const CityMaster = {
    cities: [
        {
            "postCodeInt": 79000,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79000"
        },
        {
            "postCodeInt": 79050,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79050"
        },
        {
            "postCodeInt": 79100,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79100"
        },
        {
            "postCodeInt": 79150,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79150"
        },
        {
            "postCodeInt": 79200,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79200"
        },
        {
            "postCodeInt": 79250,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79250"
        },
        {
            "postCodeInt": 79502,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79502"
        },
        {
            "postCodeInt": 79503,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79503"
        },
        {
            "postCodeInt": 79504,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79504"
        },
        {
            "postCodeInt": 79505,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79505"
        },
        {
            "postCodeInt": 79511,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79511"
        },
        {
            "postCodeInt": 79513,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79513"
        },
        {
            "postCodeInt": 79514,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79514"
        },
        {
            "postCodeInt": 79517,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79517"
        },
        {
            "postCodeInt": 79518,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79518"
        },
        {
            "postCodeInt": 79520,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79520"
        },
        {
            "postCodeInt": 79521,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79521"
        },
        {
            "postCodeInt": 79523,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79523"
        },
        {
            "postCodeInt": 79532,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79532"
        },
        {
            "postCodeInt": 79538,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79538"
        },
        {
            "postCodeInt": 79540,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79540"
        },
        {
            "postCodeInt": 79546,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79546"
        },
        {
            "postCodeInt": 79548,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79548"
        },
        {
            "postCodeInt": 79550,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79550"
        },
        {
            "postCodeInt": 79552,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79552"
        },
        {
            "postCodeInt": 79555,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79555"
        },
        {
            "postCodeInt": 79570,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79570"
        },
        {
            "postCodeInt": 79575,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79575"
        },
        {
            "postCodeInt": 79576,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79576"
        },
        {
            "postCodeInt": 79592,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79592"
        },
        {
            "postCodeInt": 79601,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79601"
        },
        {
            "postCodeInt": 79603,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79603"
        },
        {
            "postCodeInt": 79605,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79605"
        },
        {
            "postCodeInt": 79606,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79606"
        },
        {
            "postCodeInt": 79612,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79612"
        },
        {
            "postCodeInt": 79626,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79626"
        },
        {
            "postCodeInt": 79630,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79630"
        },
        {
            "postCodeInt": 79632,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79632"
        },
        {
            "postCodeInt": 79646,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79646"
        },
        {
            "postCodeInt": 79658,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79658"
        },
        {
            "postCodeInt": 79660,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79660"
        },
        {
            "postCodeInt": 79680,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79680"
        },
        {
            "postCodeInt": 79681,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79681"
        },
        {
            "postCodeInt": 79683,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "79683"
        },
        {
            "postCodeInt": 80000,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80000"
        },
        {
            "postCodeInt": 80050,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80050"
        },
        {
            "postCodeInt": 80100,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80100"
        },
        {
            "postCodeInt": 80150,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80150"
        },
        {
            "postCodeInt": 80200,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80200"
        },
        {
            "postCodeInt": 80250,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80250"
        },
        {
            "postCodeInt": 80300,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80300"
        },
        {
            "postCodeInt": 80350,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80350"
        },
        {
            "postCodeInt": 80400,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80400"
        },
        {
            "postCodeInt": 80500,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80500"
        },
        {
            "postCodeInt": 80506,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80506"
        },
        {
            "postCodeInt": 80508,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80508"
        },
        {
            "postCodeInt": 80516,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80516"
        },
        {
            "postCodeInt": 80519,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80519"
        },
        {
            "postCodeInt": 80534,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80534"
        },
        {
            "postCodeInt": 80536,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80536"
        },
        {
            "postCodeInt": 80542,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80542"
        },
        {
            "postCodeInt": 80546,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80546"
        },
        {
            "postCodeInt": 80558,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80558"
        },
        {
            "postCodeInt": 80560,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80560"
        },
        {
            "postCodeInt": 80564,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80564"
        },
        {
            "postCodeInt": 80568,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80568"
        },
        {
            "postCodeInt": 80578,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80578"
        },
        {
            "postCodeInt": 80584,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80584"
        },
        {
            "postCodeInt": 80586,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80586"
        },
        {
            "postCodeInt": 80590,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80590"
        },
        {
            "postCodeInt": 80592,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80592"
        },
        {
            "postCodeInt": 80594,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80594"
        },
        {
            "postCodeInt": 80596,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80596"
        },
        {
            "postCodeInt": 80600,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80600"
        },
        {
            "postCodeInt": 80604,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80604"
        },
        {
            "postCodeInt": 80608,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80608"
        },
        {
            "postCodeInt": 80620,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80620"
        },
        {
            "postCodeInt": 80622,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80622"
        },
        {
            "postCodeInt": 80628,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80628"
        },
        {
            "postCodeInt": 80644,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80644"
        },
        {
            "postCodeInt": 80648,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80648"
        },
        {
            "postCodeInt": 80662,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80662"
        },
        {
            "postCodeInt": 80664,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80664"
        },
        {
            "postCodeInt": 80668,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80668"
        },
        {
            "postCodeInt": 80670,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80670"
        },
        {
            "postCodeInt": 80672,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80672"
        },
        {
            "postCodeInt": 80673,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80673"
        },
        {
            "postCodeInt": 80676,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80676"
        },
        {
            "postCodeInt": 80700,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80700"
        },
        {
            "postCodeInt": 80710,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80710"
        },
        {
            "postCodeInt": 80720,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80720"
        },
        {
            "postCodeInt": 80730,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80730"
        },
        {
            "postCodeInt": 80900,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80900"
        },
        {
            "postCodeInt": 80902,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80902"
        },
        {
            "postCodeInt": 80904,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80904"
        },
        {
            "postCodeInt": 80906,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80906"
        },
        {
            "postCodeInt": 80908,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80908"
        },
        {
            "postCodeInt": 80988,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80988"
        },
        {
            "postCodeInt": 80990,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "80990"
        },
        {
            "postCodeInt": 81000,
            "cityName": "KULAI",
            "stateCode": "01",
            "postCode": "81000"
        },
        {
            "postCodeInt": 81100,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "81100"
        },
        {
            "postCodeInt": 81200,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "81200"
        },
        {
            "postCodeInt": 81300,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "81300"
        },
        {
            "postCodeInt": 81310,
            "cityName": "JOHOR BAHRU",
            "stateCode": "01",
            "postCode": "81310"
        },
        {
            "postCodeInt": 81400,
            "cityName": "SENAI",
            "stateCode": "01",
            "postCode": "81400"
        },
        {
            "postCodeInt": 81440,
            "cityName": "BANDAR TENGGARA",
            "stateCode": "01",
            "postCode": "81440"
        },
        {
            "postCodeInt": 81450,
            "cityName": "GUGUSAN TAIB ANDAK",
            "stateCode": "01",
            "postCode": "81450"
        },
        {
            "postCodeInt": 81500,
            "cityName": "PEKAN NENAS",
            "stateCode": "01",
            "postCode": "81500"
        },
        {
            "postCodeInt": 81550,
            "cityName": "GELANG PATAH",
            "stateCode": "01",
            "postCode": "81550"
        },
        {
            "postCodeInt": 81560,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "81560"
        },
        {
            "postCodeInt": 81600,
            "cityName": "PENGERANG",
            "stateCode": "01",
            "postCode": "81600"
        },
        {
            "postCodeInt": 81700,
            "cityName": "PASIR GUDANG",
            "stateCode": "01",
            "postCode": "81700"
        },
        {
            "postCodeInt": 81750,
            "cityName": "MASAI",
            "stateCode": "01",
            "postCode": "81750"
        },
        {
            "postCodeInt": 81800,
            "cityName": "ULU TIRAM",
            "stateCode": "01",
            "postCode": "81800"
        },
        {
            "postCodeInt": 81850,
            "cityName": "LAYANG-LAYANG",
            "stateCode": "01",
            "postCode": "81850"
        },
        {
            "postCodeInt": 81900,
            "cityName": "KOTA TINGGI",
            "stateCode": "01",
            "postCode": "81900"
        },
        {
            "postCodeInt": 81920,
            "cityName": "AYER TAWAR 2",
            "stateCode": "01",
            "postCode": "81920"
        },
        {
            "postCodeInt": 81930,
            "cityName": "BANDAR PENAWAR",
            "stateCode": "01",
            "postCode": "81930"
        },
        {
            "postCodeInt": 82000,
            "cityName": "PONTIAN",
            "stateCode": "01",
            "postCode": "82000"
        },
        {
            "postCodeInt": 82100,
            "cityName": "AYER BALOI",
            "stateCode": "01",
            "postCode": "82100"
        },
        {
            "postCodeInt": 82200,
            "cityName": "BENUT",
            "stateCode": "01",
            "postCode": "82200"
        },
        {
            "postCodeInt": 82300,
            "cityName": "KUKUP",
            "stateCode": "01",
            "postCode": "82300"
        },
        {
            "postCodeInt": 83000,
            "cityName": "BATU PAHAT",
            "stateCode": "01",
            "postCode": "83000"
        },
        {
            "postCodeInt": 83100,
            "cityName": "RENGIT",
            "stateCode": "01",
            "postCode": "83100"
        },
        {
            "postCodeInt": 83200,
            "cityName": "SENGGARANG",
            "stateCode": "01",
            "postCode": "83200"
        },
        {
            "postCodeInt": 83300,
            "cityName": "SERI GADING",
            "stateCode": "01",
            "postCode": "83300"
        },
        {
            "postCodeInt": 83400,
            "cityName": "SERI MEDAN",
            "stateCode": "01",
            "postCode": "83400"
        },
        {
            "postCodeInt": 83500,
            "cityName": "PARIT SULONG",
            "stateCode": "01",
            "postCode": "83500"
        },
        {
            "postCodeInt": 83600,
            "cityName": "SEMERAH",
            "stateCode": "01",
            "postCode": "83600"
        },
        {
            "postCodeInt": 83700,
            "cityName": "YONG PENG",
            "stateCode": "01",
            "postCode": "83700"
        },
        {
            "postCodeInt": 84000,
            "cityName": "MUAR",
            "stateCode": "01",
            "postCode": "84000"
        },
        {
            "postCodeInt": 84100,
            "cityName": "MUAR",
            "stateCode": "01",
            "postCode": "84100"
        },
        {
            "postCodeInt": 84150,
            "cityName": "PARIT JAWA",
            "stateCode": "01",
            "postCode": "84150"
        },
        {
            "postCodeInt": 84200,
            "cityName": "MUAR",
            "stateCode": "01",
            "postCode": "84200"
        },
        {
            "postCodeInt": 84300,
            "cityName": "BUKIT PASIR",
            "stateCode": "01",
            "postCode": "84300"
        },
        {
            "postCodeInt": 84400,
            "cityName": "SUNGAI MATI",
            "stateCode": "01",
            "postCode": "84400"
        },
        {
            "postCodeInt": 84500,
            "cityName": "PANCHOR",
            "stateCode": "01",
            "postCode": "84500"
        },
        {
            "postCodeInt": 84600,
            "cityName": "PAGOH",
            "stateCode": "01",
            "postCode": "84600"
        },
        {
            "postCodeInt": 84700,
            "cityName": "GERISEK",
            "stateCode": "01",
            "postCode": "84700"
        },
        {
            "postCodeInt": 84800,
            "cityName": "BUKIT GAMBIR",
            "stateCode": "01",
            "postCode": "84800"
        },
        {
            "postCodeInt": 84900,
            "cityName": "TANGKAK",
            "stateCode": "01",
            "postCode": "84900"
        },
        {
            "postCodeInt": 85000,
            "cityName": "SEGAMAT",
            "stateCode": "01",
            "postCode": "85000"
        },
        {
            "postCodeInt": 85100,
            "cityName": "BATU ANAM",
            "stateCode": "01",
            "postCode": "85100"
        },
        {
            "postCodeInt": 85200,
            "cityName": "JEMENTAH",
            "stateCode": "01",
            "postCode": "85200"
        },
        {
            "postCodeInt": 85300,
            "cityName": "LABIS",
            "stateCode": "01",
            "postCode": "85300"
        },
        {
            "postCodeInt": 85400,
            "cityName": "CHAAH",
            "stateCode": "01",
            "postCode": "85400"
        },
        {
            "postCodeInt": 86000,
            "cityName": "KLUANG",
            "stateCode": "01",
            "postCode": "86000"
        },
        {
            "postCodeInt": 86100,
            "cityName": "AYER HITAM",
            "stateCode": "01",
            "postCode": "86100"
        },
        {
            "postCodeInt": 86200,
            "cityName": "SIMPANG RENGAM",
            "stateCode": "01",
            "postCode": "86200"
        },
        {
            "postCodeInt": 86300,
            "cityName": "RENGAM",
            "stateCode": "01",
            "postCode": "86300"
        },
        {
            "postCodeInt": 86400,
            "cityName": "PARIT RAJA",
            "stateCode": "01",
            "postCode": "86400"
        },
        {
            "postCodeInt": 86500,
            "cityName": "BEKOK",
            "stateCode": "01",
            "postCode": "86500"
        },
        {
            "postCodeInt": 86600,
            "cityName": "PALOH",
            "stateCode": "01",
            "postCode": "86600"
        },
        {
            "postCodeInt": 86700,
            "cityName": "KAHANG",
            "stateCode": "01",
            "postCode": "86700"
        },
        {
            "postCodeInt": 86800,
            "cityName": "MERSING",
            "stateCode": "01",
            "postCode": "86800"
        },
        {
            "postCodeInt": 86810,
            "cityName": "MERSING",
            "stateCode": "01",
            "postCode": "86810"
        },
        {
            "postCodeInt": 86888,
            "cityName": "MERSING",
            "stateCode": "01",
            "postCode": "86888"
        },
        {
            "postCodeInt": 86900,
            "cityName": "ENDAU",
            "stateCode": "01",
            "postCode": "86900"
        },
        {
            "postCodeInt": 76548,
            "cityName": "NUSAJAYA",
            "stateCode": "01",
            "postCode": "76548"
        },
        {
            "postCodeInt": 14290,
            "cityName": "BANDAR BAHARU",
            "stateCode": "02",
            "postCode": "14290"
        },
        {
            "postCodeInt": 34950,
            "cityName": "BANDAR BAHARU",
            "stateCode": "02",
            "postCode": "34950"
        },
        {
            "postCodeInt": 14390,
            "cityName": "BANDAR BAHARU",
            "stateCode": "02",
            "postCode": "14390"
        },
        {
            "postCodeInt": "05000",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05000"
        },
        {
            "postCodeInt": "05050",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05050"
        },
        {
            "postCodeInt": "05100",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05100"
        },
        {
            "postCodeInt": "05150",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05150"
        },
        {
            "postCodeInt": "05200",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05200"
        },
        {
            "postCodeInt": "05250",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05250"
        },
        {
            "postCodeInt": "05300",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05300"
        },
        {
            "postCodeInt": "05350",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05350"
        },
        {
            "postCodeInt": "05400",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05400"
        },
        {
            "postCodeInt": "05460",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05460"
        },
        {
            "postCodeInt": "05500",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05500"
        },
        {
            "postCodeInt": "05502",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05502"
        },
        {
            "postCodeInt": "05503",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05503"
        },
        {
            "postCodeInt": "05504",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05504"
        },
        {
            "postCodeInt": "05505",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05505"
        },
        {
            "postCodeInt": "05506",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05506"
        },
        {
            "postCodeInt": "05508",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05508"
        },
        {
            "postCodeInt": "05512",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05512"
        },
        {
            "postCodeInt": "05514",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05514"
        },
        {
            "postCodeInt": "05516",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05516"
        },
        {
            "postCodeInt": "05517",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05517"
        },
        {
            "postCodeInt": "05518",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05518"
        },
        {
            "postCodeInt": "05520",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05520"
        },
        {
            "postCodeInt": "05532",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05532"
        },
        {
            "postCodeInt": "05534",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05534"
        },
        {
            "postCodeInt": "05536",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05536"
        },
        {
            "postCodeInt": "05538",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05538"
        },
        {
            "postCodeInt": "05550",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05550"
        },
        {
            "postCodeInt": "05551",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05551"
        },
        {
            "postCodeInt": "05552",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05552"
        },
        {
            "postCodeInt": "05556",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05556"
        },
        {
            "postCodeInt": "05558",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05558"
        },
        {
            "postCodeInt": "05560",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05560"
        },
        {
            "postCodeInt": "05564",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05564"
        },
        {
            "postCodeInt": "05576",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05576"
        },
        {
            "postCodeInt": "05578",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05578"
        },
        {
            "postCodeInt": "05580",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05580"
        },
        {
            "postCodeInt": "05582",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05582"
        },
        {
            "postCodeInt": "05586",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05586"
        },
        {
            "postCodeInt": "05590",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05590"
        },
        {
            "postCodeInt": "05592",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05592"
        },
        {
            "postCodeInt": "05594",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05594"
        },
        {
            "postCodeInt": "05596",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05596"
        },
        {
            "postCodeInt": "05600",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05600"
        },
        {
            "postCodeInt": "05604",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05604"
        },
        {
            "postCodeInt": "05610",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05610"
        },
        {
            "postCodeInt": "05612",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05612"
        },
        {
            "postCodeInt": "05614",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05614"
        },
        {
            "postCodeInt": "05620",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05620"
        },
        {
            "postCodeInt": "05621",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05621"
        },
        {
            "postCodeInt": "05622",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05622"
        },
        {
            "postCodeInt": "05626",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05626"
        },
        {
            "postCodeInt": "05628",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05628"
        },
        {
            "postCodeInt": "05630",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05630"
        },
        {
            "postCodeInt": "05632",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05632"
        },
        {
            "postCodeInt": "05644",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05644"
        },
        {
            "postCodeInt": "05660",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05660"
        },
        {
            "postCodeInt": "05661",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05661"
        },
        {
            "postCodeInt": "05664",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05664"
        },
        {
            "postCodeInt": "05670",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05670"
        },
        {
            "postCodeInt": "05672",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05672"
        },
        {
            "postCodeInt": "05673",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05673"
        },
        {
            "postCodeInt": "05674",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05674"
        },
        {
            "postCodeInt": "05675",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05675"
        },
        {
            "postCodeInt": "05676",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05676"
        },
        {
            "postCodeInt": "05680",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05680"
        },
        {
            "postCodeInt": "05690",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05690"
        },
        {
            "postCodeInt": "05696",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05696"
        },
        {
            "postCodeInt": "05700",
            "cityName": "ALOR SETAR",
            "stateCode": "02",
            "postCode": "05700"
        },
        {
            "postCodeInt": "05710",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05710"
        },
        {
            "postCodeInt": "05720",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05720"
        },
        {
            "postCodeInt": "05990",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "05990"
        },
        {
            "postCodeInt": "06000",
            "cityName": "JITRA",
            "stateCode": "02",
            "postCode": "06000"
        },
        {
            "postCodeInt": "06007",
            "cityName": "JITRA",
            "stateCode": "02",
            "postCode": "06007"
        },
        {
            "postCodeInt": "06009",
            "cityName": "JITRA",
            "stateCode": "02",
            "postCode": "06009"
        },
        {
            "postCodeInt": "06010",
            "cityName": "SINTOK",
            "stateCode": "02",
            "postCode": "06010"
        },
        {
            "postCodeInt": "06050",
            "cityName": "BUKIT KAYU HITAM",
            "stateCode": "02",
            "postCode": "06050"
        },
        {
            "postCodeInt": "06100",
            "cityName": "KODIANG",
            "stateCode": "02",
            "postCode": "06100"
        },
        {
            "postCodeInt": "06150",
            "cityName": "AYER HITAM",
            "stateCode": "02",
            "postCode": "06150"
        },
        {
            "postCodeInt": "06200",
            "cityName": "KEPALA BATAS",
            "stateCode": "02",
            "postCode": "06200"
        },
        {
            "postCodeInt": "06207",
            "cityName": "KEPALA BATAS",
            "stateCode": "02",
            "postCode": "06207"
        },
        {
            "postCodeInt": "06209",
            "cityName": "KEPALA BATAS",
            "stateCode": "02",
            "postCode": "06209"
        },
        {
            "postCodeInt": "06250",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "06250"
        },
        {
            "postCodeInt": "06300",
            "cityName": "KUALA NERANG",
            "stateCode": "02",
            "postCode": "06300"
        },
        {
            "postCodeInt": "06350",
            "cityName": "POKOK SENA",
            "stateCode": "02",
            "postCode": "06350"
        },
        {
            "postCodeInt": "06400",
            "cityName": "POKOK SENA",
            "stateCode": "02",
            "postCode": "06400"
        },
        {
            "postCodeInt": "06500",
            "cityName": "LANGGAR",
            "stateCode": "02",
            "postCode": "06500"
        },
        {
            "postCodeInt": "06501",
            "cityName": "LANGGAR",
            "stateCode": "02",
            "postCode": "06501"
        },
        {
            "postCodeInt": "06507",
            "cityName": "LANGGAR",
            "stateCode": "02",
            "postCode": "06507"
        },
        {
            "postCodeInt": "06509",
            "cityName": "LANGGAR",
            "stateCode": "02",
            "postCode": "06509"
        },
        {
            "postCodeInt": "06550",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "06550"
        },
        {
            "postCodeInt": "06570",
            "cityName": "ALOR STAR",
            "stateCode": "02",
            "postCode": "06570"
        },
        {
            "postCodeInt": "06600",
            "cityName": "KUALA KEDAH",
            "stateCode": "02",
            "postCode": "06600"
        },
        {
            "postCodeInt": "06650",
            "cityName": "SIMPANG EMPAT",
            "stateCode": "02",
            "postCode": "06650"
        },
        {
            "postCodeInt": "06660",
            "cityName": "KUALA KEDAH",
            "stateCode": "02",
            "postCode": "06660"
        },
        {
            "postCodeInt": "06700",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06700"
        },
        {
            "postCodeInt": "06707",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06707"
        },
        {
            "postCodeInt": "06709",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06709"
        },
        {
            "postCodeInt": "06710",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06710"
        },
        {
            "postCodeInt": "06720",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06720"
        },
        {
            "postCodeInt": "06750",
            "cityName": "PENDANG",
            "stateCode": "02",
            "postCode": "06750"
        },
        {
            "postCodeInt": "06800",
            "cityName": "KOTA SARANG SEMUT",
            "stateCode": "02",
            "postCode": "06800"
        },
        {
            "postCodeInt": "06900",
            "cityName": "YAN",
            "stateCode": "02",
            "postCode": "06900"
        },
        {
            "postCodeInt": "06910",
            "cityName": "YAN",
            "stateCode": "02",
            "postCode": "06910"
        },
        {
            "postCodeInt": "07000",
            "cityName": "LANGKAWI",
            "stateCode": "02",
            "postCode": "07000"
        },
        {
            "postCodeInt": "07007",
            "cityName": "LANGKAWI",
            "stateCode": "02",
            "postCode": "07007"
        },
        {
            "postCodeInt": "07009",
            "cityName": "LANGKAWI",
            "stateCode": "02",
            "postCode": "07009"
        },
        {
            "postCodeInt": "08000",
            "cityName": "SUNGAI PETANI",
            "stateCode": "02",
            "postCode": "08000"
        },
        {
            "postCodeInt": "08007",
            "cityName": "SUNGAI PETANI",
            "stateCode": "02",
            "postCode": "08007"
        },
        {
            "postCodeInt": "08009",
            "cityName": "SUNGAI PETANI",
            "stateCode": "02",
            "postCode": "08009"
        },
        {
            "postCodeInt": "08010",
            "cityName": "SUNGAI PETANI",
            "stateCode": "02",
            "postCode": "08010"
        },
        {
            "postCodeInt": "08100",
            "cityName": "BEDONG",
            "stateCode": "02",
            "postCode": "08100"
        },
        {
            "postCodeInt": "08110",
            "cityName": "BEDONG",
            "stateCode": "02",
            "postCode": "08110"
        },
        {
            "postCodeInt": "08200",
            "cityName": "SIK",
            "stateCode": "02",
            "postCode": "08200"
        },
        {
            "postCodeInt": "08210",
            "cityName": "SIK",
            "stateCode": "02",
            "postCode": "08210"
        },
        {
            "postCodeInt": "08300",
            "cityName": "GURUN",
            "stateCode": "02",
            "postCode": "08300"
        },
        {
            "postCodeInt": "08320",
            "cityName": "JENIANG",
            "stateCode": "02",
            "postCode": "08320"
        },
        {
            "postCodeInt": "08330",
            "cityName": "GURUN",
            "stateCode": "02",
            "postCode": "08330"
        },
        {
            "postCodeInt": "08340",
            "cityName": "SIK",
            "stateCode": "02",
            "postCode": "08340"
        },
        {
            "postCodeInt": "08400",
            "cityName": "MERBOK",
            "stateCode": "02",
            "postCode": "08400"
        },
        {
            "postCodeInt": "08407",
            "cityName": "MERBOK",
            "stateCode": "02",
            "postCode": "08407"
        },
        {
            "postCodeInt": "08409",
            "cityName": "MERBOK",
            "stateCode": "02",
            "postCode": "08409"
        },
        {
            "postCodeInt": "08500",
            "cityName": "KOTA KUALA MUDA",
            "stateCode": "02",
            "postCode": "08500"
        },
        {
            "postCodeInt": "08507",
            "cityName": "KOTA KUALA MUDA",
            "stateCode": "02",
            "postCode": "08507"
        },
        {
            "postCodeInt": "08509",
            "cityName": "KOTA KUALA MUDA",
            "stateCode": "02",
            "postCode": "08509"
        },
        {
            "postCodeInt": "08600",
            "cityName": "SUNGAI PETANI",
            "stateCode": "02",
            "postCode": "08600"
        },
        {
            "postCodeInt": "08700",
            "cityName": "JENIANG",
            "stateCode": "02",
            "postCode": "08700"
        },
        {
            "postCodeInt": "08800",
            "cityName": "GURUN",
            "stateCode": "02",
            "postCode": "08800"
        },
        {
            "postCodeInt": "09000",
            "cityName": "KULIM",
            "stateCode": "02",
            "postCode": "09000"
        },
        {
            "postCodeInt": "09007",
            "cityName": "KULIM",
            "stateCode": "02",
            "postCode": "09007"
        },
        {
            "postCodeInt": "09009",
            "cityName": "KULIM",
            "stateCode": "02",
            "postCode": "09009"
        },
        {
            "postCodeInt": "09010",
            "cityName": "KULIM",
            "stateCode": "02",
            "postCode": "09010"
        },
        {
            "postCodeInt": "09020",
            "cityName": "KULIM",
            "stateCode": "02",
            "postCode": "09020"
        },
        {
            "postCodeInt": "09100",
            "cityName": "BALING",
            "stateCode": "02",
            "postCode": "09100"
        },
        {
            "postCodeInt": "09110",
            "cityName": "KUALA PEGANG",
            "stateCode": "02",
            "postCode": "09110"
        },
        {
            "postCodeInt": "09200",
            "cityName": "KUPANG",
            "stateCode": "02",
            "postCode": "09200"
        },
        {
            "postCodeInt": "09300",
            "cityName": "KUALA KETIL",
            "stateCode": "02",
            "postCode": "09300"
        },
        {
            "postCodeInt": "09310",
            "cityName": "KUALA KETIL",
            "stateCode": "02",
            "postCode": "09310"
        },
        {
            "postCodeInt": "09400",
            "cityName": "PADANG SERAI",
            "stateCode": "02",
            "postCode": "09400"
        },
        {
            "postCodeInt": "09410",
            "cityName": "PADANG SERAI",
            "stateCode": "02",
            "postCode": "09410"
        },
        {
            "postCodeInt": "09600",
            "cityName": "LUNAS",
            "stateCode": "02",
            "postCode": "09600"
        },
        {
            "postCodeInt": "09700",
            "cityName": "KARANGAN",
            "stateCode": "02",
            "postCode": "09700"
        },
        {
            "postCodeInt": "09800",
            "cityName": "SERDANG",
            "stateCode": "02",
            "postCode": "09800"
        },
        {
            "postCodeInt": "09810",
            "cityName": "SERDANG",
            "stateCode": "02",
            "postCode": "09810"
        },
        {
            "postCodeInt": 15000,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15000"
        },
        {
            "postCodeInt": 15050,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15050"
        },
        {
            "postCodeInt": 15100,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15100"
        },
        {
            "postCodeInt": 15150,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15150"
        },
        {
            "postCodeInt": 15159,
            "cityName": "KUBANG KERIAN",
            "stateCode": "03",
            "postCode": "15159"
        },
        {
            "postCodeInt": 15200,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15200"
        },
        {
            "postCodeInt": 15300,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15300"
        },
        {
            "postCodeInt": 15350,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15350"
        },
        {
            "postCodeInt": 15400,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15400"
        },
        {
            "postCodeInt": 15500,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15500"
        },
        {
            "postCodeInt": 15502,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15502"
        },
        {
            "postCodeInt": 15503,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15503"
        },
        {
            "postCodeInt": 15504,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15504"
        },
        {
            "postCodeInt": 15505,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15505"
        },
        {
            "postCodeInt": 15506,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15506"
        },
        {
            "postCodeInt": 15508,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15508"
        },
        {
            "postCodeInt": 15512,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15512"
        },
        {
            "postCodeInt": 15514,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15514"
        },
        {
            "postCodeInt": 15516,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15516"
        },
        {
            "postCodeInt": 15517,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15517"
        },
        {
            "postCodeInt": 15518,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15518"
        },
        {
            "postCodeInt": 15519,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15519"
        },
        {
            "postCodeInt": 15520,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15520"
        },
        {
            "postCodeInt": 15524,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15524"
        },
        {
            "postCodeInt": 15529,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15529"
        },
        {
            "postCodeInt": 15532,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15532"
        },
        {
            "postCodeInt": 15534,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15534"
        },
        {
            "postCodeInt": 15536,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15536"
        },
        {
            "postCodeInt": 15538,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15538"
        },
        {
            "postCodeInt": 15540,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15540"
        },
        {
            "postCodeInt": 15546,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15546"
        },
        {
            "postCodeInt": 15548,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15548"
        },
        {
            "postCodeInt": 15550,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15550"
        },
        {
            "postCodeInt": 15551,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15551"
        },
        {
            "postCodeInt": 15556,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15556"
        },
        {
            "postCodeInt": 15558,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15558"
        },
        {
            "postCodeInt": 15560,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15560"
        },
        {
            "postCodeInt": 15564,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15564"
        },
        {
            "postCodeInt": 15570,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15570"
        },
        {
            "postCodeInt": 15572,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15572"
        },
        {
            "postCodeInt": 15576,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15576"
        },
        {
            "postCodeInt": 15578,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15578"
        },
        {
            "postCodeInt": 15582,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15582"
        },
        {
            "postCodeInt": 15586,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15586"
        },
        {
            "postCodeInt": 15590,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15590"
        },
        {
            "postCodeInt": 15592,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15592"
        },
        {
            "postCodeInt": 15594,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15594"
        },
        {
            "postCodeInt": 15596,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15596"
        },
        {
            "postCodeInt": 15600,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15600"
        },
        {
            "postCodeInt": 15604,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15604"
        },
        {
            "postCodeInt": 15606,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15606"
        },
        {
            "postCodeInt": 15608,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15608"
        },
        {
            "postCodeInt": 15609,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15609"
        },
        {
            "postCodeInt": 15610,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15610"
        },
        {
            "postCodeInt": 15612,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15612"
        },
        {
            "postCodeInt": 15614,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15614"
        },
        {
            "postCodeInt": 15616,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15616"
        },
        {
            "postCodeInt": 15620,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15620"
        },
        {
            "postCodeInt": 15622,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15622"
        },
        {
            "postCodeInt": 15623,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15623"
        },
        {
            "postCodeInt": 15624,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15624"
        },
        {
            "postCodeInt": 15626,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15626"
        },
        {
            "postCodeInt": 15628,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15628"
        },
        {
            "postCodeInt": 15630,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15630"
        },
        {
            "postCodeInt": 15632,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15632"
        },
        {
            "postCodeInt": 15634,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15634"
        },
        {
            "postCodeInt": 15644,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15644"
        },
        {
            "postCodeInt": 15646,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15646"
        },
        {
            "postCodeInt": 15648,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15648"
        },
        {
            "postCodeInt": 15658,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15658"
        },
        {
            "postCodeInt": 15660,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15660"
        },
        {
            "postCodeInt": 15661,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15661"
        },
        {
            "postCodeInt": 15662,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15662"
        },
        {
            "postCodeInt": 15664,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15664"
        },
        {
            "postCodeInt": 15670,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15670"
        },
        {
            "postCodeInt": 15672,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15672"
        },
        {
            "postCodeInt": 15673,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15673"
        },
        {
            "postCodeInt": 15674,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15674"
        },
        {
            "postCodeInt": 15676,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15676"
        },
        {
            "postCodeInt": 15680,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15680"
        },
        {
            "postCodeInt": 15690,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15690"
        },
        {
            "postCodeInt": 15700,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15700"
        },
        {
            "postCodeInt": 15710,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15710"
        },
        {
            "postCodeInt": 15720,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15720"
        },
        {
            "postCodeInt": 15730,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15730"
        },
        {
            "postCodeInt": 15740,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15740"
        },
        {
            "postCodeInt": 15988,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15988"
        },
        {
            "postCodeInt": 15990,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "15990"
        },
        {
            "postCodeInt": 16010,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16010"
        },
        {
            "postCodeInt": 16020,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16020"
        },
        {
            "postCodeInt": 16030,
            "cityName": "BUKIT MARAK",
            "stateCode": "03",
            "postCode": "16030"
        },
        {
            "postCodeInt": 16040,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16040"
        },
        {
            "postCodeInt": 16050,
            "cityName": "BACHOK",
            "stateCode": "03",
            "postCode": "16050"
        },
        {
            "postCodeInt": 16060,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16060"
        },
        {
            "postCodeInt": 16070,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16070"
        },
        {
            "postCodeInt": 16080,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16080"
        },
        {
            "postCodeInt": 16090,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16090"
        },
        {
            "postCodeInt": 16100,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16100"
        },
        {
            "postCodeInt": 16109,
            "cityName": "PENGKALAN CHEPA",
            "stateCode": "03",
            "postCode": "16109"
        },
        {
            "postCodeInt": 16150,
            "cityName": "KOTA BHARU",
            "stateCode": "03",
            "postCode": "16150"
        },
        {
            "postCodeInt": 16200,
            "cityName": "TUMPAT",
            "stateCode": "03",
            "postCode": "16200"
        },
        {
            "postCodeInt": 16210,
            "cityName": "TUMPAT",
            "stateCode": "03",
            "postCode": "16210"
        },
        {
            "postCodeInt": 16250,
            "cityName": "WAKAF BHARU",
            "stateCode": "03",
            "postCode": "16250"
        },
        {
            "postCodeInt": 16300,
            "cityName": "BACHOK",
            "stateCode": "03",
            "postCode": "16300"
        },
        {
            "postCodeInt": 16310,
            "cityName": "BACHOK",
            "stateCode": "03",
            "postCode": "16310"
        },
        {
            "postCodeInt": 16320,
            "cityName": "BACHOK",
            "stateCode": "03",
            "postCode": "16320"
        },
        {
            "postCodeInt": 16400,
            "cityName": "MELOR",
            "stateCode": "03",
            "postCode": "16400"
        },
        {
            "postCodeInt": 16410,
            "cityName": "MELOR",
            "stateCode": "03",
            "postCode": "16410"
        },
        {
            "postCodeInt": 16450,
            "cityName": "KETEREH",
            "stateCode": "03",
            "postCode": "16450"
        },
        {
            "postCodeInt": 16500,
            "cityName": "KEM DESA PAHLAWAN",
            "stateCode": "03",
            "postCode": "16500"
        },
        {
            "postCodeInt": 16600,
            "cityName": "PULAI CHONDONG",
            "stateCode": "03",
            "postCode": "16600"
        },
        {
            "postCodeInt": 16700,
            "cityName": "CHERANG RUKU",
            "stateCode": "03",
            "postCode": "16700"
        },
        {
            "postCodeInt": 16800,
            "cityName": "PASIR PUTEH",
            "stateCode": "03",
            "postCode": "16800"
        },
        {
            "postCodeInt": 16810,
            "cityName": "SELISING",
            "stateCode": "03",
            "postCode": "16810"
        },
        {
            "postCodeInt": 17000,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17000"
        },
        {
            "postCodeInt": 17007,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17007"
        },
        {
            "postCodeInt": 17009,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17009"
        },
        {
            "postCodeInt": 17010,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17010"
        },
        {
            "postCodeInt": 17020,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17020"
        },
        {
            "postCodeInt": 17030,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17030"
        },
        {
            "postCodeInt": 17040,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17040"
        },
        {
            "postCodeInt": 17050,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17050"
        },
        {
            "postCodeInt": 17060,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17060"
        },
        {
            "postCodeInt": 17070,
            "cityName": "PASIR MAS",
            "stateCode": "03",
            "postCode": "17070"
        },
        {
            "postCodeInt": 17200,
            "cityName": "RANTAU PANJANG",
            "stateCode": "03",
            "postCode": "17200"
        },
        {
            "postCodeInt": 17500,
            "cityName": "TANAH MERAH",
            "stateCode": "03",
            "postCode": "17500"
        },
        {
            "postCodeInt": 17507,
            "cityName": "TANAH MERAH",
            "stateCode": "03",
            "postCode": "17507"
        },
        {
            "postCodeInt": 17509,
            "cityName": "TANAH MERAH",
            "stateCode": "03",
            "postCode": "17509"
        },
        {
            "postCodeInt": 17510,
            "cityName": "TANAH MERAH",
            "stateCode": "03",
            "postCode": "17510"
        },
        {
            "postCodeInt": 17520,
            "cityName": "BATU MELINTANG",
            "stateCode": "03",
            "postCode": "17520"
        },
        {
            "postCodeInt": 17600,
            "cityName": "JELI",
            "stateCode": "03",
            "postCode": "17600"
        },
        {
            "postCodeInt": 17610,
            "cityName": "KUALA BALAH",
            "stateCode": "03",
            "postCode": "17610"
        },
        {
            "postCodeInt": 17700,
            "cityName": "AYER LANAS",
            "stateCode": "03",
            "postCode": "17700"
        },
        {
            "postCodeInt": 18000,
            "cityName": "KUALA KRAI",
            "stateCode": "03",
            "postCode": "18000"
        },
        {
            "postCodeInt": 18010,
            "cityName": "BERTAM",
            "stateCode": "03",
            "postCode": "18010"
        },
        {
            "postCodeInt": 18020,
            "cityName": "KUALA KRAI",
            "stateCode": "03",
            "postCode": "18020"
        },
        {
            "postCodeInt": 18050,
            "cityName": "KUALA KRAI",
            "stateCode": "03",
            "postCode": "18050"
        },
        {
            "postCodeInt": 18200,
            "cityName": "DABONG",
            "stateCode": "03",
            "postCode": "18200"
        },
        {
            "postCodeInt": 18300,
            "cityName": "GUA MUSANG",
            "stateCode": "03",
            "postCode": "18300"
        },
        {
            "postCodeInt": 18400,
            "cityName": "TEMANGAN",
            "stateCode": "03",
            "postCode": "18400"
        },
        {
            "postCodeInt": 18500,
            "cityName": "MACHANG",
            "stateCode": "03",
            "postCode": "18500"
        },
        {
            "postCodeInt": 75000,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75000"
        },
        {
            "postCodeInt": 75050,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75050"
        },
        {
            "postCodeInt": 75100,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75100"
        },
        {
            "postCodeInt": 75150,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75150"
        },
        {
            "postCodeInt": 75200,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75200"
        },
        {
            "postCodeInt": 75250,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75250"
        },
        {
            "postCodeInt": 75260,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75260"
        },
        {
            "postCodeInt": 75300,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75300"
        },
        {
            "postCodeInt": 75350,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75350"
        },
        {
            "postCodeInt": 75400,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75400"
        },
        {
            "postCodeInt": 75450,
            "cityName": "AIR KEROH",
            "stateCode": "04",
            "postCode": "75450"
        },
        {
            "postCodeInt": 75460,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75460"
        },
        {
            "postCodeInt": 75500,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75500"
        },
        {
            "postCodeInt": 75502,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75502"
        },
        {
            "postCodeInt": 75503,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75503"
        },
        {
            "postCodeInt": 75504,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75504"
        },
        {
            "postCodeInt": 75505,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75505"
        },
        {
            "postCodeInt": 75506,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75506"
        },
        {
            "postCodeInt": 75508,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75508"
        },
        {
            "postCodeInt": 75510,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75510"
        },
        {
            "postCodeInt": 75512,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75512"
        },
        {
            "postCodeInt": 75514,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75514"
        },
        {
            "postCodeInt": 75516,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75516"
        },
        {
            "postCodeInt": 75517,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75517"
        },
        {
            "postCodeInt": 75518,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75518"
        },
        {
            "postCodeInt": 75519,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75519"
        },
        {
            "postCodeInt": 75532,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75532"
        },
        {
            "postCodeInt": 75536,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75536"
        },
        {
            "postCodeInt": 75538,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75538"
        },
        {
            "postCodeInt": 75540,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75540"
        },
        {
            "postCodeInt": 75542,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75542"
        },
        {
            "postCodeInt": 75546,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75546"
        },
        {
            "postCodeInt": 75550,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75550"
        },
        {
            "postCodeInt": 75551,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75551"
        },
        {
            "postCodeInt": 75552,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75552"
        },
        {
            "postCodeInt": 75560,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75560"
        },
        {
            "postCodeInt": 75564,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75564"
        },
        {
            "postCodeInt": 75566,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75566"
        },
        {
            "postCodeInt": 75570,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75570"
        },
        {
            "postCodeInt": 75572,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75572"
        },
        {
            "postCodeInt": 75576,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75576"
        },
        {
            "postCodeInt": 75578,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75578"
        },
        {
            "postCodeInt": 75582,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75582"
        },
        {
            "postCodeInt": 75584,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75584"
        },
        {
            "postCodeInt": 75586,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75586"
        },
        {
            "postCodeInt": 75590,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75590"
        },
        {
            "postCodeInt": 75592,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75592"
        },
        {
            "postCodeInt": 75594,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75594"
        },
        {
            "postCodeInt": 75596,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75596"
        },
        {
            "postCodeInt": 75600,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75600"
        },
        {
            "postCodeInt": 75604,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75604"
        },
        {
            "postCodeInt": 75606,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75606"
        },
        {
            "postCodeInt": 75608,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75608"
        },
        {
            "postCodeInt": 75609,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75609"
        },
        {
            "postCodeInt": 75610,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75610"
        },
        {
            "postCodeInt": 75612,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75612"
        },
        {
            "postCodeInt": 75618,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75618"
        },
        {
            "postCodeInt": 75620,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75620"
        },
        {
            "postCodeInt": 75622,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75622"
        },
        {
            "postCodeInt": 75626,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75626"
        },
        {
            "postCodeInt": 75628,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75628"
        },
        {
            "postCodeInt": 75630,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75630"
        },
        {
            "postCodeInt": 75632,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75632"
        },
        {
            "postCodeInt": 75646,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75646"
        },
        {
            "postCodeInt": 75648,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75648"
        },
        {
            "postCodeInt": 75662,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75662"
        },
        {
            "postCodeInt": 75668,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75668"
        },
        {
            "postCodeInt": 75670,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75670"
        },
        {
            "postCodeInt": 75672,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75672"
        },
        {
            "postCodeInt": 75673,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75673"
        },
        {
            "postCodeInt": 75674,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75674"
        },
        {
            "postCodeInt": 75676,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75676"
        },
        {
            "postCodeInt": 75690,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75690"
        },
        {
            "postCodeInt": 75700,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75700"
        },
        {
            "postCodeInt": 75710,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75710"
        },
        {
            "postCodeInt": 75720,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75720"
        },
        {
            "postCodeInt": 75730,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75730"
        },
        {
            "postCodeInt": 75740,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75740"
        },
        {
            "postCodeInt": 75750,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75750"
        },
        {
            "postCodeInt": 75760,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75760"
        },
        {
            "postCodeInt": 75900,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75900"
        },
        {
            "postCodeInt": 75902,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75902"
        },
        {
            "postCodeInt": 75904,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75904"
        },
        {
            "postCodeInt": 75906,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75906"
        },
        {
            "postCodeInt": 75908,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75908"
        },
        {
            "postCodeInt": 75910,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75910"
        },
        {
            "postCodeInt": 75912,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75912"
        },
        {
            "postCodeInt": 75914,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75914"
        },
        {
            "postCodeInt": 75916,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75916"
        },
        {
            "postCodeInt": 75918,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75918"
        },
        {
            "postCodeInt": 75990,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "75990"
        },
        {
            "postCodeInt": 76100,
            "cityName": "DURIAN TUNGGAL",
            "stateCode": "04",
            "postCode": "76100"
        },
        {
            "postCodeInt": 76109,
            "cityName": "DURIAN TUNGGAL",
            "stateCode": "04",
            "postCode": "76109"
        },
        {
            "postCodeInt": 76200,
            "cityName": "KEM TERENDAK",
            "stateCode": "04",
            "postCode": "76200"
        },
        {
            "postCodeInt": 76300,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "76300"
        },
        {
            "postCodeInt": 76400,
            "cityName": "TANJONG KLING",
            "stateCode": "04",
            "postCode": "76400"
        },
        {
            "postCodeInt": 76409,
            "cityName": "TANJONG KLING",
            "stateCode": "04",
            "postCode": "76409"
        },
        {
            "postCodeInt": 76450,
            "cityName": "MELAKA",
            "stateCode": "04",
            "postCode": "76450"
        },
        {
            "postCodeInt": 77000,
            "cityName": "JASIN",
            "stateCode": "04",
            "postCode": "77000"
        },
        {
            "postCodeInt": 77007,
            "cityName": "JASIN",
            "stateCode": "04",
            "postCode": "77007"
        },
        {
            "postCodeInt": 77008,
            "cityName": "JASIN",
            "stateCode": "04",
            "postCode": "77008"
        },
        {
            "postCodeInt": 77009,
            "cityName": "JASIN",
            "stateCode": "04",
            "postCode": "77009"
        },
        {
            "postCodeInt": 77100,
            "cityName": "ASAHAN",
            "stateCode": "04",
            "postCode": "77100"
        },
        {
            "postCodeInt": 77109,
            "cityName": "ASAHAN",
            "stateCode": "04",
            "postCode": "77109"
        },
        {
            "postCodeInt": 77200,
            "cityName": "BEMBAN",
            "stateCode": "04",
            "postCode": "77200"
        },
        {
            "postCodeInt": 77300,
            "cityName": "MERLIMAU",
            "stateCode": "04",
            "postCode": "77300"
        },
        {
            "postCodeInt": 77309,
            "cityName": "MERLIMAU",
            "stateCode": "04",
            "postCode": "77309"
        },
        {
            "postCodeInt": 77400,
            "cityName": "SUNGAI RAMBAI",
            "stateCode": "04",
            "postCode": "77400"
        },
        {
            "postCodeInt": 77407,
            "cityName": "SUNGAI RAMBAI",
            "stateCode": "04",
            "postCode": "77407"
        },
        {
            "postCodeInt": 77409,
            "cityName": "SUNGAI RAMBAI",
            "stateCode": "04",
            "postCode": "77409"
        },
        {
            "postCodeInt": 77500,
            "cityName": "SELANDAR",
            "stateCode": "04",
            "postCode": "77500"
        },
        {
            "postCodeInt": 78000,
            "cityName": "ALOR GAJAH",
            "stateCode": "04",
            "postCode": "78000"
        },
        {
            "postCodeInt": 78009,
            "cityName": "ALOR GAJAH",
            "stateCode": "04",
            "postCode": "78009"
        },
        {
            "postCodeInt": 78100,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "78100"
        },
        {
            "postCodeInt": 78200,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "78200"
        },
        {
            "postCodeInt": 78300,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "78300"
        },
        {
            "postCodeInt": 78307,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "78307"
        },
        {
            "postCodeInt": 78309,
            "cityName": "MASJID TANAH",
            "stateCode": "04",
            "postCode": "78309"
        },
        {
            "postCodeInt": 70000,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70000"
        },
        {
            "postCodeInt": 70100,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70100"
        },
        {
            "postCodeInt": 70200,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70200"
        },
        {
            "postCodeInt": 70300,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70300"
        },
        {
            "postCodeInt": 70400,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70400"
        },
        {
            "postCodeInt": 70450,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70450"
        },
        {
            "postCodeInt": 70500,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70500"
        },
        {
            "postCodeInt": 70502,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70502"
        },
        {
            "postCodeInt": 70503,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70503"
        },
        {
            "postCodeInt": 70504,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70504"
        },
        {
            "postCodeInt": 70505,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70505"
        },
        {
            "postCodeInt": 70506,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70506"
        },
        {
            "postCodeInt": 70508,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70508"
        },
        {
            "postCodeInt": 70512,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70512"
        },
        {
            "postCodeInt": 70516,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70516"
        },
        {
            "postCodeInt": 70517,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70517"
        },
        {
            "postCodeInt": 70518,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70518"
        },
        {
            "postCodeInt": 70532,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70532"
        },
        {
            "postCodeInt": 70534,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70534"
        },
        {
            "postCodeInt": 70536,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70536"
        },
        {
            "postCodeInt": 70540,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70540"
        },
        {
            "postCodeInt": 70546,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70546"
        },
        {
            "postCodeInt": 70548,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70548"
        },
        {
            "postCodeInt": 70550,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70550"
        },
        {
            "postCodeInt": 70551,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70551"
        },
        {
            "postCodeInt": 70558,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70558"
        },
        {
            "postCodeInt": 70560,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70560"
        },
        {
            "postCodeInt": 70564,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70564"
        },
        {
            "postCodeInt": 70570,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70570"
        },
        {
            "postCodeInt": 70572,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70572"
        },
        {
            "postCodeInt": 70576,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70576"
        },
        {
            "postCodeInt": 70578,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70578"
        },
        {
            "postCodeInt": 70582,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70582"
        },
        {
            "postCodeInt": 70586,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70586"
        },
        {
            "postCodeInt": 70590,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70590"
        },
        {
            "postCodeInt": 70592,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70592"
        },
        {
            "postCodeInt": 70594,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70594"
        },
        {
            "postCodeInt": 70596,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70596"
        },
        {
            "postCodeInt": 70600,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70600"
        },
        {
            "postCodeInt": 70604,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70604"
        },
        {
            "postCodeInt": 70606,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70606"
        },
        {
            "postCodeInt": 70608,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70608"
        },
        {
            "postCodeInt": 70609,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70609"
        },
        {
            "postCodeInt": 70610,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70610"
        },
        {
            "postCodeInt": 70620,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70620"
        },
        {
            "postCodeInt": 70626,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70626"
        },
        {
            "postCodeInt": 70628,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70628"
        },
        {
            "postCodeInt": 70632,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70632"
        },
        {
            "postCodeInt": 70634,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70634"
        },
        {
            "postCodeInt": 70644,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70644"
        },
        {
            "postCodeInt": 70646,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70646"
        },
        {
            "postCodeInt": 70648,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70648"
        },
        {
            "postCodeInt": 70658,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70658"
        },
        {
            "postCodeInt": 70664,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70664"
        },
        {
            "postCodeInt": 70670,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70670"
        },
        {
            "postCodeInt": 70672,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70672"
        },
        {
            "postCodeInt": 70673,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70673"
        },
        {
            "postCodeInt": 70674,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70674"
        },
        {
            "postCodeInt": 70676,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70676"
        },
        {
            "postCodeInt": 70690,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70690"
        },
        {
            "postCodeInt": 70700,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70700"
        },
        {
            "postCodeInt": 70710,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70710"
        },
        {
            "postCodeInt": 70720,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70720"
        },
        {
            "postCodeInt": 70730,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70730"
        },
        {
            "postCodeInt": 70740,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70740"
        },
        {
            "postCodeInt": 70750,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70750"
        },
        {
            "postCodeInt": 70990,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "70990"
        },
        {
            "postCodeInt": 71000,
            "cityName": "PORT DICKSON",
            "stateCode": "05",
            "postCode": "71000"
        },
        {
            "postCodeInt": 71007,
            "cityName": "PORT DICKSON",
            "stateCode": "05",
            "postCode": "71007"
        },
        {
            "postCodeInt": 71009,
            "cityName": "PORT DICKSON",
            "stateCode": "05",
            "postCode": "71009"
        },
        {
            "postCodeInt": 71010,
            "cityName": "PORT DICKSON",
            "stateCode": "05",
            "postCode": "71010"
        },
        {
            "postCodeInt": 71050,
            "cityName": "SI RUSA",
            "stateCode": "05",
            "postCode": "71050"
        },
        {
            "postCodeInt": 71059,
            "cityName": "SRI RUSA",
            "stateCode": "05",
            "postCode": "71059"
        },
        {
            "postCodeInt": 71100,
            "cityName": "RANTAU",
            "stateCode": "05",
            "postCode": "71100"
        },
        {
            "postCodeInt": 71109,
            "cityName": "SILIAU",
            "stateCode": "05",
            "postCode": "71109"
        },
        {
            "postCodeInt": 71150,
            "cityName": "LINGGI",
            "stateCode": "05",
            "postCode": "71150"
        },
        {
            "postCodeInt": 71159,
            "cityName": "LINGGI",
            "stateCode": "05",
            "postCode": "71159"
        },
        {
            "postCodeInt": 71200,
            "cityName": "RANTAU",
            "stateCode": "05",
            "postCode": "71200"
        },
        {
            "postCodeInt": 71209,
            "cityName": "RANTAU",
            "stateCode": "05",
            "postCode": "71209"
        },
        {
            "postCodeInt": 71250,
            "cityName": "PASIR PANJANG",
            "stateCode": "05",
            "postCode": "71250"
        },
        {
            "postCodeInt": 71259,
            "cityName": "PASIR PANJANG",
            "stateCode": "05",
            "postCode": "71259"
        },
        {
            "postCodeInt": 71300,
            "cityName": "REMBAU",
            "stateCode": "05",
            "postCode": "71300"
        },
        {
            "postCodeInt": 71309,
            "cityName": "REMBAU",
            "stateCode": "05",
            "postCode": "71309"
        },
        {
            "postCodeInt": 71350,
            "cityName": "KOTA",
            "stateCode": "05",
            "postCode": "71350"
        },
        {
            "postCodeInt": 71359,
            "cityName": "KOTA",
            "stateCode": "05",
            "postCode": "71359"
        },
        {
            "postCodeInt": 71400,
            "cityName": "REMBAU",
            "stateCode": "05",
            "postCode": "71400"
        },
        {
            "postCodeInt": 71409,
            "cityName": "PEDAS",
            "stateCode": "05",
            "postCode": "71409"
        },
        {
            "postCodeInt": 71450,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "71450"
        },
        {
            "postCodeInt": 71459,
            "cityName": "SUNGAI GADUT",
            "stateCode": "05",
            "postCode": "71459"
        },
        {
            "postCodeInt": 71500,
            "cityName": "TANJONG IPOH",
            "stateCode": "05",
            "postCode": "71500"
        },
        {
            "postCodeInt": 71509,
            "cityName": "TANJUNG IPOH",
            "stateCode": "05",
            "postCode": "71509"
        },
        {
            "postCodeInt": 71550,
            "cityName": "SRI MENANTI",
            "stateCode": "05",
            "postCode": "71550"
        },
        {
            "postCodeInt": 71559,
            "cityName": "SRI MENANTI",
            "stateCode": "05",
            "postCode": "71559"
        },
        {
            "postCodeInt": 71600,
            "cityName": "KUALA KLAWANG",
            "stateCode": "05",
            "postCode": "71600"
        },
        {
            "postCodeInt": 71609,
            "cityName": "KUALA KLAWANG",
            "stateCode": "05",
            "postCode": "71609"
        },
        {
            "postCodeInt": 71650,
            "cityName": "KUALA KLAWANG",
            "stateCode": "05",
            "postCode": "71650"
        },
        {
            "postCodeInt": 71659,
            "cityName": "TITI",
            "stateCode": "05",
            "postCode": "71659"
        },
        {
            "postCodeInt": 71700,
            "cityName": "MANTIN",
            "stateCode": "05",
            "postCode": "71700"
        },
        {
            "postCodeInt": 71707,
            "cityName": "MANTIN",
            "stateCode": "05",
            "postCode": "71707"
        },
        {
            "postCodeInt": 71709,
            "cityName": "MANTIN",
            "stateCode": "05",
            "postCode": "71709"
        },
        {
            "postCodeInt": 71750,
            "cityName": "MANTIN",
            "stateCode": "05",
            "postCode": "71750"
        },
        {
            "postCodeInt": 71759,
            "cityName": "LENGGENG",
            "stateCode": "05",
            "postCode": "71759"
        },
        {
            "postCodeInt": 71760,
            "cityName": "BANDAR BARU ENSTEK",
            "stateCode": "05",
            "postCode": "71760"
        },
        {
            "postCodeInt": 71770,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "71770"
        },
        {
            "postCodeInt": 71800,
            "cityName": "NILAI",
            "stateCode": "05",
            "postCode": "71800"
        },
        {
            "postCodeInt": 71807,
            "cityName": "NILAI",
            "stateCode": "05",
            "postCode": "71807"
        },
        {
            "postCodeInt": 71809,
            "cityName": "NILAI",
            "stateCode": "05",
            "postCode": "71809"
        },
        {
            "postCodeInt": 71900,
            "cityName": "LABU",
            "stateCode": "05",
            "postCode": "71900"
        },
        {
            "postCodeInt": 71907,
            "cityName": "LABU",
            "stateCode": "05",
            "postCode": "71907"
        },
        {
            "postCodeInt": 71909,
            "cityName": "LABU",
            "stateCode": "05",
            "postCode": "71909"
        },
        {
            "postCodeInt": 71950,
            "cityName": "SEREMBAN",
            "stateCode": "05",
            "postCode": "71950"
        },
        {
            "postCodeInt": 71960,
            "cityName": "PORT DICKSON",
            "stateCode": "05",
            "postCode": "71960"
        },
        {
            "postCodeInt": 72000,
            "cityName": "KUALA PILAH",
            "stateCode": "05",
            "postCode": "72000"
        },
        {
            "postCodeInt": 72007,
            "cityName": "KUALA PILAH",
            "stateCode": "05",
            "postCode": "72007"
        },
        {
            "postCodeInt": 72009,
            "cityName": "KUALA PILAH",
            "stateCode": "05",
            "postCode": "72009"
        },
        {
            "postCodeInt": 72100,
            "cityName": "BAHAU",
            "stateCode": "05",
            "postCode": "72100"
        },
        {
            "postCodeInt": 72107,
            "cityName": "BAHAU",
            "stateCode": "05",
            "postCode": "72107"
        },
        {
            "postCodeInt": 72109,
            "cityName": "BAHAU",
            "stateCode": "05",
            "postCode": "72109"
        },
        {
            "postCodeInt": 72120,
            "cityName": "BANDAR BARU SERTING",
            "stateCode": "05",
            "postCode": "72120"
        },
        {
            "postCodeInt": 72127,
            "cityName": "BANDAR BARU SERTING",
            "stateCode": "05",
            "postCode": "72127"
        },
        {
            "postCodeInt": 72129,
            "cityName": "BANDAR BARU SERTING",
            "stateCode": "05",
            "postCode": "72129"
        },
        {
            "postCodeInt": 72200,
            "cityName": "BATU KIKIR",
            "stateCode": "05",
            "postCode": "72200"
        },
        {
            "postCodeInt": 72207,
            "cityName": "BATU KIKIR",
            "stateCode": "05",
            "postCode": "72207"
        },
        {
            "postCodeInt": 72209,
            "cityName": "BATU KIKIR",
            "stateCode": "05",
            "postCode": "72209"
        },
        {
            "postCodeInt": 72300,
            "cityName": "SIMPANG PERTANG",
            "stateCode": "05",
            "postCode": "72300"
        },
        {
            "postCodeInt": 72307,
            "cityName": "SIMPANG PERTANG",
            "stateCode": "05",
            "postCode": "72307"
        },
        {
            "postCodeInt": 72309,
            "cityName": "SIMPANG PERTANG",
            "stateCode": "05",
            "postCode": "72309"
        },
        {
            "postCodeInt": 72400,
            "cityName": "SIMPANG DURIAN",
            "stateCode": "05",
            "postCode": "72400"
        },
        {
            "postCodeInt": 72409,
            "cityName": "SIMPANG DURIAN",
            "stateCode": "05",
            "postCode": "72409"
        },
        {
            "postCodeInt": 72500,
            "cityName": "KUALA PILAH",
            "stateCode": "05",
            "postCode": "72500"
        },
        {
            "postCodeInt": 72507,
            "cityName": "JUASSEH",
            "stateCode": "05",
            "postCode": "72507"
        },
        {
            "postCodeInt": 72509,
            "cityName": "JUASSEH",
            "stateCode": "05",
            "postCode": "72509"
        },
        {
            "postCodeInt": 73000,
            "cityName": "TAMPIN",
            "stateCode": "05",
            "postCode": "73000"
        },
        {
            "postCodeInt": 73007,
            "cityName": "TAMPIN",
            "stateCode": "05",
            "postCode": "73007"
        },
        {
            "postCodeInt": 73009,
            "cityName": "TAMPIN",
            "stateCode": "05",
            "postCode": "73009"
        },
        {
            "postCodeInt": 73100,
            "cityName": "JOHOL",
            "stateCode": "05",
            "postCode": "73100"
        },
        {
            "postCodeInt": 73109,
            "cityName": "JOHOL",
            "stateCode": "05",
            "postCode": "73109"
        },
        {
            "postCodeInt": 73200,
            "cityName": "GEMENCHEH",
            "stateCode": "05",
            "postCode": "73200"
        },
        {
            "postCodeInt": 73207,
            "cityName": "GEMENCHEH",
            "stateCode": "05",
            "postCode": "73207"
        },
        {
            "postCodeInt": 73209,
            "cityName": "GEMENCHEH",
            "stateCode": "05",
            "postCode": "73209"
        },
        {
            "postCodeInt": 73300,
            "cityName": "GEMENCHEH",
            "stateCode": "05",
            "postCode": "73300"
        },
        {
            "postCodeInt": 73309,
            "cityName": "BATANG MELAKA",
            "stateCode": "05",
            "postCode": "73309"
        },
        {
            "postCodeInt": 73400,
            "cityName": "GEMAS",
            "stateCode": "05",
            "postCode": "73400"
        },
        {
            "postCodeInt": 73409,
            "cityName": "GEMAS",
            "stateCode": "05",
            "postCode": "73409"
        },
        {
            "postCodeInt": 73410,
            "cityName": "GEMAS",
            "stateCode": "05",
            "postCode": "73410"
        },
        {
            "postCodeInt": 73420,
            "cityName": "GEMAS",
            "stateCode": "05",
            "postCode": "73420"
        },
        {
            "postCodeInt": 73430,
            "cityName": "PST BDR PALONG",
            "stateCode": "05",
            "postCode": "73430"
        },
        {
            "postCodeInt": 73440,
            "cityName": "FELDA PALONG 1",
            "stateCode": "05",
            "postCode": "73440"
        },
        {
            "postCodeInt": 73450,
            "cityName": "PST BDR PALONG",
            "stateCode": "05",
            "postCode": "73450"
        },
        {
            "postCodeInt": 73460,
            "cityName": "PST BDR PALONG",
            "stateCode": "05",
            "postCode": "73460"
        },
        {
            "postCodeInt": 73470,
            "cityName": "PST BDR PALONG",
            "stateCode": "05",
            "postCode": "73470"
        },
        {
            "postCodeInt": 73480,
            "cityName": "GEMAS",
            "stateCode": "05",
            "postCode": "73480"
        },
        {
            "postCodeInt": 73500,
            "cityName": "ROMPIN",
            "stateCode": "05",
            "postCode": "73500"
        },
        {
            "postCodeInt": 73507,
            "cityName": "ROMPIN",
            "stateCode": "05",
            "postCode": "73507"
        },
        {
            "postCodeInt": 73509,
            "cityName": "ROMPIN",
            "stateCode": "05",
            "postCode": "73509"
        },
        {
            "postCodeInt": 10000,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10000"
        },
        {
            "postCodeInt": 10050,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10050"
        },
        {
            "postCodeInt": 10100,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10100"
        },
        {
            "postCodeInt": 10150,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10150"
        },
        {
            "postCodeInt": 10200,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10200"
        },
        {
            "postCodeInt": 10250,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10250"
        },
        {
            "postCodeInt": 10300,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10300"
        },
        {
            "postCodeInt": 10350,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10350"
        },
        {
            "postCodeInt": 10400,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10400"
        },
        {
            "postCodeInt": 10450,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10450"
        },
        {
            "postCodeInt": 10460,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10460"
        },
        {
            "postCodeInt": 10470,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10470"
        },
        {
            "postCodeInt": 10500,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10500"
        },
        {
            "postCodeInt": 10502,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10502"
        },
        {
            "postCodeInt": 10503,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10503"
        },
        {
            "postCodeInt": 10504,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10504"
        },
        {
            "postCodeInt": 10505,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10505"
        },
        {
            "postCodeInt": 10506,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10506"
        },
        {
            "postCodeInt": 10508,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10508"
        },
        {
            "postCodeInt": 10512,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10512"
        },
        {
            "postCodeInt": 10514,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10514"
        },
        {
            "postCodeInt": 10516,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10516"
        },
        {
            "postCodeInt": 10518,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10518"
        },
        {
            "postCodeInt": 10524,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10524"
        },
        {
            "postCodeInt": 10534,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10534"
        },
        {
            "postCodeInt": 10538,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10538"
        },
        {
            "postCodeInt": 10540,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10540"
        },
        {
            "postCodeInt": 10542,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10542"
        },
        {
            "postCodeInt": 10546,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10546"
        },
        {
            "postCodeInt": 10550,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10550"
        },
        {
            "postCodeInt": 10551,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10551"
        },
        {
            "postCodeInt": 10552,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10552"
        },
        {
            "postCodeInt": 10558,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10558"
        },
        {
            "postCodeInt": 10560,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10560"
        },
        {
            "postCodeInt": 10564,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10564"
        },
        {
            "postCodeInt": 10566,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10566"
        },
        {
            "postCodeInt": 10570,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10570"
        },
        {
            "postCodeInt": 10576,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10576"
        },
        {
            "postCodeInt": 10578,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10578"
        },
        {
            "postCodeInt": 10582,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10582"
        },
        {
            "postCodeInt": 10590,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10590"
        },
        {
            "postCodeInt": 10592,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10592"
        },
        {
            "postCodeInt": 10593,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10593"
        },
        {
            "postCodeInt": 10594,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10594"
        },
        {
            "postCodeInt": 10596,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10596"
        },
        {
            "postCodeInt": 10600,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10600"
        },
        {
            "postCodeInt": 10604,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10604"
        },
        {
            "postCodeInt": 10609,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10609"
        },
        {
            "postCodeInt": 10610,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10610"
        },
        {
            "postCodeInt": 10612,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10612"
        },
        {
            "postCodeInt": 10620,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10620"
        },
        {
            "postCodeInt": 10622,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10622"
        },
        {
            "postCodeInt": 10626,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10626"
        },
        {
            "postCodeInt": 10628,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10628"
        },
        {
            "postCodeInt": 10634,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10634"
        },
        {
            "postCodeInt": 10646,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10646"
        },
        {
            "postCodeInt": 10648,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10648"
        },
        {
            "postCodeInt": 10660,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10660"
        },
        {
            "postCodeInt": 10661,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10661"
        },
        {
            "postCodeInt": 10662,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10662"
        },
        {
            "postCodeInt": 10668,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10668"
        },
        {
            "postCodeInt": 10670,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10670"
        },
        {
            "postCodeInt": 10672,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10672"
        },
        {
            "postCodeInt": 10673,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10673"
        },
        {
            "postCodeInt": 10674,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10674"
        },
        {
            "postCodeInt": 10676,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10676"
        },
        {
            "postCodeInt": 10690,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10690"
        },
        {
            "postCodeInt": 10700,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10700"
        },
        {
            "postCodeInt": 10710,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10710"
        },
        {
            "postCodeInt": 10720,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10720"
        },
        {
            "postCodeInt": 10730,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10730"
        },
        {
            "postCodeInt": 10740,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10740"
        },
        {
            "postCodeInt": 10750,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10750"
        },
        {
            "postCodeInt": 10760,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10760"
        },
        {
            "postCodeInt": 10770,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10770"
        },
        {
            "postCodeInt": 10780,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10780"
        },
        {
            "postCodeInt": 10790,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10790"
        },
        {
            "postCodeInt": 10800,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10800"
        },
        {
            "postCodeInt": 10810,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10810"
        },
        {
            "postCodeInt": 10820,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10820"
        },
        {
            "postCodeInt": 10830,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10830"
        },
        {
            "postCodeInt": 10840,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10840"
        },
        {
            "postCodeInt": 10850,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10850"
        },
        {
            "postCodeInt": 10900,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10900"
        },
        {
            "postCodeInt": 10910,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10910"
        },
        {
            "postCodeInt": 10920,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10920"
        },
        {
            "postCodeInt": 10990,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "10990"
        },
        {
            "postCodeInt": 11000,
            "cityName": "BALIK PULAU",
            "stateCode": "07",
            "postCode": "11000"
        },
        {
            "postCodeInt": 11010,
            "cityName": "BALIK PULAU",
            "stateCode": "07",
            "postCode": "11010"
        },
        {
            "postCodeInt": 11020,
            "cityName": "BALIK PULAU",
            "stateCode": "07",
            "postCode": "11020"
        },
        {
            "postCodeInt": 11050,
            "cityName": "TANJUNG BUNGAH",
            "stateCode": "07",
            "postCode": "11050"
        },
        {
            "postCodeInt": 11060,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "11060"
        },
        {
            "postCodeInt": 11100,
            "cityName": "BATU FERINGGI",
            "stateCode": "07",
            "postCode": "11100"
        },
        {
            "postCodeInt": 11200,
            "cityName": "TANJONG BUNGAH",
            "stateCode": "07",
            "postCode": "11200"
        },
        {
            "postCodeInt": 11300,
            "cityName": "PENANG HILL",
            "stateCode": "07",
            "postCode": "11300"
        },
        {
            "postCodeInt": 11400,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "11400"
        },
        {
            "postCodeInt": 11409,
            "cityName": "PADANG TEMBAK",
            "stateCode": "07",
            "postCode": "11409"
        },
        {
            "postCodeInt": 11500,
            "cityName": "AYER ITAM",
            "stateCode": "07",
            "postCode": "11500"
        },
        {
            "postCodeInt": 11600,
            "cityName": "PULAU PINANG",
            "stateCode": "07",
            "postCode": "11600"
        },
        {
            "postCodeInt": 11609,
            "cityName": "JELUTONG",
            "stateCode": "07",
            "postCode": "11609"
        },
        {
            "postCodeInt": 11700,
            "cityName": "GELUGOR",
            "stateCode": "07",
            "postCode": "11700"
        },
        {
            "postCodeInt": 11800,
            "cityName": "GELUGOR",
            "stateCode": "07",
            "postCode": "11800"
        },
        {
            "postCodeInt": 11900,
            "cityName": "BAYAN LEPAS",
            "stateCode": "07",
            "postCode": "11900"
        },
        {
            "postCodeInt": 11910,
            "cityName": "BAYAN LEPAS",
            "stateCode": "07",
            "postCode": "11910"
        },
        {
            "postCodeInt": 11920,
            "cityName": "BAYAN LEPAS",
            "stateCode": "07",
            "postCode": "11920"
        },
        {
            "postCodeInt": 11950,
            "cityName": "BAYAN BARU",
            "stateCode": "07",
            "postCode": "11950"
        },
        {
            "postCodeInt": 11960,
            "cityName": "BATU MAUNG",
            "stateCode": "07",
            "postCode": "11960"
        },
        {
            "postCodeInt": 12000,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12000"
        },
        {
            "postCodeInt": 12100,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12100"
        },
        {
            "postCodeInt": 12200,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12200"
        },
        {
            "postCodeInt": 12300,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12300"
        },
        {
            "postCodeInt": 12700,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12700"
        },
        {
            "postCodeInt": 12710,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12710"
        },
        {
            "postCodeInt": 12720,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12720"
        },
        {
            "postCodeInt": 12990,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "12990"
        },
        {
            "postCodeInt": 13000,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13000"
        },
        {
            "postCodeInt": 13009,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13009"
        },
        {
            "postCodeInt": 13020,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13020"
        },
        {
            "postCodeInt": 13050,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13050"
        },
        {
            "postCodeInt": 13100,
            "cityName": "PENAGA",
            "stateCode": "07",
            "postCode": "13100"
        },
        {
            "postCodeInt": 13110,
            "cityName": "PENAGA",
            "stateCode": "07",
            "postCode": "13110"
        },
        {
            "postCodeInt": 13200,
            "cityName": "KEPALA BATAS",
            "stateCode": "07",
            "postCode": "13200"
        },
        {
            "postCodeInt": 13210,
            "cityName": "KEPALA BATAS",
            "stateCode": "07",
            "postCode": "13210"
        },
        {
            "postCodeInt": 13220,
            "cityName": "KEPALA BATAS",
            "stateCode": "07",
            "postCode": "13220"
        },
        {
            "postCodeInt": 13300,
            "cityName": "TASEK GELUGOR",
            "stateCode": "07",
            "postCode": "13300"
        },
        {
            "postCodeInt": 13310,
            "cityName": "TASEK GELUGOR",
            "stateCode": "07",
            "postCode": "13310"
        },
        {
            "postCodeInt": 13400,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13400"
        },
        {
            "postCodeInt": 13409,
            "cityName": "MAK MANDIN",
            "stateCode": "07",
            "postCode": "13409"
        },
        {
            "postCodeInt": 13500,
            "cityName": "PERMATANG PAUH",
            "stateCode": "07",
            "postCode": "13500"
        },
        {
            "postCodeInt": 13600,
            "cityName": "PERAI",
            "stateCode": "07",
            "postCode": "13600"
        },
        {
            "postCodeInt": 13700,
            "cityName": "PERAI",
            "stateCode": "07",
            "postCode": "13700"
        },
        {
            "postCodeInt": 13800,
            "cityName": "BUTTERWORTH",
            "stateCode": "07",
            "postCode": "13800"
        },
        {
            "postCodeInt": 14000,
            "cityName": "BUKIT MERTAJAM",
            "stateCode": "07",
            "postCode": "14000"
        },
        {
            "postCodeInt": 14007,
            "cityName": "BUKIT MERTAJAM",
            "stateCode": "07",
            "postCode": "14007"
        },
        {
            "postCodeInt": 14009,
            "cityName": "BUKIT MERTAJAM",
            "stateCode": "07",
            "postCode": "14009"
        },
        {
            "postCodeInt": 14020,
            "cityName": "BUKIT MERTAJAM",
            "stateCode": "07",
            "postCode": "14020"
        },
        {
            "postCodeInt": 14100,
            "cityName": "SIMPANG AMPAT",
            "stateCode": "07",
            "postCode": "14100"
        },
        {
            "postCodeInt": 14101,
            "cityName": "SIMPANG AMPAT",
            "stateCode": "07",
            "postCode": "14101"
        },
        {
            "postCodeInt": 14110,
            "cityName": "SIMPANG AMPAT",
            "stateCode": "07",
            "postCode": "14110"
        },
        {
            "postCodeInt": 14120,
            "cityName": "SIMPANG AMPAT",
            "stateCode": "07",
            "postCode": "14120"
        },
        {
            "postCodeInt": 14200,
            "cityName": "SUNGAI JAWI",
            "stateCode": "07",
            "postCode": "14200"
        },
        {
            "postCodeInt": 14300,
            "cityName": "NIBONG TEBAL",
            "stateCode": "07",
            "postCode": "14300"
        },
        {
            "postCodeInt": 14310,
            "cityName": "NIBONG TEBAL",
            "stateCode": "07",
            "postCode": "14310"
        },
        {
            "postCodeInt": 14320,
            "cityName": "NIBONG TEBAL",
            "stateCode": "07",
            "postCode": "14320"
        },
        {
            "postCodeInt": 14400,
            "cityName": "KUBANG SEMANG",
            "stateCode": "07",
            "postCode": "14400"
        },
        {
            "postCodeInt": "01000",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01000"
        },
        {
            "postCodeInt": "01007",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01007"
        },
        {
            "postCodeInt": "01009",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01009"
        },
        {
            "postCodeInt": "01500",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01500"
        },
        {
            "postCodeInt": "01502",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01502"
        },
        {
            "postCodeInt": "01503",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01503"
        },
        {
            "postCodeInt": "01504",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01504"
        },
        {
            "postCodeInt": "01505",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01505"
        },
        {
            "postCodeInt": "01506",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01506"
        },
        {
            "postCodeInt": "01508",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01508"
        },
        {
            "postCodeInt": "01512",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01512"
        },
        {
            "postCodeInt": "01514",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01514"
        },
        {
            "postCodeInt": "01516",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01516"
        },
        {
            "postCodeInt": "01517",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01517"
        },
        {
            "postCodeInt": "01518",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01518"
        },
        {
            "postCodeInt": "01524",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01524"
        },
        {
            "postCodeInt": "01529",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01529"
        },
        {
            "postCodeInt": "01532",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01532"
        },
        {
            "postCodeInt": "01538",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01538"
        },
        {
            "postCodeInt": "01540",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01540"
        },
        {
            "postCodeInt": "01546",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01546"
        },
        {
            "postCodeInt": "01550",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01550"
        },
        {
            "postCodeInt": "01551",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01551"
        },
        {
            "postCodeInt": "01556",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01556"
        },
        {
            "postCodeInt": "01560",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01560"
        },
        {
            "postCodeInt": "01564",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01564"
        },
        {
            "postCodeInt": "01570",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01570"
        },
        {
            "postCodeInt": "01572",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01572"
        },
        {
            "postCodeInt": "01576",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01576"
        },
        {
            "postCodeInt": "01578",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01578"
        },
        {
            "postCodeInt": "01582",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01582"
        },
        {
            "postCodeInt": "01586",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01586"
        },
        {
            "postCodeInt": "01590",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01590"
        },
        {
            "postCodeInt": "01592",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01592"
        },
        {
            "postCodeInt": "01594",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01594"
        },
        {
            "postCodeInt": "01596",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01596"
        },
        {
            "postCodeInt": "01598",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01598"
        },
        {
            "postCodeInt": "01600",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01600"
        },
        {
            "postCodeInt": "01604",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01604"
        },
        {
            "postCodeInt": "01606",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01606"
        },
        {
            "postCodeInt": "01608",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01608"
        },
        {
            "postCodeInt": "01609",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01609"
        },
        {
            "postCodeInt": "01610",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01610"
        },
        {
            "postCodeInt": "01612",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01612"
        },
        {
            "postCodeInt": "01614",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01614"
        },
        {
            "postCodeInt": "01620",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01620"
        },
        {
            "postCodeInt": "01622",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01622"
        },
        {
            "postCodeInt": "01626",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01626"
        },
        {
            "postCodeInt": "01628",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01628"
        },
        {
            "postCodeInt": "01630",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01630"
        },
        {
            "postCodeInt": "01632",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01632"
        },
        {
            "postCodeInt": "01634",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01634"
        },
        {
            "postCodeInt": "01644",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01644"
        },
        {
            "postCodeInt": "01646",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01646"
        },
        {
            "postCodeInt": "01648",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01648"
        },
        {
            "postCodeInt": "01660",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01660"
        },
        {
            "postCodeInt": "01664",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01664"
        },
        {
            "postCodeInt": "01670",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01670"
        },
        {
            "postCodeInt": "01672",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01672"
        },
        {
            "postCodeInt": "01673",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01673"
        },
        {
            "postCodeInt": "01674",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01674"
        },
        {
            "postCodeInt": "01676",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01676"
        },
        {
            "postCodeInt": "01680",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01680"
        },
        {
            "postCodeInt": "01694",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "01694"
        },
        {
            "postCodeInt": "02000",
            "cityName": "KUALA PERLIS",
            "stateCode": "09",
            "postCode": "02000"
        },
        {
            "postCodeInt": "02100",
            "cityName": "PADANG BESAR",
            "stateCode": "09",
            "postCode": "02100"
        },
        {
            "postCodeInt": "02200",
            "cityName": "KAKI BUKIT",
            "stateCode": "09",
            "postCode": "02200"
        },
        {
            "postCodeInt": "02400",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "02400"
        },
        {
            "postCodeInt": "02450",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "02450"
        },
        {
            "postCodeInt": "02500",
            "cityName": "KANGAR",
            "stateCode": "09",
            "postCode": "02500"
        },
        {
            "postCodeInt": "02600",
            "cityName": "ARAU",
            "stateCode": "09",
            "postCode": "02600"
        },
        {
            "postCodeInt": "02607",
            "cityName": "ARAU",
            "stateCode": "09",
            "postCode": "02607"
        },
        {
            "postCodeInt": "02609",
            "cityName": "ARAU",
            "stateCode": "09",
            "postCode": "02609"
        },
        {
            "postCodeInt": "02700",
            "cityName": "SIMPANG AMPAT",
            "stateCode": "09",
            "postCode": "02700"
        },
        {
            "postCodeInt": "02707",
            "cityName": "SIMPANG AMPAT",
            "stateCode": "09",
            "postCode": "02707"
        },
        {
            "postCodeInt": "02709",
            "cityName": "SIMPANG AMPAT",
            "stateCode": "09",
            "postCode": "02709"
        },
        {
            "postCodeInt": "02800",
            "cityName": "SIMPANG AMPAT",
            "stateCode": "09",
            "postCode": "02800"
        },
        {
            "postCodeInt": 40000,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40000"
        },
        {
            "postCodeInt": 40100,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40100"
        },
        {
            "postCodeInt": 40150,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40150"
        },
        {
            "postCodeInt": 40160,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40160"
        },
        {
            "postCodeInt": 40170,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40170"
        },
        {
            "postCodeInt": 40200,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40200"
        },
        {
            "postCodeInt": 40300,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40300"
        },
        {
            "postCodeInt": 40400,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40400"
        },
        {
            "postCodeInt": 40450,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40450"
        },
        {
            "postCodeInt": 40460,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40460"
        },
        {
            "postCodeInt": 40470,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40470"
        },
        {
            "postCodeInt": 40500,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40500"
        },
        {
            "postCodeInt": 40502,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40502"
        },
        {
            "postCodeInt": 40503,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40503"
        },
        {
            "postCodeInt": 40505,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40505"
        },
        {
            "postCodeInt": 40509,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40509"
        },
        {
            "postCodeInt": 40512,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40512"
        },
        {
            "postCodeInt": 40517,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40517"
        },
        {
            "postCodeInt": 40520,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40520"
        },
        {
            "postCodeInt": 40529,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40529"
        },
        {
            "postCodeInt": 40542,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40542"
        },
        {
            "postCodeInt": 40548,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40548"
        },
        {
            "postCodeInt": 40550,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40550"
        },
        {
            "postCodeInt": 40551,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40551"
        },
        {
            "postCodeInt": 40560,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40560"
        },
        {
            "postCodeInt": 40564,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40564"
        },
        {
            "postCodeInt": 40570,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40570"
        },
        {
            "postCodeInt": 40572,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40572"
        },
        {
            "postCodeInt": 40576,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40576"
        },
        {
            "postCodeInt": 40578,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40578"
        },
        {
            "postCodeInt": 40582,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40582"
        },
        {
            "postCodeInt": 40590,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40590"
        },
        {
            "postCodeInt": 40592,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40592"
        },
        {
            "postCodeInt": 40594,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40594"
        },
        {
            "postCodeInt": 40596,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40596"
        },
        {
            "postCodeInt": 40598,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40598"
        },
        {
            "postCodeInt": 40604,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40604"
        },
        {
            "postCodeInt": 40607,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40607"
        },
        {
            "postCodeInt": 40608,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40608"
        },
        {
            "postCodeInt": 40610,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40610"
        },
        {
            "postCodeInt": 40612,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40612"
        },
        {
            "postCodeInt": 40620,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40620"
        },
        {
            "postCodeInt": 40622,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40622"
        },
        {
            "postCodeInt": 40626,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40626"
        },
        {
            "postCodeInt": 40632,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40632"
        },
        {
            "postCodeInt": 40646,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40646"
        },
        {
            "postCodeInt": 40648,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40648"
        },
        {
            "postCodeInt": 40660,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40660"
        },
        {
            "postCodeInt": 40664,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40664"
        },
        {
            "postCodeInt": 40670,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40670"
        },
        {
            "postCodeInt": 40672,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40672"
        },
        {
            "postCodeInt": 40673,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40673"
        },
        {
            "postCodeInt": 40674,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40674"
        },
        {
            "postCodeInt": 40675,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40675"
        },
        {
            "postCodeInt": 40676,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40676"
        },
        {
            "postCodeInt": 40680,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40680"
        },
        {
            "postCodeInt": 40690,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40690"
        },
        {
            "postCodeInt": 40700,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40700"
        },
        {
            "postCodeInt": 40702,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40702"
        },
        {
            "postCodeInt": 40704,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40704"
        },
        {
            "postCodeInt": 40706,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40706"
        },
        {
            "postCodeInt": 40708,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40708"
        },
        {
            "postCodeInt": 40710,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40710"
        },
        {
            "postCodeInt": 40712,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40712"
        },
        {
            "postCodeInt": 40714,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40714"
        },
        {
            "postCodeInt": 40716,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40716"
        },
        {
            "postCodeInt": 40718,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40718"
        },
        {
            "postCodeInt": 40720,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40720"
        },
        {
            "postCodeInt": 40722,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40722"
        },
        {
            "postCodeInt": 40724,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40724"
        },
        {
            "postCodeInt": 40726,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40726"
        },
        {
            "postCodeInt": 40728,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40728"
        },
        {
            "postCodeInt": 40730,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40730"
        },
        {
            "postCodeInt": 40732,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40732"
        },
        {
            "postCodeInt": 40800,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40800"
        },
        {
            "postCodeInt": 40802,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40802"
        },
        {
            "postCodeInt": 40804,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40804"
        },
        {
            "postCodeInt": 40806,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40806"
        },
        {
            "postCodeInt": 40808,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40808"
        },
        {
            "postCodeInt": 40810,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40810"
        },
        {
            "postCodeInt": 40990,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "40990"
        },
        {
            "postCodeInt": 41000,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41000"
        },
        {
            "postCodeInt": 41050,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41050"
        },
        {
            "postCodeInt": 41100,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41100"
        },
        {
            "postCodeInt": 41150,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41150"
        },
        {
            "postCodeInt": 41200,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41200"
        },
        {
            "postCodeInt": 55188,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55188"
        },
        {
            "postCodeInt": 41250,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41250"
        },
        {
            "postCodeInt": 41300,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41300"
        },
        {
            "postCodeInt": 41400,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41400"
        },
        {
            "postCodeInt": 41500,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41500"
        },
        {
            "postCodeInt": 41506,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41506"
        },
        {
            "postCodeInt": 41560,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41560"
        },
        {
            "postCodeInt": 41586,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41586"
        },
        {
            "postCodeInt": 41672,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41672"
        },
        {
            "postCodeInt": 41675,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41675"
        },
        {
            "postCodeInt": 41700,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41700"
        },
        {
            "postCodeInt": 41710,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41710"
        },
        {
            "postCodeInt": 41720,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41720"
        },
        {
            "postCodeInt": 41900,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41900"
        },
        {
            "postCodeInt": 41902,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41902"
        },
        {
            "postCodeInt": 41904,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41904"
        },
        {
            "postCodeInt": 41906,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41906"
        },
        {
            "postCodeInt": 41908,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41908"
        },
        {
            "postCodeInt": 41910,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41910"
        },
        {
            "postCodeInt": 41912,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41912"
        },
        {
            "postCodeInt": 41914,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41914"
        },
        {
            "postCodeInt": 41916,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41916"
        },
        {
            "postCodeInt": 41918,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41918"
        },
        {
            "postCodeInt": 41990,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "41990"
        },
        {
            "postCodeInt": 42000,
            "cityName": "PELABUHAN KLANG",
            "stateCode": "10",
            "postCode": "42000"
        },
        {
            "postCodeInt": 42009,
            "cityName": "PELABUHAN KLANG",
            "stateCode": "10",
            "postCode": "42009"
        },
        {
            "postCodeInt": 42100,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "42100"
        },
        {
            "postCodeInt": 42200,
            "cityName": "KAPAR",
            "stateCode": "10",
            "postCode": "42200"
        },
        {
            "postCodeInt": 42300,
            "cityName": "BANDAR PUNCAK ALAM",
            "stateCode": "10",
            "postCode": "42300"
        },
        {
            "postCodeInt": 42425,
            "cityName": "TELOK PANGLIMA GARANG",
            "stateCode": "10",
            "postCode": "42425"
        },
        {
            "postCodeInt": 42450,
            "cityName": "KLANG",
            "stateCode": "10",
            "postCode": "42450"
        },
        {
            "postCodeInt": 42500,
            "cityName": "TELOK PANGLIMA GARANG",
            "stateCode": "10",
            "postCode": "42500"
        },
        {
            "postCodeInt": 42507,
            "cityName": "TELOK PANGLIMA GARANG",
            "stateCode": "10",
            "postCode": "42507"
        },
        {
            "postCodeInt": 42509,
            "cityName": "TELUK PANGLIMA GARANG",
            "stateCode": "10",
            "postCode": "42509"
        },
        {
            "postCodeInt": 42600,
            "cityName": "JENJAROM",
            "stateCode": "10",
            "postCode": "42600"
        },
        {
            "postCodeInt": 42610,
            "cityName": "BANDAR SAUJANA PUTRA",
            "stateCode": "10",
            "postCode": "42610"
        },
        {
            "postCodeInt": 42700,
            "cityName": "BANTING",
            "stateCode": "10",
            "postCode": "42700"
        },
        {
            "postCodeInt": 42800,
            "cityName": "TANJONG SEPAT",
            "stateCode": "10",
            "postCode": "42800"
        },
        {
            "postCodeInt": 42920,
            "cityName": "PULAU LUMUT",
            "stateCode": "10",
            "postCode": "42920"
        },
        {
            "postCodeInt": 42940,
            "cityName": "PULAU KETAM",
            "stateCode": "10",
            "postCode": "42940"
        },
        {
            "postCodeInt": 42960,
            "cityName": "PULAU CAREY",
            "stateCode": "10",
            "postCode": "42960"
        },
        {
            "postCodeInt": 43000,
            "cityName": "KAJANG",
            "stateCode": "10",
            "postCode": "43000"
        },
        {
            "postCodeInt": 43007,
            "cityName": "KAJANG",
            "stateCode": "10",
            "postCode": "43007"
        },
        {
            "postCodeInt": 43009,
            "cityName": "KAJANG",
            "stateCode": "10",
            "postCode": "43009"
        },
        {
            "postCodeInt": 43100,
            "cityName": "HULU LANGAT",
            "stateCode": "10",
            "postCode": "43100"
        },
        {
            "postCodeInt": 43200,
            "cityName": "BATU 9 CHERAS",
            "stateCode": "10",
            "postCode": "43200"
        },
        {
            "postCodeInt": 43207,
            "cityName": "BATU 9 CHERAS",
            "stateCode": "10",
            "postCode": "43207"
        },
        {
            "postCodeInt": 43300,
            "cityName": "SERI KEMBANGAN",
            "stateCode": "10",
            "postCode": "43300"
        },
        {
            "postCodeInt": 43400,
            "cityName": "SERDANG",
            "stateCode": "10",
            "postCode": "43400"
        },
        {
            "postCodeInt": 43500,
            "cityName": "SEMENYIH",
            "stateCode": "10",
            "postCode": "43500"
        },
        {
            "postCodeInt": 43558,
            "cityName": "KAJANG",
            "stateCode": "10",
            "postCode": "43558"
        },
        {
            "postCodeInt": 43600,
            "cityName": "BANGI",
            "stateCode": "10",
            "postCode": "43600"
        },
        {
            "postCodeInt": 43650,
            "cityName": "BANDAR BARU BANGI",
            "stateCode": "10",
            "postCode": "43650"
        },
        {
            "postCodeInt": 43700,
            "cityName": "BERANANG",
            "stateCode": "10",
            "postCode": "43700"
        },
        {
            "postCodeInt": 43800,
            "cityName": "DENGKIL",
            "stateCode": "10",
            "postCode": "43800"
        },
        {
            "postCodeInt": 43807,
            "cityName": "DENGKIL",
            "stateCode": "10",
            "postCode": "43807"
        },
        {
            "postCodeInt": 43809,
            "cityName": "DENGKIL",
            "stateCode": "10",
            "postCode": "43809"
        },
        {
            "postCodeInt": 43900,
            "cityName": "SEPANG",
            "stateCode": "10",
            "postCode": "43900"
        },
        {
            "postCodeInt": 43950,
            "cityName": "SUNGAI PELEK",
            "stateCode": "10",
            "postCode": "43950"
        },
        {
            "postCodeInt": 44000,
            "cityName": "KUALA KUBU BARU",
            "stateCode": "10",
            "postCode": "44000"
        },
        {
            "postCodeInt": 44010,
            "cityName": "KUALA KUBU BARU",
            "stateCode": "10",
            "postCode": "44010"
        },
        {
            "postCodeInt": 44020,
            "cityName": "KUALA KUBU BARU",
            "stateCode": "10",
            "postCode": "44020"
        },
        {
            "postCodeInt": 44100,
            "cityName": "KERLING",
            "stateCode": "10",
            "postCode": "44100"
        },
        {
            "postCodeInt": 44110,
            "cityName": "BDR BARU LEMBAH BERINGIN",
            "stateCode": "10",
            "postCode": "44110"
        },
        {
            "postCodeInt": 44200,
            "cityName": "RASA",
            "stateCode": "10",
            "postCode": "44200"
        },
        {
            "postCodeInt": 44300,
            "cityName": "BATANG KALI",
            "stateCode": "10",
            "postCode": "44300"
        },
        {
            "postCodeInt": 45000,
            "cityName": "KUALA SELANGOR",
            "stateCode": "10",
            "postCode": "45000"
        },
        {
            "postCodeInt": 45030,
            "cityName": "BANDAR ALAM PERDANA",
            "stateCode": "10",
            "postCode": "45030"
        },
        {
            "postCodeInt": 45100,
            "cityName": "SUNGAI AYER TAWAR",
            "stateCode": "10",
            "postCode": "45100"
        },
        {
            "postCodeInt": 45200,
            "cityName": "SABAK BERNAM",
            "stateCode": "10",
            "postCode": "45200"
        },
        {
            "postCodeInt": 45207,
            "cityName": "SABAK BERNAM",
            "stateCode": "10",
            "postCode": "45207"
        },
        {
            "postCodeInt": 45209,
            "cityName": "SABAK BERNAM",
            "stateCode": "10",
            "postCode": "45209"
        },
        {
            "postCodeInt": 45300,
            "cityName": "SUNGAI BESAR",
            "stateCode": "10",
            "postCode": "45300"
        },
        {
            "postCodeInt": 45400,
            "cityName": "SEKINCHAN",
            "stateCode": "10",
            "postCode": "45400"
        },
        {
            "postCodeInt": 45500,
            "cityName": "TANJONG KARANG",
            "stateCode": "10",
            "postCode": "45500"
        },
        {
            "postCodeInt": 45600,
            "cityName": "BATANG BERJUNTAI",
            "stateCode": "10",
            "postCode": "45600"
        },
        {
            "postCodeInt": 45607,
            "cityName": "BATANG BERJUNTAI",
            "stateCode": "10",
            "postCode": "45607"
        },
        {
            "postCodeInt": 45609,
            "cityName": "BATANG BERJUNTAI",
            "stateCode": "10",
            "postCode": "45609"
        },
        {
            "postCodeInt": 45620,
            "cityName": "IJOK",
            "stateCode": "10",
            "postCode": "45620"
        },
        {
            "postCodeInt": 45700,
            "cityName": "BUKIT ROTAN",
            "stateCode": "10",
            "postCode": "45700"
        },
        {
            "postCodeInt": 45800,
            "cityName": "JERAM",
            "stateCode": "10",
            "postCode": "45800"
        },
        {
            "postCodeInt": 46000,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46000"
        },
        {
            "postCodeInt": 46050,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46050"
        },
        {
            "postCodeInt": 46100,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46100"
        },
        {
            "postCodeInt": 46150,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46150"
        },
        {
            "postCodeInt": 46160,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46160"
        },
        {
            "postCodeInt": 46200,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46200"
        },
        {
            "postCodeInt": 46300,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46300"
        },
        {
            "postCodeInt": 46350,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46350"
        },
        {
            "postCodeInt": 46400,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46400"
        },
        {
            "postCodeInt": 46506,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46506"
        },
        {
            "postCodeInt": 46547,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46547"
        },
        {
            "postCodeInt": 46549,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46549"
        },
        {
            "postCodeInt": 46551,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46551"
        },
        {
            "postCodeInt": 46564,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46564"
        },
        {
            "postCodeInt": 46582,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46582"
        },
        {
            "postCodeInt": 46598,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46598"
        },
        {
            "postCodeInt": 46662,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46662"
        },
        {
            "postCodeInt": 46667,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46667"
        },
        {
            "postCodeInt": 46668,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46668"
        },
        {
            "postCodeInt": 46672,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46672"
        },
        {
            "postCodeInt": 46675,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46675"
        },
        {
            "postCodeInt": 46692,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46692"
        },
        {
            "postCodeInt": 46700,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46700"
        },
        {
            "postCodeInt": 46710,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46710"
        },
        {
            "postCodeInt": 46720,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46720"
        },
        {
            "postCodeInt": 46730,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46730"
        },
        {
            "postCodeInt": 46740,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46740"
        },
        {
            "postCodeInt": 46750,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46750"
        },
        {
            "postCodeInt": 46760,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46760"
        },
        {
            "postCodeInt": 46770,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46770"
        },
        {
            "postCodeInt": 46780,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46780"
        },
        {
            "postCodeInt": 46781,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46781"
        },
        {
            "postCodeInt": 46782,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46782"
        },
        {
            "postCodeInt": 46783,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46783"
        },
        {
            "postCodeInt": 46784,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46784"
        },
        {
            "postCodeInt": 46785,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46785"
        },
        {
            "postCodeInt": 46786,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46786"
        },
        {
            "postCodeInt": 46787,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46787"
        },
        {
            "postCodeInt": 46788,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46788"
        },
        {
            "postCodeInt": 46789,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46789"
        },
        {
            "postCodeInt": 46790,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46790"
        },
        {
            "postCodeInt": 46791,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46791"
        },
        {
            "postCodeInt": 46792,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46792"
        },
        {
            "postCodeInt": 46793,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46793"
        },
        {
            "postCodeInt": 46794,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46794"
        },
        {
            "postCodeInt": 46795,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46795"
        },
        {
            "postCodeInt": 46796,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46796"
        },
        {
            "postCodeInt": 46797,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46797"
        },
        {
            "postCodeInt": 46798,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46798"
        },
        {
            "postCodeInt": 46799,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46799"
        },
        {
            "postCodeInt": 46800,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46800"
        },
        {
            "postCodeInt": 46801,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46801"
        },
        {
            "postCodeInt": 46802,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46802"
        },
        {
            "postCodeInt": 46803,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46803"
        },
        {
            "postCodeInt": 46804,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46804"
        },
        {
            "postCodeInt": 46805,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46805"
        },
        {
            "postCodeInt": 46806,
            "cityName": "KELANA JAYA",
            "stateCode": "10",
            "postCode": "46806"
        },
        {
            "postCodeInt": 46860,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46860"
        },
        {
            "postCodeInt": 46870,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46870"
        },
        {
            "postCodeInt": 46960,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46960"
        },
        {
            "postCodeInt": 46962,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46962"
        },
        {
            "postCodeInt": 46964,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46964"
        },
        {
            "postCodeInt": 46966,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46966"
        },
        {
            "postCodeInt": 46968,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46968"
        },
        {
            "postCodeInt": 46970,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46970"
        },
        {
            "postCodeInt": 46972,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46972"
        },
        {
            "postCodeInt": 46974,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46974"
        },
        {
            "postCodeInt": 46976,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46976"
        },
        {
            "postCodeInt": 46978,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "46978"
        },
        {
            "postCodeInt": 47000,
            "cityName": "SUNGAI BULOH",
            "stateCode": "10",
            "postCode": "47000"
        },
        {
            "postCodeInt": 47100,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47100"
        },
        {
            "postCodeInt": 47110,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47110"
        },
        {
            "postCodeInt": 47120,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47120"
        },
        {
            "postCodeInt": 47130,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47130"
        },
        {
            "postCodeInt": 47140,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47140"
        },
        {
            "postCodeInt": 47150,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47150"
        },
        {
            "postCodeInt": 47160,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47160"
        },
        {
            "postCodeInt": 47170,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47170"
        },
        {
            "postCodeInt": 47180,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47180"
        },
        {
            "postCodeInt": 47190,
            "cityName": "PUCHONG",
            "stateCode": "10",
            "postCode": "47190"
        },
        {
            "postCodeInt": 47200,
            "cityName": "SHAH ALAM",
            "stateCode": "10",
            "postCode": "47200"
        },
        {
            "postCodeInt": 47300,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47300"
        },
        {
            "postCodeInt": 47301,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47301"
        },
        {
            "postCodeInt": 47307,
            "cityName": "KAMPONG TUNKU",
            "stateCode": "10",
            "postCode": "47307"
        },
        {
            "postCodeInt": 47308,
            "cityName": "KAMPONG TUNKU",
            "stateCode": "10",
            "postCode": "47308"
        },
        {
            "postCodeInt": 47400,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47400"
        },
        {
            "postCodeInt": 47410,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47410"
        },
        {
            "postCodeInt": 47500,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47500"
        },
        {
            "postCodeInt": 47507,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47507"
        },
        {
            "postCodeInt": 47509,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47509"
        },
        {
            "postCodeInt": 47600,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47600"
        },
        {
            "postCodeInt": 47610,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47610"
        },
        {
            "postCodeInt": 47620,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47620"
        },
        {
            "postCodeInt": 47630,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47630"
        },
        {
            "postCodeInt": 47640,
            "cityName": "SUBANG JAYA",
            "stateCode": "10",
            "postCode": "47640"
        },
        {
            "postCodeInt": 47650,
            "cityName": "BANDAR PUTRA HEIGHT",
            "stateCode": "10",
            "postCode": "47650"
        },
        {
            "postCodeInt": 47800,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47800"
        },
        {
            "postCodeInt": 47810,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47810"
        },
        {
            "postCodeInt": 47820,
            "cityName": "PETALING JAYA",
            "stateCode": "10",
            "postCode": "47820"
        },
        {
            "postCodeInt": 47830,
            "cityName": "DAMANSARA DAMAI",
            "stateCode": "10",
            "postCode": "47830"
        },
        {
            "postCodeInt": 48000,
            "cityName": "RAWANG",
            "stateCode": "10",
            "postCode": "48000"
        },
        {
            "postCodeInt": 48010,
            "cityName": "RAWANG",
            "stateCode": "10",
            "postCode": "48010"
        },
        {
            "postCodeInt": 48020,
            "cityName": "RAWANG",
            "stateCode": "10",
            "postCode": "48020"
        },
        {
            "postCodeInt": 48050,
            "cityName": "RAWANG",
            "stateCode": "10",
            "postCode": "48050"
        },
        {
            "postCodeInt": 48100,
            "cityName": "BATU ARANG",
            "stateCode": "10",
            "postCode": "48100"
        },
        {
            "postCodeInt": 48200,
            "cityName": "SERENDAH",
            "stateCode": "10",
            "postCode": "48200"
        },
        {
            "postCodeInt": 48300,
            "cityName": "RAWANG",
            "stateCode": "10",
            "postCode": "48300"
        },
        {
            "postCodeInt": 63000,
            "cityName": "CYBERJAYA",
            "stateCode": "10",
            "postCode": "63000"
        },
        {
            "postCodeInt": 63100,
            "cityName": "CYBERJAYA",
            "stateCode": "10",
            "postCode": "63100"
        },
        {
            "postCodeInt": 63200,
            "cityName": "CYBERJAYA",
            "stateCode": "10",
            "postCode": "63200"
        },
        {
            "postCodeInt": 63300,
            "cityName": "CYBERJAYA",
            "stateCode": "10",
            "postCode": "63300"
        },
        {
            "postCodeInt": 64000,
            "cityName": "SEPANG",
            "stateCode": "10",
            "postCode": "64000"
        },
        {
            "postCodeInt": 68000,
            "cityName": "AMPANG",
            "stateCode": "10",
            "postCode": "68000"
        },
        {
            "postCodeInt": 68100,
            "cityName": "BATU CAVES",
            "stateCode": "10",
            "postCode": "68100"
        },
        {
            "postCodeInt": 20000,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20000"
        },
        {
            "postCodeInt": 20050,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20050"
        },
        {
            "postCodeInt": 20080,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20080"
        },
        {
            "postCodeInt": 20100,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20100"
        },
        {
            "postCodeInt": 20200,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20200"
        },
        {
            "postCodeInt": 20300,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20300"
        },
        {
            "postCodeInt": 20400,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20400"
        },
        {
            "postCodeInt": 20500,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20500"
        },
        {
            "postCodeInt": 20502,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20502"
        },
        {
            "postCodeInt": 20503,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20503"
        },
        {
            "postCodeInt": 20504,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20504"
        },
        {
            "postCodeInt": 20505,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20505"
        },
        {
            "postCodeInt": 20506,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20506"
        },
        {
            "postCodeInt": 20508,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20508"
        },
        {
            "postCodeInt": 20512,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20512"
        },
        {
            "postCodeInt": 20514,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20514"
        },
        {
            "postCodeInt": 20516,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20516"
        },
        {
            "postCodeInt": 20517,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20517"
        },
        {
            "postCodeInt": 20518,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20518"
        },
        {
            "postCodeInt": 20519,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20519"
        },
        {
            "postCodeInt": 20520,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20520"
        },
        {
            "postCodeInt": 20532,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20532"
        },
        {
            "postCodeInt": 20534,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20534"
        },
        {
            "postCodeInt": 20536,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20536"
        },
        {
            "postCodeInt": 20538,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20538"
        },
        {
            "postCodeInt": 20540,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20540"
        },
        {
            "postCodeInt": 20542,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20542"
        },
        {
            "postCodeInt": 20546,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20546"
        },
        {
            "postCodeInt": 20548,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20548"
        },
        {
            "postCodeInt": 20550,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20550"
        },
        {
            "postCodeInt": 20551,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20551"
        },
        {
            "postCodeInt": 20552,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20552"
        },
        {
            "postCodeInt": 20554,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20554"
        },
        {
            "postCodeInt": 20556,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20556"
        },
        {
            "postCodeInt": 20560,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20560"
        },
        {
            "postCodeInt": 20564,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20564"
        },
        {
            "postCodeInt": 20566,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20566"
        },
        {
            "postCodeInt": 20568,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20568"
        },
        {
            "postCodeInt": 20570,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20570"
        },
        {
            "postCodeInt": 20572,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20572"
        },
        {
            "postCodeInt": 20576,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20576"
        },
        {
            "postCodeInt": 20578,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20578"
        },
        {
            "postCodeInt": 20582,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20582"
        },
        {
            "postCodeInt": 20586,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20586"
        },
        {
            "postCodeInt": 20590,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20590"
        },
        {
            "postCodeInt": 20592,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20592"
        },
        {
            "postCodeInt": 20594,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20594"
        },
        {
            "postCodeInt": 20596,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20596"
        },
        {
            "postCodeInt": 20598,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20598"
        },
        {
            "postCodeInt": 20600,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20600"
        },
        {
            "postCodeInt": 20604,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20604"
        },
        {
            "postCodeInt": 20606,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20606"
        },
        {
            "postCodeInt": 20608,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20608"
        },
        {
            "postCodeInt": 20609,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20609"
        },
        {
            "postCodeInt": 20610,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20610"
        },
        {
            "postCodeInt": 20612,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20612"
        },
        {
            "postCodeInt": 20614,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20614"
        },
        {
            "postCodeInt": 20618,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20618"
        },
        {
            "postCodeInt": 20620,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20620"
        },
        {
            "postCodeInt": 20622,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20622"
        },
        {
            "postCodeInt": 20626,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20626"
        },
        {
            "postCodeInt": 20628,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20628"
        },
        {
            "postCodeInt": 20630,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20630"
        },
        {
            "postCodeInt": 20632,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20632"
        },
        {
            "postCodeInt": 20646,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20646"
        },
        {
            "postCodeInt": 20648,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20648"
        },
        {
            "postCodeInt": 20656,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20656"
        },
        {
            "postCodeInt": 20658,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20658"
        },
        {
            "postCodeInt": 20660,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20660"
        },
        {
            "postCodeInt": 20661,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20661"
        },
        {
            "postCodeInt": 20662,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20662"
        },
        {
            "postCodeInt": 20664,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20664"
        },
        {
            "postCodeInt": 20668,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20668"
        },
        {
            "postCodeInt": 20670,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20670"
        },
        {
            "postCodeInt": 20672,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20672"
        },
        {
            "postCodeInt": 20673,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20673"
        },
        {
            "postCodeInt": 20674,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20674"
        },
        {
            "postCodeInt": 20676,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20676"
        },
        {
            "postCodeInt": 20680,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20680"
        },
        {
            "postCodeInt": 20690,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20690"
        },
        {
            "postCodeInt": 20698,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20698"
        },
        {
            "postCodeInt": 20700,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20700"
        },
        {
            "postCodeInt": 20710,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20710"
        },
        {
            "postCodeInt": 20720,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20720"
        },
        {
            "postCodeInt": 20900,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20900"
        },
        {
            "postCodeInt": 20902,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20902"
        },
        {
            "postCodeInt": 20904,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20904"
        },
        {
            "postCodeInt": 20906,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20906"
        },
        {
            "postCodeInt": 20908,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20908"
        },
        {
            "postCodeInt": 20910,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20910"
        },
        {
            "postCodeInt": 20912,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20912"
        },
        {
            "postCodeInt": 20914,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20914"
        },
        {
            "postCodeInt": 20916,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20916"
        },
        {
            "postCodeInt": 20918,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20918"
        },
        {
            "postCodeInt": 20920,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20920"
        },
        {
            "postCodeInt": 20922,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20922"
        },
        {
            "postCodeInt": 20924,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20924"
        },
        {
            "postCodeInt": 20926,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20926"
        },
        {
            "postCodeInt": 20928,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20928"
        },
        {
            "postCodeInt": 20930,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20930"
        },
        {
            "postCodeInt": 20990,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "20990"
        },
        {
            "postCodeInt": 21000,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21000"
        },
        {
            "postCodeInt": 21009,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21009"
        },
        {
            "postCodeInt": 21010,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21010"
        },
        {
            "postCodeInt": 21020,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21020"
        },
        {
            "postCodeInt": 21030,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21030"
        },
        {
            "postCodeInt": 21040,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21040"
        },
        {
            "postCodeInt": 21050,
            "cityName": "BELARA",
            "stateCode": "11",
            "postCode": "21050"
        },
        {
            "postCodeInt": 21060,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21060"
        },
        {
            "postCodeInt": 21070,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21070"
        },
        {
            "postCodeInt": 21080,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21080"
        },
        {
            "postCodeInt": 21090,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21090"
        },
        {
            "postCodeInt": 21100,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21100"
        },
        {
            "postCodeInt": 21109,
            "cityName": "GONG KAPAS",
            "stateCode": "11",
            "postCode": "21109"
        },
        {
            "postCodeInt": 21159,
            "cityName": "CHABANG TIGA",
            "stateCode": "11",
            "postCode": "21159"
        },
        {
            "postCodeInt": 21200,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21200"
        },
        {
            "postCodeInt": 21209,
            "cityName": "MANIR",
            "stateCode": "11",
            "postCode": "21209"
        },
        {
            "postCodeInt": 21210,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21210"
        },
        {
            "postCodeInt": 21220,
            "cityName": "BELARA",
            "stateCode": "11",
            "postCode": "21220"
        },
        {
            "postCodeInt": 21300,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21300"
        },
        {
            "postCodeInt": 21309,
            "cityName": "SEBERANG TAKIR",
            "stateCode": "11",
            "postCode": "21309"
        },
        {
            "postCodeInt": 21400,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21400"
        },
        {
            "postCodeInt": 21450,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21450"
        },
        {
            "postCodeInt": 21500,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21500"
        },
        {
            "postCodeInt": 21600,
            "cityName": "MARANG",
            "stateCode": "11",
            "postCode": "21600"
        },
        {
            "postCodeInt": 21610,
            "cityName": "KUALA TERENGGANU",
            "stateCode": "11",
            "postCode": "21610"
        },
        {
            "postCodeInt": 21700,
            "cityName": "KUALA BERANG",
            "stateCode": "11",
            "postCode": "21700"
        },
        {
            "postCodeInt": 21800,
            "cityName": "AJIL",
            "stateCode": "11",
            "postCode": "21800"
        },
        {
            "postCodeInt": 21810,
            "cityName": "AJIL",
            "stateCode": "11",
            "postCode": "21810"
        },
        {
            "postCodeInt": 21820,
            "cityName": "AJIL",
            "stateCode": "11",
            "postCode": "21820"
        },
        {
            "postCodeInt": 22000,
            "cityName": "JERTEH",
            "stateCode": "11",
            "postCode": "22000"
        },
        {
            "postCodeInt": 22010,
            "cityName": "JERTEH",
            "stateCode": "11",
            "postCode": "22010"
        },
        {
            "postCodeInt": 22020,
            "cityName": "JERTEH",
            "stateCode": "11",
            "postCode": "22020"
        },
        {
            "postCodeInt": 22030,
            "cityName": "JERTEH",
            "stateCode": "11",
            "postCode": "22030"
        },
        {
            "postCodeInt": 22040,
            "cityName": "JERTEH",
            "stateCode": "11",
            "postCode": "22040"
        },
        {
            "postCodeInt": 22100,
            "cityName": "PERMAISURI",
            "stateCode": "11",
            "postCode": "22100"
        },
        {
            "postCodeInt": 22107,
            "cityName": "PERMAISURI",
            "stateCode": "11",
            "postCode": "22107"
        },
        {
            "postCodeInt": 22109,
            "cityName": "PERMAISURI",
            "stateCode": "11",
            "postCode": "22109"
        },
        {
            "postCodeInt": 22110,
            "cityName": "PERMAISURI",
            "stateCode": "11",
            "postCode": "22110"
        },
        {
            "postCodeInt": 22120,
            "cityName": "PERMAISURI",
            "stateCode": "11",
            "postCode": "22120"
        },
        {
            "postCodeInt": 22200,
            "cityName": "KAMPONG RAJA",
            "stateCode": "11",
            "postCode": "22200"
        },
        {
            "postCodeInt": 22300,
            "cityName": "KUALA BESUT",
            "stateCode": "11",
            "postCode": "22300"
        },
        {
            "postCodeInt": 22307,
            "cityName": "KUALA BESUT",
            "stateCode": "11",
            "postCode": "22307"
        },
        {
            "postCodeInt": 22309,
            "cityName": "KUALA BESUT",
            "stateCode": "11",
            "postCode": "22309"
        },
        {
            "postCodeInt": 23000,
            "cityName": "DUNGUN",
            "stateCode": "11",
            "postCode": "23000"
        },
        {
            "postCodeInt": 23007,
            "cityName": "DUNGUN",
            "stateCode": "11",
            "postCode": "23007"
        },
        {
            "postCodeInt": 23009,
            "cityName": "DUNGUN",
            "stateCode": "11",
            "postCode": "23009"
        },
        {
            "postCodeInt": 23050,
            "cityName": "DUNGUN",
            "stateCode": "11",
            "postCode": "23050"
        },
        {
            "postCodeInt": 23100,
            "cityName": "PAKA",
            "stateCode": "11",
            "postCode": "23100"
        },
        {
            "postCodeInt": 23200,
            "cityName": "BUKIT BESI",
            "stateCode": "11",
            "postCode": "23200"
        },
        {
            "postCodeInt": 23300,
            "cityName": "KETENGAH JAYA",
            "stateCode": "11",
            "postCode": "23300"
        },
        {
            "postCodeInt": 23400,
            "cityName": "AL MUKTAFI BILLAH SHAH",
            "stateCode": "11",
            "postCode": "23400"
        },
        {
            "postCodeInt": 24000,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24000"
        },
        {
            "postCodeInt": 24007,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24007"
        },
        {
            "postCodeInt": 24009,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24009"
        },
        {
            "postCodeInt": 24010,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24010"
        },
        {
            "postCodeInt": 24020,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24020"
        },
        {
            "postCodeInt": 24030,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24030"
        },
        {
            "postCodeInt": 24040,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24040"
        },
        {
            "postCodeInt": 24050,
            "cityName": "CUKAI",
            "stateCode": "11",
            "postCode": "24050"
        },
        {
            "postCodeInt": 24060,
            "cityName": "CENEH",
            "stateCode": "11",
            "postCode": "24060"
        },
        {
            "postCodeInt": 24100,
            "cityName": "KIJAL",
            "stateCode": "11",
            "postCode": "24100"
        },
        {
            "postCodeInt": 24107,
            "cityName": "KIJAL",
            "stateCode": "11",
            "postCode": "24107"
        },
        {
            "postCodeInt": 24109,
            "cityName": "KIJAL",
            "stateCode": "11",
            "postCode": "24109"
        },
        {
            "postCodeInt": 24200,
            "cityName": "KEMASEK",
            "stateCode": "11",
            "postCode": "24200"
        },
        {
            "postCodeInt": 24207,
            "cityName": "KEMASEK",
            "stateCode": "11",
            "postCode": "24207"
        },
        {
            "postCodeInt": 24209,
            "cityName": "KEMASEK",
            "stateCode": "11",
            "postCode": "24209"
        },
        {
            "postCodeInt": 24210,
            "cityName": "KEMASEK",
            "stateCode": "11",
            "postCode": "24210"
        },
        {
            "postCodeInt": 24300,
            "cityName": "KERTEH",
            "stateCode": "11",
            "postCode": "24300"
        },
        {
            "postCodeInt": 24520,
            "cityName": "KAMPONG BARU",
            "stateCode": "11",
            "postCode": "24520"
        },
        {
            "postCodeInt": 88000,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88000"
        },
        {
            "postCodeInt": 88100,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88100"
        },
        {
            "postCodeInt": 88200,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88200"
        },
        {
            "postCodeInt": 88300,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88300"
        },
        {
            "postCodeInt": 88400,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88400"
        },
        {
            "postCodeInt": 88450,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88450"
        },
        {
            "postCodeInt": 88460,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88460"
        },
        {
            "postCodeInt": 88500,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88500"
        },
        {
            "postCodeInt": 88502,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88502"
        },
        {
            "postCodeInt": 88504,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88504"
        },
        {
            "postCodeInt": 88505,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88505"
        },
        {
            "postCodeInt": 88506,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88506"
        },
        {
            "postCodeInt": 88508,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88508"
        },
        {
            "postCodeInt": 88510,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88510"
        },
        {
            "postCodeInt": 88512,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88512"
        },
        {
            "postCodeInt": 88514,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88514"
        },
        {
            "postCodeInt": 88516,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88516"
        },
        {
            "postCodeInt": 88518,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88518"
        },
        {
            "postCodeInt": 88520,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88520"
        },
        {
            "postCodeInt": 88526,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88526"
        },
        {
            "postCodeInt": 88527,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88527"
        },
        {
            "postCodeInt": 88532,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88532"
        },
        {
            "postCodeInt": 88534,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88534"
        },
        {
            "postCodeInt": 88538,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88538"
        },
        {
            "postCodeInt": 88540,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88540"
        },
        {
            "postCodeInt": 88546,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88546"
        },
        {
            "postCodeInt": 88550,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88550"
        },
        {
            "postCodeInt": 88551,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88551"
        },
        {
            "postCodeInt": 88552,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88552"
        },
        {
            "postCodeInt": 88554,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88554"
        },
        {
            "postCodeInt": 88556,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88556"
        },
        {
            "postCodeInt": 88558,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88558"
        },
        {
            "postCodeInt": 88560,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88560"
        },
        {
            "postCodeInt": 88562,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88562"
        },
        {
            "postCodeInt": 88564,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88564"
        },
        {
            "postCodeInt": 88566,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88566"
        },
        {
            "postCodeInt": 88568,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88568"
        },
        {
            "postCodeInt": 88570,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88570"
        },
        {
            "postCodeInt": 88572,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88572"
        },
        {
            "postCodeInt": 88576,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88576"
        },
        {
            "postCodeInt": 88580,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88580"
        },
        {
            "postCodeInt": 88582,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88582"
        },
        {
            "postCodeInt": 88586,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88586"
        },
        {
            "postCodeInt": 88590,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88590"
        },
        {
            "postCodeInt": 88592,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88592"
        },
        {
            "postCodeInt": 88594,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88594"
        },
        {
            "postCodeInt": 88596,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88596"
        },
        {
            "postCodeInt": 88598,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88598"
        },
        {
            "postCodeInt": 88600,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88600"
        },
        {
            "postCodeInt": 88602,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88602"
        },
        {
            "postCodeInt": 88604,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88604"
        },
        {
            "postCodeInt": 88606,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88606"
        },
        {
            "postCodeInt": 88608,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88608"
        },
        {
            "postCodeInt": 88609,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88609"
        },
        {
            "postCodeInt": 88610,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88610"
        },
        {
            "postCodeInt": 88612,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88612"
        },
        {
            "postCodeInt": 88614,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88614"
        },
        {
            "postCodeInt": 88617,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88617"
        },
        {
            "postCodeInt": 88618,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88618"
        },
        {
            "postCodeInt": 88620,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88620"
        },
        {
            "postCodeInt": 88621,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88621"
        },
        {
            "postCodeInt": 88622,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88622"
        },
        {
            "postCodeInt": 88624,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88624"
        },
        {
            "postCodeInt": 88626,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88626"
        },
        {
            "postCodeInt": 88628,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88628"
        },
        {
            "postCodeInt": 88630,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88630"
        },
        {
            "postCodeInt": 88632,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88632"
        },
        {
            "postCodeInt": 88634,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88634"
        },
        {
            "postCodeInt": 88644,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88644"
        },
        {
            "postCodeInt": 88646,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88646"
        },
        {
            "postCodeInt": 88648,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88648"
        },
        {
            "postCodeInt": 88656,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88656"
        },
        {
            "postCodeInt": 88658,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88658"
        },
        {
            "postCodeInt": 88660,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88660"
        },
        {
            "postCodeInt": 88661,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88661"
        },
        {
            "postCodeInt": 88662,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88662"
        },
        {
            "postCodeInt": 88670,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88670"
        },
        {
            "postCodeInt": 88672,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88672"
        },
        {
            "postCodeInt": 88673,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88673"
        },
        {
            "postCodeInt": 88675,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88675"
        },
        {
            "postCodeInt": 88676,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88676"
        },
        {
            "postCodeInt": 88680,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88680"
        },
        {
            "postCodeInt": 88690,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88690"
        },
        {
            "postCodeInt": 88700,
            "cityName": "BEVERLY",
            "stateCode": "12",
            "postCode": "88700"
        },
        {
            "postCodeInt": 88721,
            "cityName": "PUTATAN",
            "stateCode": "12",
            "postCode": "88721"
        },
        {
            "postCodeInt": 88722,
            "cityName": "PUTATAN",
            "stateCode": "12",
            "postCode": "88722"
        },
        {
            "postCodeInt": 88723,
            "cityName": "PUTATAN",
            "stateCode": "12",
            "postCode": "88723"
        },
        {
            "postCodeInt": 88724,
            "cityName": "PUTATAN",
            "stateCode": "12",
            "postCode": "88724"
        },
        {
            "postCodeInt": 88725,
            "cityName": "PUTATAN",
            "stateCode": "12",
            "postCode": "88725"
        },
        {
            "postCodeInt": 88757,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88757"
        },
        {
            "postCodeInt": 88758,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88758"
        },
        {
            "postCodeInt": 88759,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88759"
        },
        {
            "postCodeInt": 88760,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88760"
        },
        {
            "postCodeInt": 88761,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88761"
        },
        {
            "postCodeInt": 88762,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88762"
        },
        {
            "postCodeInt": 88763,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88763"
        },
        {
            "postCodeInt": 88764,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88764"
        },
        {
            "postCodeInt": 88765,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88765"
        },
        {
            "postCodeInt": 88766,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88766"
        },
        {
            "postCodeInt": 88767,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88767"
        },
        {
            "postCodeInt": 88768,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88768"
        },
        {
            "postCodeInt": 88769,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88769"
        },
        {
            "postCodeInt": 88770,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88770"
        },
        {
            "postCodeInt": 88771,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88771"
        },
        {
            "postCodeInt": 88772,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88772"
        },
        {
            "postCodeInt": 88773,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88773"
        },
        {
            "postCodeInt": 88774,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88774"
        },
        {
            "postCodeInt": 88775,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88775"
        },
        {
            "postCodeInt": 88776,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88776"
        },
        {
            "postCodeInt": 88777,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88777"
        },
        {
            "postCodeInt": 88778,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88778"
        },
        {
            "postCodeInt": 88779,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88779"
        },
        {
            "postCodeInt": 88780,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88780"
        },
        {
            "postCodeInt": 88781,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88781"
        },
        {
            "postCodeInt": 88782,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88782"
        },
        {
            "postCodeInt": 88783,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88783"
        },
        {
            "postCodeInt": 88784,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88784"
        },
        {
            "postCodeInt": 88785,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88785"
        },
        {
            "postCodeInt": 88786,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88786"
        },
        {
            "postCodeInt": 88787,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88787"
        },
        {
            "postCodeInt": 88788,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88788"
        },
        {
            "postCodeInt": 88789,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88789"
        },
        {
            "postCodeInt": 88790,
            "cityName": "LUYANG",
            "stateCode": "12",
            "postCode": "88790"
        },
        {
            "postCodeInt": 88800,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88800"
        },
        {
            "postCodeInt": 88801,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88801"
        },
        {
            "postCodeInt": 88802,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88802"
        },
        {
            "postCodeInt": 88803,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88803"
        },
        {
            "postCodeInt": 88804,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88804"
        },
        {
            "postCodeInt": 88805,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88805"
        },
        {
            "postCodeInt": 88806,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88806"
        },
        {
            "postCodeInt": 88807,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88807"
        },
        {
            "postCodeInt": 88808,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88808"
        },
        {
            "postCodeInt": 88809,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88809"
        },
        {
            "postCodeInt": 88810,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88810"
        },
        {
            "postCodeInt": 88811,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88811"
        },
        {
            "postCodeInt": 88812,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88812"
        },
        {
            "postCodeInt": 88813,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88813"
        },
        {
            "postCodeInt": 88814,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88814"
        },
        {
            "postCodeInt": 88815,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88815"
        },
        {
            "postCodeInt": 88816,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88816"
        },
        {
            "postCodeInt": 88817,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88817"
        },
        {
            "postCodeInt": 88818,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88818"
        },
        {
            "postCodeInt": 88819,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88819"
        },
        {
            "postCodeInt": 88820,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88820"
        },
        {
            "postCodeInt": 88821,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88821"
        },
        {
            "postCodeInt": 88822,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88822"
        },
        {
            "postCodeInt": 88823,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88823"
        },
        {
            "postCodeInt": 88824,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88824"
        },
        {
            "postCodeInt": 88825,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88825"
        },
        {
            "postCodeInt": 88826,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88826"
        },
        {
            "postCodeInt": 88827,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88827"
        },
        {
            "postCodeInt": 88828,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88828"
        },
        {
            "postCodeInt": 88829,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88829"
        },
        {
            "postCodeInt": 88830,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88830"
        },
        {
            "postCodeInt": 88831,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88831"
        },
        {
            "postCodeInt": 88832,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88832"
        },
        {
            "postCodeInt": 88833,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88833"
        },
        {
            "postCodeInt": 88834,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88834"
        },
        {
            "postCodeInt": 88835,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88835"
        },
        {
            "postCodeInt": 88836,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88836"
        },
        {
            "postCodeInt": 88837,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88837"
        },
        {
            "postCodeInt": 88838,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88838"
        },
        {
            "postCodeInt": 88839,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88839"
        },
        {
            "postCodeInt": 88840,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88840"
        },
        {
            "postCodeInt": 88841,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88841"
        },
        {
            "postCodeInt": 88842,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88842"
        },
        {
            "postCodeInt": 88843,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88843"
        },
        {
            "postCodeInt": 88844,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88844"
        },
        {
            "postCodeInt": 88845,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88845"
        },
        {
            "postCodeInt": 88846,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88846"
        },
        {
            "postCodeInt": 88847,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88847"
        },
        {
            "postCodeInt": 88848,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88848"
        },
        {
            "postCodeInt": 88849,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88849"
        },
        {
            "postCodeInt": 88850,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88850"
        },
        {
            "postCodeInt": 88851,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88851"
        },
        {
            "postCodeInt": 88852,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88852"
        },
        {
            "postCodeInt": 88853,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88853"
        },
        {
            "postCodeInt": 88854,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88854"
        },
        {
            "postCodeInt": 88855,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88855"
        },
        {
            "postCodeInt": 88856,
            "cityName": "LIKAS",
            "stateCode": "12",
            "postCode": "88856"
        },
        {
            "postCodeInt": 88857,
            "cityName": "INANAM",
            "stateCode": "12",
            "postCode": "88857"
        },
        {
            "postCodeInt": 88858,
            "cityName": "TANJUNG ARU",
            "stateCode": "12",
            "postCode": "88858"
        },
        {
            "postCodeInt": 88859,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88859"
        },
        {
            "postCodeInt": 88860,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88860"
        },
        {
            "postCodeInt": 88861,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88861"
        },
        {
            "postCodeInt": 88862,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88862"
        },
        {
            "postCodeInt": 88863,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88863"
        },
        {
            "postCodeInt": 88865,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88865"
        },
        {
            "postCodeInt": 88866,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88866"
        },
        {
            "postCodeInt": 88867,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88867"
        },
        {
            "postCodeInt": 88868,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88868"
        },
        {
            "postCodeInt": 88869,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88869"
        },
        {
            "postCodeInt": 88870,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88870"
        },
        {
            "postCodeInt": 88871,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88871"
        },
        {
            "postCodeInt": 88872,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88872"
        },
        {
            "postCodeInt": 88873,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88873"
        },
        {
            "postCodeInt": 88874,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88874"
        },
        {
            "postCodeInt": 88875,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88875"
        },
        {
            "postCodeInt": 88900,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88900"
        },
        {
            "postCodeInt": 88901,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88901"
        },
        {
            "postCodeInt": 88902,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88902"
        },
        {
            "postCodeInt": 88903,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88903"
        },
        {
            "postCodeInt": 88904,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88904"
        },
        {
            "postCodeInt": 88905,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88905"
        },
        {
            "postCodeInt": 88906,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88906"
        },
        {
            "postCodeInt": 88988,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88988"
        },
        {
            "postCodeInt": 88990,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88990"
        },
        {
            "postCodeInt": 88991,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88991"
        },
        {
            "postCodeInt": 88992,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88992"
        },
        {
            "postCodeInt": 88993,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88993"
        },
        {
            "postCodeInt": 88994,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88994"
        },
        {
            "postCodeInt": 88995,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88995"
        },
        {
            "postCodeInt": 88996,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88996"
        },
        {
            "postCodeInt": 88997,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88997"
        },
        {
            "postCodeInt": 88998,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88998"
        },
        {
            "postCodeInt": 88999,
            "cityName": "KOTA KINABALU",
            "stateCode": "12",
            "postCode": "88999"
        },
        {
            "postCodeInt": 89000,
            "cityName": "KENINGAU",
            "stateCode": "12",
            "postCode": "89000"
        },
        {
            "postCodeInt": 89007,
            "cityName": "KENINGAU",
            "stateCode": "12",
            "postCode": "89007"
        },
        {
            "postCodeInt": 89008,
            "cityName": "KENINGAU",
            "stateCode": "12",
            "postCode": "89008"
        },
        {
            "postCodeInt": 89009,
            "cityName": "KENINGAU",
            "stateCode": "12",
            "postCode": "89009"
        },
        {
            "postCodeInt": 89050,
            "cityName": "KUDAT",
            "stateCode": "12",
            "postCode": "89050"
        },
        {
            "postCodeInt": 89057,
            "cityName": "KUDAT",
            "stateCode": "12",
            "postCode": "89057"
        },
        {
            "postCodeInt": 89058,
            "cityName": "KUDAT",
            "stateCode": "12",
            "postCode": "89058"
        },
        {
            "postCodeInt": 89059,
            "cityName": "KUDAT",
            "stateCode": "12",
            "postCode": "89059"
        },
        {
            "postCodeInt": 89100,
            "cityName": "KOTA MARUDU",
            "stateCode": "12",
            "postCode": "89100"
        },
        {
            "postCodeInt": 89107,
            "cityName": "KOTA MARUDU",
            "stateCode": "12",
            "postCode": "89107"
        },
        {
            "postCodeInt": 89108,
            "cityName": "KOTA MARUDU",
            "stateCode": "12",
            "postCode": "89108"
        },
        {
            "postCodeInt": 89109,
            "cityName": "KOTA MARUDU",
            "stateCode": "12",
            "postCode": "89109"
        },
        {
            "postCodeInt": 89150,
            "cityName": "KOTA BELUD",
            "stateCode": "12",
            "postCode": "89150"
        },
        {
            "postCodeInt": 89157,
            "cityName": "KOTA BELUD",
            "stateCode": "12",
            "postCode": "89157"
        },
        {
            "postCodeInt": 89158,
            "cityName": "KOTA BELUD",
            "stateCode": "12",
            "postCode": "89158"
        },
        {
            "postCodeInt": 89159,
            "cityName": "KOTA BELUD",
            "stateCode": "12",
            "postCode": "89159"
        },
        {
            "postCodeInt": 89200,
            "cityName": "TUARAN",
            "stateCode": "12",
            "postCode": "89200"
        },
        {
            "postCodeInt": 89207,
            "cityName": "TUARAN",
            "stateCode": "12",
            "postCode": "89207"
        },
        {
            "postCodeInt": 89208,
            "cityName": "TUARAN",
            "stateCode": "12",
            "postCode": "89208"
        },
        {
            "postCodeInt": 89209,
            "cityName": "TUARAN",
            "stateCode": "12",
            "postCode": "89209"
        },
        {
            "postCodeInt": 89250,
            "cityName": "TAMPARULI",
            "stateCode": "12",
            "postCode": "89250"
        },
        {
            "postCodeInt": 89257,
            "cityName": "TAMPARULI",
            "stateCode": "12",
            "postCode": "89257"
        },
        {
            "postCodeInt": 89258,
            "cityName": "TAMPARULI",
            "stateCode": "12",
            "postCode": "89258"
        },
        {
            "postCodeInt": 89259,
            "cityName": "TAMPARULI",
            "stateCode": "12",
            "postCode": "89259"
        },
        {
            "postCodeInt": 89260,
            "cityName": "TENGHILAN",
            "stateCode": "12",
            "postCode": "89260"
        },
        {
            "postCodeInt": 89300,
            "cityName": "RANAU",
            "stateCode": "12",
            "postCode": "89300"
        },
        {
            "postCodeInt": 89307,
            "cityName": "RANAU",
            "stateCode": "12",
            "postCode": "89307"
        },
        {
            "postCodeInt": 89308,
            "cityName": "RANAU",
            "stateCode": "12",
            "postCode": "89308"
        },
        {
            "postCodeInt": 89309,
            "cityName": "RANAU",
            "stateCode": "12",
            "postCode": "89309"
        },
        {
            "postCodeInt": 89500,
            "cityName": "PENAMPANG",
            "stateCode": "12",
            "postCode": "89500"
        },
        {
            "postCodeInt": 89507,
            "cityName": "PENAMPANG",
            "stateCode": "12",
            "postCode": "89507"
        },
        {
            "postCodeInt": 89508,
            "cityName": "PENAMPANG",
            "stateCode": "12",
            "postCode": "89508"
        },
        {
            "postCodeInt": 89509,
            "cityName": "PENAMPANG",
            "stateCode": "12",
            "postCode": "89509"
        },
        {
            "postCodeInt": 89600,
            "cityName": "PAPAR",
            "stateCode": "12",
            "postCode": "89600"
        },
        {
            "postCodeInt": 89607,
            "cityName": "PAPAR",
            "stateCode": "12",
            "postCode": "89607"
        },
        {
            "postCodeInt": 89608,
            "cityName": "PAPAR",
            "stateCode": "12",
            "postCode": "89608"
        },
        {
            "postCodeInt": 89609,
            "cityName": "PAPAR",
            "stateCode": "12",
            "postCode": "89609"
        },
        {
            "postCodeInt": 89650,
            "cityName": "TAMBUNAN",
            "stateCode": "12",
            "postCode": "89650"
        },
        {
            "postCodeInt": 89657,
            "cityName": "TAMBUNAN",
            "stateCode": "12",
            "postCode": "89657"
        },
        {
            "postCodeInt": 89658,
            "cityName": "TAMBUNAN",
            "stateCode": "12",
            "postCode": "89658"
        },
        {
            "postCodeInt": 89659,
            "cityName": "TAMBUNAN",
            "stateCode": "12",
            "postCode": "89659"
        },
        {
            "postCodeInt": 89700,
            "cityName": "BONGAWAN",
            "stateCode": "12",
            "postCode": "89700"
        },
        {
            "postCodeInt": 89707,
            "cityName": "BONGAWAN",
            "stateCode": "12",
            "postCode": "89707"
        },
        {
            "postCodeInt": 89708,
            "cityName": "BONGAWAN",
            "stateCode": "12",
            "postCode": "89708"
        },
        {
            "postCodeInt": 89709,
            "cityName": "BONGAWAN",
            "stateCode": "12",
            "postCode": "89709"
        },
        {
            "postCodeInt": 89720,
            "cityName": "MEMBAKUT",
            "stateCode": "12",
            "postCode": "89720"
        },
        {
            "postCodeInt": 89727,
            "cityName": "MEMBAKUT",
            "stateCode": "12",
            "postCode": "89727"
        },
        {
            "postCodeInt": 89728,
            "cityName": "MEMBAKUT",
            "stateCode": "12",
            "postCode": "89728"
        },
        {
            "postCodeInt": 89729,
            "cityName": "MEMBAKUT",
            "stateCode": "12",
            "postCode": "89729"
        },
        {
            "postCodeInt": 89740,
            "cityName": "KUALA PENYU",
            "stateCode": "12",
            "postCode": "89740"
        },
        {
            "postCodeInt": 89747,
            "cityName": "KUALA PENYU",
            "stateCode": "12",
            "postCode": "89747"
        },
        {
            "postCodeInt": 89748,
            "cityName": "KUALA PENYU",
            "stateCode": "12",
            "postCode": "89748"
        },
        {
            "postCodeInt": 89749,
            "cityName": "KUALA PENYU",
            "stateCode": "12",
            "postCode": "89749"
        },
        {
            "postCodeInt": 89760,
            "cityName": "MENUMBOK",
            "stateCode": "12",
            "postCode": "89760"
        },
        {
            "postCodeInt": 89767,
            "cityName": "MENUMBOK",
            "stateCode": "12",
            "postCode": "89767"
        },
        {
            "postCodeInt": 89768,
            "cityName": "MENUMBOK",
            "stateCode": "12",
            "postCode": "89768"
        },
        {
            "postCodeInt": 89769,
            "cityName": "MENUMBOK",
            "stateCode": "12",
            "postCode": "89769"
        },
        {
            "postCodeInt": 89800,
            "cityName": "BEAUFORT",
            "stateCode": "12",
            "postCode": "89800"
        },
        {
            "postCodeInt": 89807,
            "cityName": "BEAUFORT",
            "stateCode": "12",
            "postCode": "89807"
        },
        {
            "postCodeInt": 89808,
            "cityName": "BEAUFORT",
            "stateCode": "12",
            "postCode": "89808"
        },
        {
            "postCodeInt": 89809,
            "cityName": "BEAUFORT",
            "stateCode": "12",
            "postCode": "89809"
        },
        {
            "postCodeInt": 89850,
            "cityName": "SIPITANG",
            "stateCode": "12",
            "postCode": "89850"
        },
        {
            "postCodeInt": 89857,
            "cityName": "SIPITANG",
            "stateCode": "12",
            "postCode": "89857"
        },
        {
            "postCodeInt": 89858,
            "cityName": "SIPITANG",
            "stateCode": "12",
            "postCode": "89858"
        },
        {
            "postCodeInt": 89859,
            "cityName": "SIPITANG",
            "stateCode": "12",
            "postCode": "89859"
        },
        {
            "postCodeInt": 89900,
            "cityName": "TENOM",
            "stateCode": "12",
            "postCode": "89900"
        },
        {
            "postCodeInt": 89907,
            "cityName": "TENOM",
            "stateCode": "12",
            "postCode": "89907"
        },
        {
            "postCodeInt": 89908,
            "cityName": "TENOM",
            "stateCode": "12",
            "postCode": "89908"
        },
        {
            "postCodeInt": 89909,
            "cityName": "TENOM",
            "stateCode": "12",
            "postCode": "89909"
        },
        {
            "postCodeInt": 89950,
            "cityName": "NABAWAN",
            "stateCode": "12",
            "postCode": "89950"
        },
        {
            "postCodeInt": 89957,
            "cityName": "NABAWAN",
            "stateCode": "12",
            "postCode": "89957"
        },
        {
            "postCodeInt": 89958,
            "cityName": "NABAWAN",
            "stateCode": "12",
            "postCode": "89958"
        },
        {
            "postCodeInt": 89959,
            "cityName": "NABAWAN",
            "stateCode": "12",
            "postCode": "89959"
        },
        {
            "postCodeInt": 90000,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90000"
        },
        {
            "postCodeInt": 90009,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90009"
        },
        {
            "postCodeInt": 90100,
            "cityName": "BELURAN",
            "stateCode": "12",
            "postCode": "90100"
        },
        {
            "postCodeInt": 90107,
            "cityName": "BELURAN",
            "stateCode": "12",
            "postCode": "90107"
        },
        {
            "postCodeInt": 90109,
            "cityName": "BELURAN",
            "stateCode": "12",
            "postCode": "90109"
        },
        {
            "postCodeInt": 90200,
            "cityName": "KOTA KINABATANGAN",
            "stateCode": "12",
            "postCode": "90200"
        },
        {
            "postCodeInt": 90300,
            "cityName": "KOTA KINABATANGAN",
            "stateCode": "12",
            "postCode": "90300"
        },
        {
            "postCodeInt": 90307,
            "cityName": "KOTA KINABATANGAN",
            "stateCode": "12",
            "postCode": "90307"
        },
        {
            "postCodeInt": 90400,
            "cityName": "PAMOL",
            "stateCode": "12",
            "postCode": "90400"
        },
        {
            "postCodeInt": 90700,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90700"
        },
        {
            "postCodeInt": 90701,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90701"
        },
        {
            "postCodeInt": 90702,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90702"
        },
        {
            "postCodeInt": 90703,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90703"
        },
        {
            "postCodeInt": 90704,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90704"
        },
        {
            "postCodeInt": 90705,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90705"
        },
        {
            "postCodeInt": 90706,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90706"
        },
        {
            "postCodeInt": 90707,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90707"
        },
        {
            "postCodeInt": 90708,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90708"
        },
        {
            "postCodeInt": 90709,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90709"
        },
        {
            "postCodeInt": 90711,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90711"
        },
        {
            "postCodeInt": 90712,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90712"
        },
        {
            "postCodeInt": 90713,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90713"
        },
        {
            "postCodeInt": 90714,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90714"
        },
        {
            "postCodeInt": 90715,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90715"
        },
        {
            "postCodeInt": 90716,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90716"
        },
        {
            "postCodeInt": 90717,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90717"
        },
        {
            "postCodeInt": 90718,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90718"
        },
        {
            "postCodeInt": 90719,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90719"
        },
        {
            "postCodeInt": 90720,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90720"
        },
        {
            "postCodeInt": 90721,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90721"
        },
        {
            "postCodeInt": 90722,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90722"
        },
        {
            "postCodeInt": 90723,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90723"
        },
        {
            "postCodeInt": 90724,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90724"
        },
        {
            "postCodeInt": 90725,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90725"
        },
        {
            "postCodeInt": 90726,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90726"
        },
        {
            "postCodeInt": 90727,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90727"
        },
        {
            "postCodeInt": 90728,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90728"
        },
        {
            "postCodeInt": 90729,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90729"
        },
        {
            "postCodeInt": 90730,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90730"
        },
        {
            "postCodeInt": 90731,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90731"
        },
        {
            "postCodeInt": 90732,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90732"
        },
        {
            "postCodeInt": 90733,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90733"
        },
        {
            "postCodeInt": 90734,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90734"
        },
        {
            "postCodeInt": 90735,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90735"
        },
        {
            "postCodeInt": 90736,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90736"
        },
        {
            "postCodeInt": 90737,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90737"
        },
        {
            "postCodeInt": 90738,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90738"
        },
        {
            "postCodeInt": 90739,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90739"
        },
        {
            "postCodeInt": 90740,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90740"
        },
        {
            "postCodeInt": 90741,
            "cityName": "SANDAKAN",
            "stateCode": "12",
            "postCode": "90741"
        },
        {
            "postCodeInt": 91000,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91000"
        },
        {
            "postCodeInt": 91007,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91007"
        },
        {
            "postCodeInt": 91008,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91008"
        },
        {
            "postCodeInt": 91009,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91009"
        },
        {
            "postCodeInt": 91010,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91010"
        },
        {
            "postCodeInt": 91011,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91011"
        },
        {
            "postCodeInt": 91012,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91012"
        },
        {
            "postCodeInt": 91013,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91013"
        },
        {
            "postCodeInt": 91014,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91014"
        },
        {
            "postCodeInt": 91015,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91015"
        },
        {
            "postCodeInt": 91016,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91016"
        },
        {
            "postCodeInt": 91017,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91017"
        },
        {
            "postCodeInt": 91018,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91018"
        },
        {
            "postCodeInt": 91019,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91019"
        },
        {
            "postCodeInt": 91020,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91020"
        },
        {
            "postCodeInt": 91021,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91021"
        },
        {
            "postCodeInt": 91022,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91022"
        },
        {
            "postCodeInt": 91023,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91023"
        },
        {
            "postCodeInt": 91024,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91024"
        },
        {
            "postCodeInt": 91025,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91025"
        },
        {
            "postCodeInt": 91026,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91026"
        },
        {
            "postCodeInt": 91027,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91027"
        },
        {
            "postCodeInt": 91028,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91028"
        },
        {
            "postCodeInt": 91029,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91029"
        },
        {
            "postCodeInt": 91030,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91030"
        },
        {
            "postCodeInt": 91031,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91031"
        },
        {
            "postCodeInt": 91032,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91032"
        },
        {
            "postCodeInt": 91033,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91033"
        },
        {
            "postCodeInt": 91034,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91034"
        },
        {
            "postCodeInt": 91035,
            "cityName": "TAWAU",
            "stateCode": "12",
            "postCode": "91035"
        },
        {
            "postCodeInt": 91100,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91100"
        },
        {
            "postCodeInt": 91109,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91109"
        },
        {
            "postCodeInt": 91110,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91110"
        },
        {
            "postCodeInt": 91111,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91111"
        },
        {
            "postCodeInt": 91112,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91112"
        },
        {
            "postCodeInt": 91113,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91113"
        },
        {
            "postCodeInt": 91114,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91114"
        },
        {
            "postCodeInt": 91115,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91115"
        },
        {
            "postCodeInt": 91116,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91116"
        },
        {
            "postCodeInt": 91117,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91117"
        },
        {
            "postCodeInt": 91118,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91118"
        },
        {
            "postCodeInt": 91119,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91119"
        },
        {
            "postCodeInt": 91120,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91120"
        },
        {
            "postCodeInt": 91121,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91121"
        },
        {
            "postCodeInt": 91122,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91122"
        },
        {
            "postCodeInt": 91123,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91123"
        },
        {
            "postCodeInt": 91124,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91124"
        },
        {
            "postCodeInt": 91125,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91125"
        },
        {
            "postCodeInt": 91126,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91126"
        },
        {
            "postCodeInt": 91127,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91127"
        },
        {
            "postCodeInt": 91128,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91128"
        },
        {
            "postCodeInt": 91150,
            "cityName": "LAHAD DATU",
            "stateCode": "12",
            "postCode": "91150"
        },
        {
            "postCodeInt": 91200,
            "cityName": "KUNAK",
            "stateCode": "12",
            "postCode": "91200"
        },
        {
            "postCodeInt": 91207,
            "cityName": "KUNAK",
            "stateCode": "12",
            "postCode": "91207"
        },
        {
            "postCodeInt": 91209,
            "cityName": "KUNAK",
            "stateCode": "12",
            "postCode": "91209"
        },
        {
            "postCodeInt": 91300,
            "cityName": "SEMPORNA",
            "stateCode": "12",
            "postCode": "91300"
        },
        {
            "postCodeInt": 91307,
            "cityName": "SEMPORNA",
            "stateCode": "12",
            "postCode": "91307"
        },
        {
            "postCodeInt": 91308,
            "cityName": "SEMPORNA",
            "stateCode": "12",
            "postCode": "91308"
        },
        {
            "postCodeInt": 91309,
            "cityName": "SEMPORNA",
            "stateCode": "12",
            "postCode": "91309"
        },
        {
            "postCodeInt": 87010,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87010"
        },
        {
            "postCodeInt": 87011,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87011"
        },
        {
            "postCodeInt": 87012,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87012"
        },
        {
            "postCodeInt": 87023,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87023"
        },
        {
            "postCodeInt": 87029,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87029"
        },
        {
            "postCodeInt": 87014,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87014"
        },
        {
            "postCodeInt": 87015,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87015"
        },
        {
            "postCodeInt": 87016,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87016"
        },
        {
            "postCodeInt": 87017,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87017"
        },
        {
            "postCodeInt": 87026,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87026"
        },
        {
            "postCodeInt": 87027,
            "cityName": "LABUAN",
            "stateCode": "12",
            "postCode": "87027"
        },
        {
            "postCodeInt": 93000,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93000"
        },
        {
            "postCodeInt": 93010,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93010"
        },
        {
            "postCodeInt": 93030,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93030"
        },
        {
            "postCodeInt": 93050,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93050"
        },
        {
            "postCodeInt": 93100,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93100"
        },
        {
            "postCodeInt": 93150,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93150"
        },
        {
            "postCodeInt": 93200,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93200"
        },
        {
            "postCodeInt": 93250,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93250"
        },
        {
            "postCodeInt": 93300,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93300"
        },
        {
            "postCodeInt": 93350,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93350"
        },
        {
            "postCodeInt": 93400,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93400"
        },
        {
            "postCodeInt": 93450,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93450"
        },
        {
            "postCodeInt": 93500,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93500"
        },
        {
            "postCodeInt": 93502,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93502"
        },
        {
            "postCodeInt": 93503,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93503"
        },
        {
            "postCodeInt": 93504,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93504"
        },
        {
            "postCodeInt": 93505,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93505"
        },
        {
            "postCodeInt": 93506,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93506"
        },
        {
            "postCodeInt": 93507,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93507"
        },
        {
            "postCodeInt": 93508,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93508"
        },
        {
            "postCodeInt": 93514,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93514"
        },
        {
            "postCodeInt": 93516,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93516"
        },
        {
            "postCodeInt": 93517,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93517"
        },
        {
            "postCodeInt": 93518,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93518"
        },
        {
            "postCodeInt": 93519,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93519"
        },
        {
            "postCodeInt": 93520,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93520"
        },
        {
            "postCodeInt": 93527,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93527"
        },
        {
            "postCodeInt": 93529,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93529"
        },
        {
            "postCodeInt": 93532,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93532"
        },
        {
            "postCodeInt": 93540,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93540"
        },
        {
            "postCodeInt": 93550,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93550"
        },
        {
            "postCodeInt": 93551,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93551"
        },
        {
            "postCodeInt": 93552,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93552"
        },
        {
            "postCodeInt": 93554,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93554"
        },
        {
            "postCodeInt": 93556,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93556"
        },
        {
            "postCodeInt": 93558,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93558"
        },
        {
            "postCodeInt": 93560,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93560"
        },
        {
            "postCodeInt": 93564,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93564"
        },
        {
            "postCodeInt": 93566,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93566"
        },
        {
            "postCodeInt": 93570,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93570"
        },
        {
            "postCodeInt": 93572,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93572"
        },
        {
            "postCodeInt": 93576,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93576"
        },
        {
            "postCodeInt": 93578,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93578"
        },
        {
            "postCodeInt": 93582,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93582"
        },
        {
            "postCodeInt": 93586,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93586"
        },
        {
            "postCodeInt": 93590,
            "cityName": "JABATAN KESIHATAN",
            "stateCode": "13",
            "postCode": "93590"
        },
        {
            "postCodeInt": 93592,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93592"
        },
        {
            "postCodeInt": 93594,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93594"
        },
        {
            "postCodeInt": 93596,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93596"
        },
        {
            "postCodeInt": 93598,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93598"
        },
        {
            "postCodeInt": 93600,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93600"
        },
        {
            "postCodeInt": 93604,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93604"
        },
        {
            "postCodeInt": 93606,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93606"
        },
        {
            "postCodeInt": 93608,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93608"
        },
        {
            "postCodeInt": 93609,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93609"
        },
        {
            "postCodeInt": 93610,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93610"
        },
        {
            "postCodeInt": 93612,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93612"
        },
        {
            "postCodeInt": 93614,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93614"
        },
        {
            "postCodeInt": 93618,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93618"
        },
        {
            "postCodeInt": 93619,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93619"
        },
        {
            "postCodeInt": 93620,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93620"
        },
        {
            "postCodeInt": 93626,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93626"
        },
        {
            "postCodeInt": 93628,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93628"
        },
        {
            "postCodeInt": 93632,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93632"
        },
        {
            "postCodeInt": 93634,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93634"
        },
        {
            "postCodeInt": 93648,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93648"
        },
        {
            "postCodeInt": 93658,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93658"
        },
        {
            "postCodeInt": 93660,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93660"
        },
        {
            "postCodeInt": 93661,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93661"
        },
        {
            "postCodeInt": 93662,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93662"
        },
        {
            "postCodeInt": 93668,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93668"
        },
        {
            "postCodeInt": 93670,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93670"
        },
        {
            "postCodeInt": 93672,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93672"
        },
        {
            "postCodeInt": 93677,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93677"
        },
        {
            "postCodeInt": 93690,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93690"
        },
        {
            "postCodeInt": 93694,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93694"
        },
        {
            "postCodeInt": 93700,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93700"
        },
        {
            "postCodeInt": 93702,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93702"
        },
        {
            "postCodeInt": 93704,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93704"
        },
        {
            "postCodeInt": 93706,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93706"
        },
        {
            "postCodeInt": 93708,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93708"
        },
        {
            "postCodeInt": 93710,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93710"
        },
        {
            "postCodeInt": 93712,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93712"
        },
        {
            "postCodeInt": 93714,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93714"
        },
        {
            "postCodeInt": 93716,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93716"
        },
        {
            "postCodeInt": 93718,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93718"
        },
        {
            "postCodeInt": 93720,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93720"
        },
        {
            "postCodeInt": 93722,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93722"
        },
        {
            "postCodeInt": 93724,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93724"
        },
        {
            "postCodeInt": 93726,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93726"
        },
        {
            "postCodeInt": 93728,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93728"
        },
        {
            "postCodeInt": 93730,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93730"
        },
        {
            "postCodeInt": 93732,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93732"
        },
        {
            "postCodeInt": 93734,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93734"
        },
        {
            "postCodeInt": 93736,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93736"
        },
        {
            "postCodeInt": 93738,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93738"
        },
        {
            "postCodeInt": 93740,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93740"
        },
        {
            "postCodeInt": 93742,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93742"
        },
        {
            "postCodeInt": 93744,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93744"
        },
        {
            "postCodeInt": 93746,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93746"
        },
        {
            "postCodeInt": 93748,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93748"
        },
        {
            "postCodeInt": 93750,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93750"
        },
        {
            "postCodeInt": 93752,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93752"
        },
        {
            "postCodeInt": 93754,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93754"
        },
        {
            "postCodeInt": 93756,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93756"
        },
        {
            "postCodeInt": 93758,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93758"
        },
        {
            "postCodeInt": 93760,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93760"
        },
        {
            "postCodeInt": 93762,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93762"
        },
        {
            "postCodeInt": 93764,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93764"
        },
        {
            "postCodeInt": 93900,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93900"
        },
        {
            "postCodeInt": 93902,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93902"
        },
        {
            "postCodeInt": 93904,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93904"
        },
        {
            "postCodeInt": 93906,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93906"
        },
        {
            "postCodeInt": 93908,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93908"
        },
        {
            "postCodeInt": 93910,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93910"
        },
        {
            "postCodeInt": 93912,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93912"
        },
        {
            "postCodeInt": 93914,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93914"
        },
        {
            "postCodeInt": 93916,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93916"
        },
        {
            "postCodeInt": 93990,
            "cityName": "KUCHING",
            "stateCode": "13",
            "postCode": "93990"
        },
        {
            "postCodeInt": 94000,
            "cityName": "BAU",
            "stateCode": "13",
            "postCode": "94000"
        },
        {
            "postCodeInt": 94007,
            "cityName": "BAU",
            "stateCode": "13",
            "postCode": "94007"
        },
        {
            "postCodeInt": 94009,
            "cityName": "BAU",
            "stateCode": "13",
            "postCode": "94009"
        },
        {
            "postCodeInt": 94200,
            "cityName": "SIBURAN",
            "stateCode": "13",
            "postCode": "94200"
        },
        {
            "postCodeInt": 94300,
            "cityName": "KOTA SAMARAHAN",
            "stateCode": "13",
            "postCode": "94300"
        },
        {
            "postCodeInt": 94500,
            "cityName": "LUNDU",
            "stateCode": "13",
            "postCode": "94500"
        },
        {
            "postCodeInt": 94507,
            "cityName": "LUNDU",
            "stateCode": "13",
            "postCode": "94507"
        },
        {
            "postCodeInt": 94509,
            "cityName": "LUNDU",
            "stateCode": "13",
            "postCode": "94509"
        },
        {
            "postCodeInt": 94600,
            "cityName": "ASAJAYA",
            "stateCode": "13",
            "postCode": "94600"
        },
        {
            "postCodeInt": 94650,
            "cityName": "KABONG",
            "stateCode": "13",
            "postCode": "94650"
        },
        {
            "postCodeInt": 94700,
            "cityName": "SERIAN",
            "stateCode": "13",
            "postCode": "94700"
        },
        {
            "postCodeInt": 94707,
            "cityName": "SERIAN",
            "stateCode": "13",
            "postCode": "94707"
        },
        {
            "postCodeInt": 94709,
            "cityName": "SERIAN",
            "stateCode": "13",
            "postCode": "94709"
        },
        {
            "postCodeInt": 94750,
            "cityName": "SERIAN",
            "stateCode": "13",
            "postCode": "94750"
        },
        {
            "postCodeInt": 94760,
            "cityName": "TEBEDU",
            "stateCode": "13",
            "postCode": "94760"
        },
        {
            "postCodeInt": 94800,
            "cityName": "SIMUNJAN",
            "stateCode": "13",
            "postCode": "94800"
        },
        {
            "postCodeInt": 94807,
            "cityName": "SIMUNJAN",
            "stateCode": "13",
            "postCode": "94807"
        },
        {
            "postCodeInt": 94809,
            "cityName": "SIMUNJAN",
            "stateCode": "13",
            "postCode": "94809"
        },
        {
            "postCodeInt": 94850,
            "cityName": "SEBUYAU",
            "stateCode": "13",
            "postCode": "94850"
        },
        {
            "postCodeInt": 94900,
            "cityName": "LINGGA",
            "stateCode": "13",
            "postCode": "94900"
        },
        {
            "postCodeInt": 94950,
            "cityName": "PUSA",
            "stateCode": "13",
            "postCode": "94950"
        },
        {
            "postCodeInt": 95000,
            "cityName": "SRI AMAN",
            "stateCode": "13",
            "postCode": "95000"
        },
        {
            "postCodeInt": 95007,
            "cityName": "SRI AMAN",
            "stateCode": "13",
            "postCode": "95007"
        },
        {
            "postCodeInt": 95008,
            "cityName": "SRI AMAN",
            "stateCode": "13",
            "postCode": "95008"
        },
        {
            "postCodeInt": 95009,
            "cityName": "SRI AMAN",
            "stateCode": "13",
            "postCode": "95009"
        },
        {
            "postCodeInt": 95300,
            "cityName": "ROBAN",
            "stateCode": "13",
            "postCode": "95300"
        },
        {
            "postCodeInt": 95400,
            "cityName": "SARATOK",
            "stateCode": "13",
            "postCode": "95400"
        },
        {
            "postCodeInt": 95407,
            "cityName": "SARATOK",
            "stateCode": "13",
            "postCode": "95407"
        },
        {
            "postCodeInt": 95409,
            "cityName": "SARATOK",
            "stateCode": "13",
            "postCode": "95409"
        },
        {
            "postCodeInt": 95500,
            "cityName": "DEBAK",
            "stateCode": "13",
            "postCode": "95500"
        },
        {
            "postCodeInt": 95600,
            "cityName": "SPAOH",
            "stateCode": "13",
            "postCode": "95600"
        },
        {
            "postCodeInt": 95700,
            "cityName": "BETONG",
            "stateCode": "13",
            "postCode": "95700"
        },
        {
            "postCodeInt": 95707,
            "cityName": "BETONG",
            "stateCode": "13",
            "postCode": "95707"
        },
        {
            "postCodeInt": 95709,
            "cityName": "BETONG",
            "stateCode": "13",
            "postCode": "95709"
        },
        {
            "postCodeInt": 95800,
            "cityName": "ENGKILILI",
            "stateCode": "13",
            "postCode": "95800"
        },
        {
            "postCodeInt": 95900,
            "cityName": "LUBOK ANTU",
            "stateCode": "13",
            "postCode": "95900"
        },
        {
            "postCodeInt": 96000,
            "cityName": "SIBU",
            "stateCode": "13",
            "postCode": "96000"
        },
        {
            "postCodeInt": 96007,
            "cityName": "SIBU",
            "stateCode": "13",
            "postCode": "96007"
        },
        {
            "postCodeInt": 96008,
            "cityName": "SIBU",
            "stateCode": "13",
            "postCode": "96008"
        },
        {
            "postCodeInt": 96009,
            "cityName": "SIBU",
            "stateCode": "13",
            "postCode": "96009"
        },
        {
            "postCodeInt": 96100,
            "cityName": "SARIKEI",
            "stateCode": "13",
            "postCode": "96100"
        },
        {
            "postCodeInt": 96107,
            "cityName": "SARIKEI",
            "stateCode": "13",
            "postCode": "96107"
        },
        {
            "postCodeInt": 96108,
            "cityName": "SARIKEI",
            "stateCode": "13",
            "postCode": "96108"
        },
        {
            "postCodeInt": 96109,
            "cityName": "SARIKEI",
            "stateCode": "13",
            "postCode": "96109"
        },
        {
            "postCodeInt": 96150,
            "cityName": "BELAWAI",
            "stateCode": "13",
            "postCode": "96150"
        },
        {
            "postCodeInt": 96200,
            "cityName": "DARO",
            "stateCode": "13",
            "postCode": "96200"
        },
        {
            "postCodeInt": 96250,
            "cityName": "MATU",
            "stateCode": "13",
            "postCode": "96250"
        },
        {
            "postCodeInt": 96300,
            "cityName": "DALAT",
            "stateCode": "13",
            "postCode": "96300"
        },
        {
            "postCodeInt": 96307,
            "cityName": "DALAT",
            "stateCode": "13",
            "postCode": "96307"
        },
        {
            "postCodeInt": 96309,
            "cityName": "DALAT",
            "stateCode": "13",
            "postCode": "96309"
        },
        {
            "postCodeInt": 96350,
            "cityName": "BALINGIAN",
            "stateCode": "13",
            "postCode": "96350"
        },
        {
            "postCodeInt": 96400,
            "cityName": "MUKAH",
            "stateCode": "13",
            "postCode": "96400"
        },
        {
            "postCodeInt": 96410,
            "cityName": "OYA",
            "stateCode": "13",
            "postCode": "96410"
        },
        {
            "postCodeInt": 96500,
            "cityName": "BINTANGOR",
            "stateCode": "13",
            "postCode": "96500"
        },
        {
            "postCodeInt": 96507,
            "cityName": "BINTANGOR",
            "stateCode": "13",
            "postCode": "96507"
        },
        {
            "postCodeInt": 96508,
            "cityName": "BINTANGOR",
            "stateCode": "13",
            "postCode": "96508"
        },
        {
            "postCodeInt": 96509,
            "cityName": "BINTANGOR",
            "stateCode": "13",
            "postCode": "96509"
        },
        {
            "postCodeInt": 96510,
            "cityName": "PAKAN",
            "stateCode": "13",
            "postCode": "96510"
        },
        {
            "postCodeInt": 96600,
            "cityName": "JULAU",
            "stateCode": "13",
            "postCode": "96600"
        },
        {
            "postCodeInt": 96700,
            "cityName": "KANOWIT",
            "stateCode": "13",
            "postCode": "96700"
        },
        {
            "postCodeInt": 96707,
            "cityName": "KANOWIT",
            "stateCode": "13",
            "postCode": "96707"
        },
        {
            "postCodeInt": 96709,
            "cityName": "KANOWIT",
            "stateCode": "13",
            "postCode": "96709"
        },
        {
            "postCodeInt": 96800,
            "cityName": "KAPIT",
            "stateCode": "13",
            "postCode": "96800"
        },
        {
            "postCodeInt": 96807,
            "cityName": "KAPIT",
            "stateCode": "13",
            "postCode": "96807"
        },
        {
            "postCodeInt": 96809,
            "cityName": "KAPIT",
            "stateCode": "13",
            "postCode": "96809"
        },
        {
            "postCodeInt": 96850,
            "cityName": "SONG",
            "stateCode": "13",
            "postCode": "96850"
        },
        {
            "postCodeInt": 96900,
            "cityName": "BELAGA",
            "stateCode": "13",
            "postCode": "96900"
        },
        {
            "postCodeInt": 96950,
            "cityName": "BELAGA",
            "stateCode": "13",
            "postCode": "96950"
        },
        {
            "postCodeInt": 97000,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97000"
        },
        {
            "postCodeInt": 97007,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97007"
        },
        {
            "postCodeInt": 97008,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97008"
        },
        {
            "postCodeInt": 97009,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97009"
        },
        {
            "postCodeInt": 97010,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97010"
        },
        {
            "postCodeInt": 97011,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97011"
        },
        {
            "postCodeInt": 97012,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97012"
        },
        {
            "postCodeInt": 97013,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97013"
        },
        {
            "postCodeInt": 97014,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97014"
        },
        {
            "postCodeInt": 97015,
            "cityName": "BINTULU",
            "stateCode": "13",
            "postCode": "97015"
        },
        {
            "postCodeInt": 97100,
            "cityName": "SEBAUH",
            "stateCode": "13",
            "postCode": "97100"
        },
        {
            "postCodeInt": 97200,
            "cityName": "TATAU",
            "stateCode": "13",
            "postCode": "97200"
        },
        {
            "postCodeInt": 97300,
            "cityName": "TANJUNG KIDURONG",
            "stateCode": "13",
            "postCode": "97300"
        },
        {
            "postCodeInt": 98000,
            "cityName": "MIRI",
            "stateCode": "13",
            "postCode": "98000"
        },
        {
            "postCodeInt": 98007,
            "cityName": "MIRI",
            "stateCode": "13",
            "postCode": "98007"
        },
        {
            "postCodeInt": 98008,
            "cityName": "MIRI",
            "stateCode": "13",
            "postCode": "98008"
        },
        {
            "postCodeInt": 98009,
            "cityName": "MIRI",
            "stateCode": "13",
            "postCode": "98009"
        },
        {
            "postCodeInt": 98050,
            "cityName": "BARAM",
            "stateCode": "13",
            "postCode": "98050"
        },
        {
            "postCodeInt": 98057,
            "cityName": "BARAM",
            "stateCode": "13",
            "postCode": "98057"
        },
        {
            "postCodeInt": 98058,
            "cityName": "BARAM",
            "stateCode": "13",
            "postCode": "98058"
        },
        {
            "postCodeInt": 98059,
            "cityName": "BARAM",
            "stateCode": "13",
            "postCode": "98059"
        },
        {
            "postCodeInt": 98100,
            "cityName": "LUTONG",
            "stateCode": "13",
            "postCode": "98100"
        },
        {
            "postCodeInt": 98107,
            "cityName": "LUTONG",
            "stateCode": "13",
            "postCode": "98107"
        },
        {
            "postCodeInt": 98109,
            "cityName": "LUTONG",
            "stateCode": "13",
            "postCode": "98109"
        },
        {
            "postCodeInt": 98150,
            "cityName": "BEKENU",
            "stateCode": "13",
            "postCode": "98150"
        },
        {
            "postCodeInt": 98157,
            "cityName": "BEKENU",
            "stateCode": "13",
            "postCode": "98157"
        },
        {
            "postCodeInt": 98159,
            "cityName": "BEKENU",
            "stateCode": "13",
            "postCode": "98159"
        },
        {
            "postCodeInt": 98200,
            "cityName": "NIAH",
            "stateCode": "13",
            "postCode": "98200"
        },
        {
            "postCodeInt": 98300,
            "cityName": "LONG LAMA",
            "stateCode": "13",
            "postCode": "98300"
        },
        {
            "postCodeInt": 98700,
            "cityName": "LIMBANG",
            "stateCode": "13",
            "postCode": "98700"
        },
        {
            "postCodeInt": 98707,
            "cityName": "LIMBANG",
            "stateCode": "13",
            "postCode": "98707"
        },
        {
            "postCodeInt": 98708,
            "cityName": "LIMBANG",
            "stateCode": "13",
            "postCode": "98708"
        },
        {
            "postCodeInt": 98709,
            "cityName": "LIMBANG",
            "stateCode": "13",
            "postCode": "98709"
        },
        {
            "postCodeInt": 98750,
            "cityName": "NANGA MEDAMIT",
            "stateCode": "13",
            "postCode": "98750"
        },
        {
            "postCodeInt": 98800,
            "cityName": "SUNDAR",
            "stateCode": "13",
            "postCode": "98800"
        },
        {
            "postCodeInt": 98850,
            "cityName": "LAWAS",
            "stateCode": "13",
            "postCode": "98850"
        },
        {
            "postCodeInt": 98857,
            "cityName": "LAWAS",
            "stateCode": "13",
            "postCode": "98857"
        },
        {
            "postCodeInt": 98859,
            "cityName": "LAWAS",
            "stateCode": "13",
            "postCode": "98859"
        },
        {
            "postCodeInt": 50000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50000"
        },
        {
            "postCodeInt": 50050,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50050"
        },
        {
            "postCodeInt": 50088,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50088"
        },
        {
            "postCodeInt": 50100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50100"
        },
        {
            "postCodeInt": 50150,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50150"
        },
        {
            "postCodeInt": 50200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50200"
        },
        {
            "postCodeInt": 50250,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50250"
        },
        {
            "postCodeInt": 50300,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50300"
        },
        {
            "postCodeInt": 50350,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50350"
        },
        {
            "postCodeInt": 50400,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50400"
        },
        {
            "postCodeInt": 50450,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50450"
        },
        {
            "postCodeInt": 50460,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50460"
        },
        {
            "postCodeInt": 50470,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50470"
        },
        {
            "postCodeInt": 50480,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50480"
        },
        {
            "postCodeInt": 50490,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50490"
        },
        {
            "postCodeInt": 50500,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50500"
        },
        {
            "postCodeInt": 50502,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50502"
        },
        {
            "postCodeInt": 50504,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50504"
        },
        {
            "postCodeInt": 50505,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50505"
        },
        {
            "postCodeInt": 50506,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50506"
        },
        {
            "postCodeInt": 50507,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50507"
        },
        {
            "postCodeInt": 50508,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50508"
        },
        {
            "postCodeInt": 50512,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50512"
        },
        {
            "postCodeInt": 50514,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50514"
        },
        {
            "postCodeInt": 50515,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50515"
        },
        {
            "postCodeInt": 50517,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50517"
        },
        {
            "postCodeInt": 50519,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50519"
        },
        {
            "postCodeInt": 50522,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50522"
        },
        {
            "postCodeInt": 50528,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50528"
        },
        {
            "postCodeInt": 50529,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50529"
        },
        {
            "postCodeInt": 50530,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50530"
        },
        {
            "postCodeInt": 50532,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50532"
        },
        {
            "postCodeInt": 50534,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50534"
        },
        {
            "postCodeInt": 50536,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50536"
        },
        {
            "postCodeInt": 50538,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50538"
        },
        {
            "postCodeInt": 50540,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50540"
        },
        {
            "postCodeInt": 50542,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50542"
        },
        {
            "postCodeInt": 50544,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50544"
        },
        {
            "postCodeInt": 50546,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50546"
        },
        {
            "postCodeInt": 50548,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50548"
        },
        {
            "postCodeInt": 50550,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50550"
        },
        {
            "postCodeInt": 50551,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50551"
        },
        {
            "postCodeInt": 50552,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50552"
        },
        {
            "postCodeInt": 50554,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50554"
        },
        {
            "postCodeInt": 50556,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50556"
        },
        {
            "postCodeInt": 50558,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50558"
        },
        {
            "postCodeInt": 50560,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50560"
        },
        {
            "postCodeInt": 50562,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50562"
        },
        {
            "postCodeInt": 50564,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50564"
        },
        {
            "postCodeInt": 50566,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50566"
        },
        {
            "postCodeInt": 50568,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50568"
        },
        {
            "postCodeInt": 50570,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50570"
        },
        {
            "postCodeInt": 50572,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50572"
        },
        {
            "postCodeInt": 50574,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50574"
        },
        {
            "postCodeInt": 50576,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50576"
        },
        {
            "postCodeInt": 50578,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50578"
        },
        {
            "postCodeInt": 50580,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50580"
        },
        {
            "postCodeInt": 50582,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50582"
        },
        {
            "postCodeInt": 50584,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50584"
        },
        {
            "postCodeInt": 50586,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50586"
        },
        {
            "postCodeInt": 50588,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50588"
        },
        {
            "postCodeInt": 50590,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50590"
        },
        {
            "postCodeInt": 50592,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50592"
        },
        {
            "postCodeInt": 50594,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50594"
        },
        {
            "postCodeInt": 50596,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50596"
        },
        {
            "postCodeInt": 50598,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50598"
        },
        {
            "postCodeInt": 50599,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50599"
        },
        {
            "postCodeInt": 50600,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50600"
        },
        {
            "postCodeInt": 50602,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50602"
        },
        {
            "postCodeInt": 50603,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50603"
        },
        {
            "postCodeInt": 50604,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50604"
        },
        {
            "postCodeInt": 50605,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50605"
        },
        {
            "postCodeInt": 50606,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50606"
        },
        {
            "postCodeInt": 50608,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50608"
        },
        {
            "postCodeInt": 50609,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50609"
        },
        {
            "postCodeInt": 50610,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50610"
        },
        {
            "postCodeInt": 50612,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50612"
        },
        {
            "postCodeInt": 50614,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50614"
        },
        {
            "postCodeInt": 50618,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50618"
        },
        {
            "postCodeInt": 50620,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50620"
        },
        {
            "postCodeInt": 50621,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50621"
        },
        {
            "postCodeInt": 50622,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50622"
        },
        {
            "postCodeInt": 50623,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50623"
        },
        {
            "postCodeInt": 50624,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50624"
        },
        {
            "postCodeInt": 50626,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50626"
        },
        {
            "postCodeInt": 50628,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50628"
        },
        {
            "postCodeInt": 50630,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50630"
        },
        {
            "postCodeInt": 50632,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50632"
        },
        {
            "postCodeInt": 50634,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50634"
        },
        {
            "postCodeInt": 50636,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50636"
        },
        {
            "postCodeInt": 50638,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50638"
        },
        {
            "postCodeInt": 50640,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50640"
        },
        {
            "postCodeInt": 50642,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50642"
        },
        {
            "postCodeInt": 50644,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50644"
        },
        {
            "postCodeInt": 50646,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50646"
        },
        {
            "postCodeInt": 50648,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50648"
        },
        {
            "postCodeInt": 50650,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50650"
        },
        {
            "postCodeInt": 50652,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50652"
        },
        {
            "postCodeInt": 50653,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50653"
        },
        {
            "postCodeInt": 50654,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50654"
        },
        {
            "postCodeInt": 50656,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50656"
        },
        {
            "postCodeInt": 50658,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50658"
        },
        {
            "postCodeInt": 50660,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50660"
        },
        {
            "postCodeInt": 50661,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50661"
        },
        {
            "postCodeInt": 50662,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50662"
        },
        {
            "postCodeInt": 50664,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50664"
        },
        {
            "postCodeInt": 50666,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50666"
        },
        {
            "postCodeInt": 50668,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50668"
        },
        {
            "postCodeInt": 50670,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50670"
        },
        {
            "postCodeInt": 50672,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50672"
        },
        {
            "postCodeInt": 50673,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50673"
        },
        {
            "postCodeInt": 50676,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50676"
        },
        {
            "postCodeInt": 50677,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50677"
        },
        {
            "postCodeInt": 50678,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50678"
        },
        {
            "postCodeInt": 50680,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50680"
        },
        {
            "postCodeInt": 50682,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50682"
        },
        {
            "postCodeInt": 50684,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50684"
        },
        {
            "postCodeInt": 50686,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50686"
        },
        {
            "postCodeInt": 50688,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50688"
        },
        {
            "postCodeInt": 50692,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50692"
        },
        {
            "postCodeInt": 50694,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50694"
        },
        {
            "postCodeInt": 50700,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50700"
        },
        {
            "postCodeInt": 50702,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50702"
        },
        {
            "postCodeInt": 50704,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50704"
        },
        {
            "postCodeInt": 50706,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50706"
        },
        {
            "postCodeInt": 50708,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50708"
        },
        {
            "postCodeInt": 50710,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50710"
        },
        {
            "postCodeInt": 50712,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50712"
        },
        {
            "postCodeInt": 50714,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50714"
        },
        {
            "postCodeInt": 50716,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50716"
        },
        {
            "postCodeInt": 50718,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50718"
        },
        {
            "postCodeInt": 50720,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50720"
        },
        {
            "postCodeInt": 50722,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50722"
        },
        {
            "postCodeInt": 50724,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50724"
        },
        {
            "postCodeInt": 50726,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50726"
        },
        {
            "postCodeInt": 50728,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50728"
        },
        {
            "postCodeInt": 50730,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50730"
        },
        {
            "postCodeInt": 50732,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50732"
        },
        {
            "postCodeInt": 50734,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50734"
        },
        {
            "postCodeInt": 50736,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50736"
        },
        {
            "postCodeInt": 50738,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50738"
        },
        {
            "postCodeInt": 50740,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50740"
        },
        {
            "postCodeInt": 50742,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50742"
        },
        {
            "postCodeInt": 50744,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50744"
        },
        {
            "postCodeInt": 50746,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50746"
        },
        {
            "postCodeInt": 50748,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50748"
        },
        {
            "postCodeInt": 50750,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50750"
        },
        {
            "postCodeInt": 50752,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50752"
        },
        {
            "postCodeInt": 50754,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50754"
        },
        {
            "postCodeInt": 50758,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50758"
        },
        {
            "postCodeInt": 50760,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50760"
        },
        {
            "postCodeInt": 50762,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50762"
        },
        {
            "postCodeInt": 50764,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50764"
        },
        {
            "postCodeInt": 50766,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50766"
        },
        {
            "postCodeInt": 50768,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50768"
        },
        {
            "postCodeInt": 50770,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50770"
        },
        {
            "postCodeInt": 50772,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50772"
        },
        {
            "postCodeInt": 50774,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50774"
        },
        {
            "postCodeInt": 50776,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50776"
        },
        {
            "postCodeInt": 50778,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50778"
        },
        {
            "postCodeInt": 50780,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50780"
        },
        {
            "postCodeInt": 50782,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50782"
        },
        {
            "postCodeInt": 50784,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50784"
        },
        {
            "postCodeInt": 50786,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50786"
        },
        {
            "postCodeInt": 50788,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50788"
        },
        {
            "postCodeInt": 50790,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50790"
        },
        {
            "postCodeInt": 50792,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50792"
        },
        {
            "postCodeInt": 50794,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50794"
        },
        {
            "postCodeInt": 50796,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50796"
        },
        {
            "postCodeInt": 50798,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50798"
        },
        {
            "postCodeInt": 50800,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50800"
        },
        {
            "postCodeInt": 50802,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50802"
        },
        {
            "postCodeInt": 50804,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50804"
        },
        {
            "postCodeInt": 50806,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50806"
        },
        {
            "postCodeInt": 50808,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50808"
        },
        {
            "postCodeInt": 50810,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50810"
        },
        {
            "postCodeInt": 50812,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50812"
        },
        {
            "postCodeInt": 50814,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50814"
        },
        {
            "postCodeInt": 50816,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50816"
        },
        {
            "postCodeInt": 50818,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50818"
        },
        {
            "postCodeInt": 50901,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50901"
        },
        {
            "postCodeInt": 50902,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50902"
        },
        {
            "postCodeInt": 50903,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50903"
        },
        {
            "postCodeInt": 50904,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50904"
        },
        {
            "postCodeInt": 50906,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50906"
        },
        {
            "postCodeInt": 50907,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50907"
        },
        {
            "postCodeInt": 50908,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50908"
        },
        {
            "postCodeInt": 50909,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50909"
        },
        {
            "postCodeInt": 50910,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50910"
        },
        {
            "postCodeInt": 50911,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50911"
        },
        {
            "postCodeInt": 50912,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50912"
        },
        {
            "postCodeInt": 50913,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50913"
        },
        {
            "postCodeInt": 50914,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50914"
        },
        {
            "postCodeInt": 50915,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50915"
        },
        {
            "postCodeInt": 50916,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50916"
        },
        {
            "postCodeInt": 50917,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50917"
        },
        {
            "postCodeInt": 50918,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50918"
        },
        {
            "postCodeInt": 50919,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50919"
        },
        {
            "postCodeInt": 50920,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50920"
        },
        {
            "postCodeInt": 50921,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50921"
        },
        {
            "postCodeInt": 50922,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50922"
        },
        {
            "postCodeInt": 50923,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50923"
        },
        {
            "postCodeInt": 50924,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50924"
        },
        {
            "postCodeInt": 50925,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50925"
        },
        {
            "postCodeInt": 50926,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50926"
        },
        {
            "postCodeInt": 50927,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50927"
        },
        {
            "postCodeInt": 50928,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50928"
        },
        {
            "postCodeInt": 50929,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50929"
        },
        {
            "postCodeInt": 50930,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50930"
        },
        {
            "postCodeInt": 50931,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50931"
        },
        {
            "postCodeInt": 50932,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50932"
        },
        {
            "postCodeInt": 50933,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50933"
        },
        {
            "postCodeInt": 50934,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50934"
        },
        {
            "postCodeInt": 50935,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50935"
        },
        {
            "postCodeInt": 50936,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50936"
        },
        {
            "postCodeInt": 50937,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50937"
        },
        {
            "postCodeInt": 50938,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50938"
        },
        {
            "postCodeInt": 50939,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50939"
        },
        {
            "postCodeInt": 50940,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50940"
        },
        {
            "postCodeInt": 50941,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50941"
        },
        {
            "postCodeInt": 50942,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50942"
        },
        {
            "postCodeInt": 50943,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50943"
        },
        {
            "postCodeInt": 50944,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50944"
        },
        {
            "postCodeInt": 50945,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50945"
        },
        {
            "postCodeInt": 50946,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50946"
        },
        {
            "postCodeInt": 50947,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50947"
        },
        {
            "postCodeInt": 50948,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50948"
        },
        {
            "postCodeInt": 50949,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50949"
        },
        {
            "postCodeInt": 50950,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50950"
        },
        {
            "postCodeInt": 50988,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50988"
        },
        {
            "postCodeInt": 50989,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50989"
        },
        {
            "postCodeInt": 50990,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "50990"
        },
        {
            "postCodeInt": 51000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "51000"
        },
        {
            "postCodeInt": 51100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "51100"
        },
        {
            "postCodeInt": 51200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "51200"
        },
        {
            "postCodeInt": 51700,
            "cityName": "SENTUL",
            "stateCode": "14",
            "postCode": "51700"
        },
        {
            "postCodeInt": 51990,
            "cityName": "SENTUL",
            "stateCode": "14",
            "postCode": "51990"
        },
        {
            "postCodeInt": 52000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "52000"
        },
        {
            "postCodeInt": 52100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "52100"
        },
        {
            "postCodeInt": 52200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "52200"
        },
        {
            "postCodeInt": 53000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "53000"
        },
        {
            "postCodeInt": 53100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "53100"
        },
        {
            "postCodeInt": 53200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "53200"
        },
        {
            "postCodeInt": 53300,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "53300"
        },
        {
            "postCodeInt": 53700,
            "cityName": "GOMBAK",
            "stateCode": "14",
            "postCode": "53700"
        },
        {
            "postCodeInt": 53800,
            "cityName": "GOMBAK",
            "stateCode": "14",
            "postCode": "53800"
        },
        {
            "postCodeInt": 53990,
            "cityName": "GOMBAK",
            "stateCode": "14",
            "postCode": "53990"
        },
        {
            "postCodeInt": 54000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "54000"
        },
        {
            "postCodeInt": 54100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "54100"
        },
        {
            "postCodeInt": 54200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "54200"
        },
        {
            "postCodeInt": 55000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55000"
        },
        {
            "postCodeInt": 55100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55100"
        },
        {
            "postCodeInt": 55200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55200"
        },
        {
            "postCodeInt": 55300,
            "cityName": "PANDAN PERDANA",
            "stateCode": "14",
            "postCode": "55300"
        },
        {
            "postCodeInt": 55700,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55700"
        },
        {
            "postCodeInt": 55710,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55710"
        },
        {
            "postCodeInt": 55720,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "55720"
        },
        {
            "postCodeInt": 55900,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55900"
        },
        {
            "postCodeInt": 55902,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55902"
        },
        {
            "postCodeInt": 55904,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55904"
        },
        {
            "postCodeInt": 55906,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55906"
        },
        {
            "postCodeInt": 55908,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55908"
        },
        {
            "postCodeInt": 55910,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55910"
        },
        {
            "postCodeInt": 55912,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55912"
        },
        {
            "postCodeInt": 55914,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55914"
        },
        {
            "postCodeInt": 55916,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55916"
        },
        {
            "postCodeInt": 55918,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55918"
        },
        {
            "postCodeInt": 55920,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55920"
        },
        {
            "postCodeInt": 55922,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55922"
        },
        {
            "postCodeInt": 55924,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55924"
        },
        {
            "postCodeInt": 55926,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55926"
        },
        {
            "postCodeInt": 55928,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55928"
        },
        {
            "postCodeInt": 55930,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55930"
        },
        {
            "postCodeInt": 55932,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55932"
        },
        {
            "postCodeInt": 55934,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55934"
        },
        {
            "postCodeInt": 55990,
            "cityName": "PUDU",
            "stateCode": "14",
            "postCode": "55990"
        },
        {
            "postCodeInt": 56000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "56000"
        },
        {
            "postCodeInt": 56100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "56100"
        },
        {
            "postCodeInt": 57000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "57000"
        },
        {
            "postCodeInt": 57100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "57100"
        },
        {
            "postCodeInt": 57700,
            "cityName": "SUNGAI BESI",
            "stateCode": "14",
            "postCode": "57700"
        },
        {
            "postCodeInt": 57990,
            "cityName": "SUNGAI BESI",
            "stateCode": "14",
            "postCode": "57990"
        },
        {
            "postCodeInt": 58000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "58000"
        },
        {
            "postCodeInt": 58100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "58100"
        },
        {
            "postCodeInt": 58200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "58200"
        },
        {
            "postCodeInt": 58700,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "58700"
        },
        {
            "postCodeInt": 58990,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "58990"
        },
        {
            "postCodeInt": 59000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59000"
        },
        {
            "postCodeInt": 59100,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59100"
        },
        {
            "postCodeInt": 59200,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59200"
        },
        {
            "postCodeInt": 59700,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59700"
        },
        {
            "postCodeInt": 59800,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59800"
        },
        {
            "postCodeInt": 59990,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "59990"
        },
        {
            "postCodeInt": 60000,
            "cityName": "KUALA LUMPUR",
            "stateCode": "14",
            "postCode": "60000"
        },
        {
            "postCodeInt": 87028,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87028"
        },
        {
            "postCodeInt": 87018,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87018"
        },
        {
            "postCodeInt": 87019,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87019"
        },
        {
            "postCodeInt": 87020,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87020"
        },
        {
            "postCodeInt": 87021,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87021"
        },
        {
            "postCodeInt": 87022,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87022"
        },
        {
            "postCodeInt": 87030,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87030"
        },
        {
            "postCodeInt": 87031,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87031"
        },
        {
            "postCodeInt": 87032,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87032"
        },
        {
            "postCodeInt": 87033,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87033"
        },
        {
            "postCodeInt": 87024,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87024"
        },
        {
            "postCodeInt": 87025,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87025"
        },
        {
            "postCodeInt": 87013,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87013"
        },
        {
            "postCodeInt": 87000,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87000"
        },
        {
            "postCodeInt": 87007,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87007"
        },
        {
            "postCodeInt": 87008,
            "cityName": "LABUAN",
            "stateCode": "15",
            "postCode": "87008"
        },
        {
            "postCodeInt": 62000,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62000"
        },
        {
            "postCodeInt": 62007,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62007"
        },
        {
            "postCodeInt": 62050,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62050"
        },
        {
            "postCodeInt": 62077,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62077"
        },
        {
            "postCodeInt": 62100,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62100"
        },
        {
            "postCodeInt": 62150,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62150"
        },
        {
            "postCodeInt": 62200,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62200"
        },
        {
            "postCodeInt": 62250,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62250"
        },
        {
            "postCodeInt": 62300,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62300"
        },
        {
            "postCodeInt": 62502,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62502"
        },
        {
            "postCodeInt": 62503,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62503"
        },
        {
            "postCodeInt": 62504,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62504"
        },
        {
            "postCodeInt": 62505,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62505"
        },
        {
            "postCodeInt": 62506,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62506"
        },
        {
            "postCodeInt": 62510,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62510"
        },
        {
            "postCodeInt": 62512,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62512"
        },
        {
            "postCodeInt": 62514,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62514"
        },
        {
            "postCodeInt": 62516,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62516"
        },
        {
            "postCodeInt": 62517,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62517"
        },
        {
            "postCodeInt": 62518,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62518"
        },
        {
            "postCodeInt": 62519,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62519"
        },
        {
            "postCodeInt": 62520,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62520"
        },
        {
            "postCodeInt": 62522,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62522"
        },
        {
            "postCodeInt": 62524,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62524"
        },
        {
            "postCodeInt": 62526,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62526"
        },
        {
            "postCodeInt": 62527,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62527"
        },
        {
            "postCodeInt": 62529,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62529"
        },
        {
            "postCodeInt": 62530,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62530"
        },
        {
            "postCodeInt": 62532,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62532"
        },
        {
            "postCodeInt": 62536,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62536"
        },
        {
            "postCodeInt": 62540,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62540"
        },
        {
            "postCodeInt": 62542,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62542"
        },
        {
            "postCodeInt": 62546,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62546"
        },
        {
            "postCodeInt": 62550,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62550"
        },
        {
            "postCodeInt": 62551,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62551"
        },
        {
            "postCodeInt": 62570,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62570"
        },
        {
            "postCodeInt": 62574,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62574"
        },
        {
            "postCodeInt": 62576,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62576"
        },
        {
            "postCodeInt": 62582,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62582"
        },
        {
            "postCodeInt": 62584,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62584"
        },
        {
            "postCodeInt": 62590,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62590"
        },
        {
            "postCodeInt": 62592,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62592"
        },
        {
            "postCodeInt": 62594,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62594"
        },
        {
            "postCodeInt": 62596,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62596"
        },
        {
            "postCodeInt": 62602,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62602"
        },
        {
            "postCodeInt": 62604,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62604"
        },
        {
            "postCodeInt": 62605,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62605"
        },
        {
            "postCodeInt": 62606,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62606"
        },
        {
            "postCodeInt": 62616,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62616"
        },
        {
            "postCodeInt": 62618,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62618"
        },
        {
            "postCodeInt": 62620,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62620"
        },
        {
            "postCodeInt": 62623,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62623"
        },
        {
            "postCodeInt": 62624,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62624"
        },
        {
            "postCodeInt": 62628,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62628"
        },
        {
            "postCodeInt": 62630,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62630"
        },
        {
            "postCodeInt": 62632,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62632"
        },
        {
            "postCodeInt": 62648,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62648"
        },
        {
            "postCodeInt": 62652,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62652"
        },
        {
            "postCodeInt": 62654,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62654"
        },
        {
            "postCodeInt": 62662,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62662"
        },
        {
            "postCodeInt": 62668,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62668"
        },
        {
            "postCodeInt": 62670,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62670"
        },
        {
            "postCodeInt": 62674,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62674"
        },
        {
            "postCodeInt": 62675,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62675"
        },
        {
            "postCodeInt": 62676,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62676"
        },
        {
            "postCodeInt": 62677,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62677"
        },
        {
            "postCodeInt": 62686,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62686"
        },
        {
            "postCodeInt": 62690,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62690"
        },
        {
            "postCodeInt": 62692,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62692"
        },
        {
            "postCodeInt": 62988,
            "cityName": "PUTRAJAYA",
            "stateCode": "16",
            "postCode": "62988"
        },
        {
            "postCodeInt": 25000,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25000"
        },
        {
            "postCodeInt": 25020,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25020"
        },
        {
            "postCodeInt": 25050,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25050"
        },
        {
            "postCodeInt": 25100,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25100"
        },
        {
            "postCodeInt": 25150,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25150"
        },
        {
            "postCodeInt": 25200,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25200"
        },
        {
            "postCodeInt": 25250,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25250"
        },
        {
            "postCodeInt": 25300,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25300"
        },
        {
            "postCodeInt": 25350,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25350"
        },
        {
            "postCodeInt": 25500,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25500"
        },
        {
            "postCodeInt": 25502,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25502"
        },
        {
            "postCodeInt": 25503,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25503"
        },
        {
            "postCodeInt": 25504,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25504"
        },
        {
            "postCodeInt": 25505,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25505"
        },
        {
            "postCodeInt": 25506,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25506"
        },
        {
            "postCodeInt": 25508,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25508"
        },
        {
            "postCodeInt": 25509,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25509"
        },
        {
            "postCodeInt": 25512,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25512"
        },
        {
            "postCodeInt": 25514,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25514"
        },
        {
            "postCodeInt": 25516,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25516"
        },
        {
            "postCodeInt": 25517,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25517"
        },
        {
            "postCodeInt": 25518,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25518"
        },
        {
            "postCodeInt": 25520,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25520"
        },
        {
            "postCodeInt": 25524,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25524"
        },
        {
            "postCodeInt": 25529,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25529"
        },
        {
            "postCodeInt": 25532,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25532"
        },
        {
            "postCodeInt": 25534,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25534"
        },
        {
            "postCodeInt": 25536,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25536"
        },
        {
            "postCodeInt": 25538,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25538"
        },
        {
            "postCodeInt": 25540,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25540"
        },
        {
            "postCodeInt": 25546,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25546"
        },
        {
            "postCodeInt": 25548,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25548"
        },
        {
            "postCodeInt": 25550,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25550"
        },
        {
            "postCodeInt": 25551,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25551"
        },
        {
            "postCodeInt": 25552,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25552"
        },
        {
            "postCodeInt": 25556,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25556"
        },
        {
            "postCodeInt": 25558,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25558"
        },
        {
            "postCodeInt": 25560,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25560"
        },
        {
            "postCodeInt": 25564,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25564"
        },
        {
            "postCodeInt": 25570,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25570"
        },
        {
            "postCodeInt": 25576,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25576"
        },
        {
            "postCodeInt": 25578,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25578"
        },
        {
            "postCodeInt": 25582,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25582"
        },
        {
            "postCodeInt": 25584,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25584"
        },
        {
            "postCodeInt": 25586,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25586"
        },
        {
            "postCodeInt": 25590,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25590"
        },
        {
            "postCodeInt": 25592,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25592"
        },
        {
            "postCodeInt": 25594,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25594"
        },
        {
            "postCodeInt": 25596,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25596"
        },
        {
            "postCodeInt": 25598,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25598"
        },
        {
            "postCodeInt": 25600,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25600"
        },
        {
            "postCodeInt": 25604,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25604"
        },
        {
            "postCodeInt": 25606,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25606"
        },
        {
            "postCodeInt": 25608,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25608"
        },
        {
            "postCodeInt": 25609,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25609"
        },
        {
            "postCodeInt": 25610,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25610"
        },
        {
            "postCodeInt": 25612,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25612"
        },
        {
            "postCodeInt": 25614,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25614"
        },
        {
            "postCodeInt": 25620,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25620"
        },
        {
            "postCodeInt": 25622,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25622"
        },
        {
            "postCodeInt": 25626,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25626"
        },
        {
            "postCodeInt": 25628,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25628"
        },
        {
            "postCodeInt": 25630,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25630"
        },
        {
            "postCodeInt": 25632,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25632"
        },
        {
            "postCodeInt": 25644,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25644"
        },
        {
            "postCodeInt": 25646,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25646"
        },
        {
            "postCodeInt": 25648,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25648"
        },
        {
            "postCodeInt": 25656,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25656"
        },
        {
            "postCodeInt": 25660,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25660"
        },
        {
            "postCodeInt": 25661,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25661"
        },
        {
            "postCodeInt": 25662,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25662"
        },
        {
            "postCodeInt": 25670,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25670"
        },
        {
            "postCodeInt": 25672,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25672"
        },
        {
            "postCodeInt": 25673,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25673"
        },
        {
            "postCodeInt": 25674,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25674"
        },
        {
            "postCodeInt": 25676,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25676"
        },
        {
            "postCodeInt": 25690,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25690"
        },
        {
            "postCodeInt": 25700,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25700"
        },
        {
            "postCodeInt": 25710,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25710"
        },
        {
            "postCodeInt": 25720,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25720"
        },
        {
            "postCodeInt": 25730,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25730"
        },
        {
            "postCodeInt": 25740,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25740"
        },
        {
            "postCodeInt": 25750,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25750"
        },
        {
            "postCodeInt": 25988,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25988"
        },
        {
            "postCodeInt": 25990,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "25990"
        },
        {
            "postCodeInt": 26000,
            "cityName": "KAMPONG JAYA GADING (JENGKA)",
            "stateCode": "06",
            "postCode": "26000"
        },
        {
            "postCodeInt": 26010,
            "cityName": "SUNGAI PANCHING SELATAN",
            "stateCode": "06",
            "postCode": "26010"
        },
        {
            "postCodeInt": 26040,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "26040"
        },
        {
            "postCodeInt": 26050,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "26050"
        },
        {
            "postCodeInt": 26060,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "26060"
        },
        {
            "postCodeInt": 26070,
            "cityName": "KUANTAN",
            "stateCode": "06",
            "postCode": "26070"
        },
        {
            "postCodeInt": 26080,
            "cityName": "BALOK",
            "stateCode": "06",
            "postCode": "26080"
        },
        {
            "postCodeInt": 26090,
            "cityName": "BUKIT GOH",
            "stateCode": "06",
            "postCode": "26090"
        },
        {
            "postCodeInt": 26100,
            "cityName": "BALOK",
            "stateCode": "06",
            "postCode": "26100"
        },
        {
            "postCodeInt": 26130,
            "cityName": "BUKIT KUANTAN",
            "stateCode": "06",
            "postCode": "26130"
        },
        {
            "postCodeInt": 26140,
            "cityName": "SUNGAI PANCHING TIMUR",
            "stateCode": "06",
            "postCode": "26140"
        },
        {
            "postCodeInt": 26150,
            "cityName": "BALOK",
            "stateCode": "06",
            "postCode": "26150"
        },
        {
            "postCodeInt": 26170,
            "cityName": "BUKIT KUIN SATU",
            "stateCode": "06",
            "postCode": "26170"
        },
        {
            "postCodeInt": 26180,
            "cityName": "BUKIT KUIN DUA",
            "stateCode": "06",
            "postCode": "26180"
        },
        {
            "postCodeInt": 26190,
            "cityName": "BALOK",
            "stateCode": "06",
            "postCode": "26190"
        },
        {
            "postCodeInt": 26200,
            "cityName": "SUNGAI LEMBING",
            "stateCode": "06",
            "postCode": "26200"
        },
        {
            "postCodeInt": 26250,
            "cityName": "SUNGAI PANCHING UTARA",
            "stateCode": "06",
            "postCode": "26250"
        },
        {
            "postCodeInt": 26300,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26300"
        },
        {
            "postCodeInt": 26310,
            "cityName": "LEPAR HILIR",
            "stateCode": "06",
            "postCode": "26310"
        },
        {
            "postCodeInt": 26320,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26320"
        },
        {
            "postCodeInt": 26330,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26330"
        },
        {
            "postCodeInt": 26340,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26340"
        },
        {
            "postCodeInt": 26350,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26350"
        },
        {
            "postCodeInt": 26360,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26360"
        },
        {
            "postCodeInt": 26370,
            "cityName": "GAMBANG",
            "stateCode": "06",
            "postCode": "26370"
        },
        {
            "postCodeInt": 26400,
            "cityName": "BANDAR PUSAT  JENGKA",
            "stateCode": "06",
            "postCode": "26400"
        },
        {
            "postCodeInt": 26410,
            "cityName": "BANDAR PUSAT  JENGKA",
            "stateCode": "06",
            "postCode": "26410"
        },
        {
            "postCodeInt": 26420,
            "cityName": "BANDAR PUSAT  JENGKA",
            "stateCode": "06",
            "postCode": "26420"
        },
        {
            "postCodeInt": 26430,
            "cityName": "BANDAR PUSAT  JENGKA",
            "stateCode": "06",
            "postCode": "26430"
        },
        {
            "postCodeInt": 26440,
            "cityName": "BANDAR PUSAT JENGKA",
            "stateCode": "06",
            "postCode": "26440"
        },
        {
            "postCodeInt": 26450,
            "cityName": "BANDAR PUSAT JENGKA",
            "stateCode": "06",
            "postCode": "26450"
        },
        {
            "postCodeInt": 26460,
            "cityName": "BANDAR PUSAT JENGKA",
            "stateCode": "06",
            "postCode": "26460"
        },
        {
            "postCodeInt": 26485,
            "cityName": "BANDAR PUSAT JENGKA",
            "stateCode": "06",
            "postCode": "26485"
        },
        {
            "postCodeInt": 26490,
            "cityName": "BANDAR PUSAT JENGKA",
            "stateCode": "06",
            "postCode": "26490"
        },
        {
            "postCodeInt": 26500,
            "cityName": "MARAN",
            "stateCode": "06",
            "postCode": "26500"
        },
        {
            "postCodeInt": 26600,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26600"
        },
        {
            "postCodeInt": 26607,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26607"
        },
        {
            "postCodeInt": 26609,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26609"
        },
        {
            "postCodeInt": 26610,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26610"
        },
        {
            "postCodeInt": 26620,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26620"
        },
        {
            "postCodeInt": 26630,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26630"
        },
        {
            "postCodeInt": 26640,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26640"
        },
        {
            "postCodeInt": 26650,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26650"
        },
        {
            "postCodeInt": 26660,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26660"
        },
        {
            "postCodeInt": 26680,
            "cityName": "PEKAN",
            "stateCode": "06",
            "postCode": "26680"
        },
        {
            "postCodeInt": 26690,
            "cityName": "CHINI",
            "stateCode": "06",
            "postCode": "26690"
        },
        {
            "postCodeInt": 26700,
            "cityName": "MUADZAM SHAH",
            "stateCode": "06",
            "postCode": "26700"
        },
        {
            "postCodeInt": 26800,
            "cityName": "KUALA ROMPIN",
            "stateCode": "06",
            "postCode": "26800"
        },
        {
            "postCodeInt": 26810,
            "cityName": "KUALA ROMPIN",
            "stateCode": "06",
            "postCode": "26810"
        },
        {
            "postCodeInt": 26820,
            "cityName": "KUALA ROMPIN",
            "stateCode": "06",
            "postCode": "26820"
        },
        {
            "postCodeInt": 26900,
            "cityName": "BANDAR TUN ABDUL RAZAK",
            "stateCode": "06",
            "postCode": "26900"
        },
        {
            "postCodeInt": 27000,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27000"
        },
        {
            "postCodeInt": 27010,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27010"
        },
        {
            "postCodeInt": 27020,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27020"
        },
        {
            "postCodeInt": 27030,
            "cityName": "DAMAK",
            "stateCode": "06",
            "postCode": "27030"
        },
        {
            "postCodeInt": 27040,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27040"
        },
        {
            "postCodeInt": 27050,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27050"
        },
        {
            "postCodeInt": 27060,
            "cityName": "SUNGAI TEKAM UTARA",
            "stateCode": "06",
            "postCode": "27060"
        },
        {
            "postCodeInt": 27070,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27070"
        },
        {
            "postCodeInt": 27080,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27080"
        },
        {
            "postCodeInt": 27090,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27090"
        },
        {
            "postCodeInt": 27100,
            "cityName": "PADANG TENGKU",
            "stateCode": "06",
            "postCode": "27100"
        },
        {
            "postCodeInt": 27150,
            "cityName": "JERANTUT",
            "stateCode": "06",
            "postCode": "27150"
        },
        {
            "postCodeInt": 27200,
            "cityName": "KUALA LIPIS",
            "stateCode": "06",
            "postCode": "27200"
        },
        {
            "postCodeInt": 27207,
            "cityName": "KUALA LIPIS",
            "stateCode": "06",
            "postCode": "27207"
        },
        {
            "postCodeInt": 27209,
            "cityName": "KUALA LIPIS",
            "stateCode": "06",
            "postCode": "27209"
        },
        {
            "postCodeInt": 27210,
            "cityName": "KUALA LIPIS",
            "stateCode": "06",
            "postCode": "27210"
        },
        {
            "postCodeInt": 27300,
            "cityName": "BENTA",
            "stateCode": "06",
            "postCode": "27300"
        },
        {
            "postCodeInt": 27310,
            "cityName": "BENTA",
            "stateCode": "06",
            "postCode": "27310"
        },
        {
            "postCodeInt": 27400,
            "cityName": "DONG",
            "stateCode": "06",
            "postCode": "27400"
        },
        {
            "postCodeInt": 27500,
            "cityName": "SUNGAI RUAN",
            "stateCode": "06",
            "postCode": "27500"
        },
        {
            "postCodeInt": 27600,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27600"
        },
        {
            "postCodeInt": 27607,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27607"
        },
        {
            "postCodeInt": 27609,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27609"
        },
        {
            "postCodeInt": 27610,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27610"
        },
        {
            "postCodeInt": 27620,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27620"
        },
        {
            "postCodeInt": 27630,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27630"
        },
        {
            "postCodeInt": 27650,
            "cityName": "SUNGAI KOYAN",
            "stateCode": "06",
            "postCode": "27650"
        },
        {
            "postCodeInt": 27660,
            "cityName": "SEGA",
            "stateCode": "06",
            "postCode": "27660"
        },
        {
            "postCodeInt": 27670,
            "cityName": "RAUB",
            "stateCode": "06",
            "postCode": "27670"
        },
        {
            "postCodeInt": "02800",
            "cityName": "KAMPONG SEBERANG TEMERLOH",
            "stateCode": "06",
            "postCode": "02800"
        },
        {
            "postCodeInt": 28000,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28000"
        },
        {
            "postCodeInt": 28007,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28007"
        },
        {
            "postCodeInt": 28009,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28009"
        },
        {
            "postCodeInt": 28010,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28010"
        },
        {
            "postCodeInt": 28020,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28020"
        },
        {
            "postCodeInt": 28030,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28030"
        },
        {
            "postCodeInt": 28040,
            "cityName": "TEMERLOH",
            "stateCode": "06",
            "postCode": "28040"
        },
        {
            "postCodeInt": 28050,
            "cityName": "KUALA KRAU",
            "stateCode": "06",
            "postCode": "28050"
        },
        {
            "postCodeInt": 28100,
            "cityName": "CHENOR",
            "stateCode": "06",
            "postCode": "28100"
        },
        {
            "postCodeInt": 28200,
            "cityName": "BANDAR BERA",
            "stateCode": "06",
            "postCode": "28200"
        },
        {
            "postCodeInt": 28300,
            "cityName": "TRIANG",
            "stateCode": "06",
            "postCode": "28300"
        },
        {
            "postCodeInt": 28310,
            "cityName": "CHEMOIMOI",
            "stateCode": "06",
            "postCode": "28310"
        },
        {
            "postCodeInt": 28320,
            "cityName": "TRIANG",
            "stateCode": "06",
            "postCode": "28320"
        },
        {
            "postCodeInt": 28330,
            "cityName": "TRIANG",
            "stateCode": "06",
            "postCode": "28330"
        },
        {
            "postCodeInt": 28340,
            "cityName": "KEMAYAN",
            "stateCode": "06",
            "postCode": "28340"
        },
        {
            "postCodeInt": 28350,
            "cityName": "TRIANG",
            "stateCode": "06",
            "postCode": "28350"
        },
        {
            "postCodeInt": 28380,
            "cityName": "KEMAYAN",
            "stateCode": "06",
            "postCode": "28380"
        },
        {
            "postCodeInt": 28400,
            "cityName": "MENTAKAB",
            "stateCode": "06",
            "postCode": "28400"
        },
        {
            "postCodeInt": 28407,
            "cityName": "MENTAKAB",
            "stateCode": "06",
            "postCode": "28407"
        },
        {
            "postCodeInt": 28409,
            "cityName": "MENTAKAB",
            "stateCode": "06",
            "postCode": "28409"
        },
        {
            "postCodeInt": 28500,
            "cityName": "LANCHANG",
            "stateCode": "06",
            "postCode": "28500"
        },
        {
            "postCodeInt": 28600,
            "cityName": "KARAK",
            "stateCode": "06",
            "postCode": "28600"
        },
        {
            "postCodeInt": 28610,
            "cityName": "KARAK",
            "stateCode": "06",
            "postCode": "28610"
        },
        {
            "postCodeInt": 28620,
            "cityName": "KARAK",
            "stateCode": "06",
            "postCode": "28620"
        },
        {
            "postCodeInt": 28700,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28700"
        },
        {
            "postCodeInt": 28707,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28707"
        },
        {
            "postCodeInt": 28709,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28709"
        },
        {
            "postCodeInt": 28730,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28730"
        },
        {
            "postCodeInt": 28740,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28740"
        },
        {
            "postCodeInt": 28750,
            "cityName": "BENTONG",
            "stateCode": "06",
            "postCode": "28750"
        },
        {
            "postCodeInt": 28800,
            "cityName": "LURAH BILUT",
            "stateCode": "06",
            "postCode": "28800"
        },
        {
            "postCodeInt": 49000,
            "cityName": "BUKIT FRASER",
            "stateCode": "06",
            "postCode": "49000"
        },
        {
            "postCodeInt": 39000,
            "cityName": "TANAH RATA",
            "stateCode": "06",
            "postCode": "39000"
        },
        {
            "postCodeInt": 39007,
            "cityName": "TANAH RATA",
            "stateCode": "06",
            "postCode": "39007"
        },
        {
            "postCodeInt": 39009,
            "cityName": "TANAH RATA",
            "stateCode": "06",
            "postCode": "39009"
        },
        {
            "postCodeInt": 39010,
            "cityName": "TANAH RATA",
            "stateCode": "06",
            "postCode": "39010"
        },
        {
            "postCodeInt": 39100,
            "cityName": "BRINCHANG",
            "stateCode": "06",
            "postCode": "39100"
        },
        {
            "postCodeInt": 39200,
            "cityName": "RINGLET",
            "stateCode": "06",
            "postCode": "39200"
        },
        {
            "postCodeInt": 35000,
            "cityName": "TAPAH",
            "stateCode": "08",
            "postCode": "35000"
        },
        {
            "postCodeInt": 35007,
            "cityName": "TAPAH",
            "stateCode": "08",
            "postCode": "35007"
        },
        {
            "postCodeInt": 35009,
            "cityName": "TAPAH",
            "stateCode": "08",
            "postCode": "35009"
        },
        {
            "postCodeInt": 35300,
            "cityName": "CHENDERIANG",
            "stateCode": "08",
            "postCode": "35300"
        },
        {
            "postCodeInt": 35350,
            "cityName": "TEMOH",
            "stateCode": "08",
            "postCode": "35350"
        },
        {
            "postCodeInt": 35400,
            "cityName": "TAPAH ROAD",
            "stateCode": "08",
            "postCode": "35400"
        },
        {
            "postCodeInt": 35500,
            "cityName": "BIDOR",
            "stateCode": "08",
            "postCode": "35500"
        },
        {
            "postCodeInt": 35600,
            "cityName": "SUNGKAI",
            "stateCode": "08",
            "postCode": "35600"
        },
        {
            "postCodeInt": 35700,
            "cityName": "TROLAK",
            "stateCode": "08",
            "postCode": "35700"
        },
        {
            "postCodeInt": 35800,
            "cityName": "SLIM RIVER",
            "stateCode": "08",
            "postCode": "35800"
        },
        {
            "postCodeInt": 35820,
            "cityName": "SLIM RIVER",
            "stateCode": "08",
            "postCode": "35820"
        },
        {
            "postCodeInt": 35900,
            "cityName": "TANJONG MALIM",
            "stateCode": "08",
            "postCode": "35900"
        },
        {
            "postCodeInt": 35907,
            "cityName": "TANJONG MALIM",
            "stateCode": "08",
            "postCode": "35907"
        },
        {
            "postCodeInt": 35909,
            "cityName": "TANJONG MALIM",
            "stateCode": "08",
            "postCode": "35909"
        },
        {
            "postCodeInt": 35910,
            "cityName": "TANJONG MALIM",
            "stateCode": "08",
            "postCode": "35910"
        },
        {
            "postCodeInt": 35950,
            "cityName": "BEHRANG STESEN",
            "stateCode": "08",
            "postCode": "35950"
        },
        {
            "postCodeInt": 36000,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36000"
        },
        {
            "postCodeInt": 36007,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36007"
        },
        {
            "postCodeInt": 36008,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36008"
        },
        {
            "postCodeInt": 36009,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36009"
        },
        {
            "postCodeInt": 36010,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36010"
        },
        {
            "postCodeInt": 36020,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36020"
        },
        {
            "postCodeInt": 36030,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36030"
        },
        {
            "postCodeInt": 36100,
            "cityName": "BAGAN DATOH",
            "stateCode": "08",
            "postCode": "36100"
        },
        {
            "postCodeInt": 36110,
            "cityName": "TELUK INTAN",
            "stateCode": "08",
            "postCode": "36110"
        },
        {
            "postCodeInt": 36200,
            "cityName": "SELEKOH",
            "stateCode": "08",
            "postCode": "36200"
        },
        {
            "postCodeInt": 36207,
            "cityName": "SELEKOH",
            "stateCode": "08",
            "postCode": "36207"
        },
        {
            "postCodeInt": 36209,
            "cityName": "SELEKOH",
            "stateCode": "08",
            "postCode": "36209"
        },
        {
            "postCodeInt": 36300,
            "cityName": "SUNGAI SUMUN",
            "stateCode": "08",
            "postCode": "36300"
        },
        {
            "postCodeInt": 36307,
            "cityName": "SUNGAI SUMUN",
            "stateCode": "08",
            "postCode": "36307"
        },
        {
            "postCodeInt": 36309,
            "cityName": "SUNGAI SUMUN",
            "stateCode": "08",
            "postCode": "36309"
        },
        {
            "postCodeInt": 36400,
            "cityName": "HUTAN MELINTANG",
            "stateCode": "08",
            "postCode": "36400"
        },
        {
            "postCodeInt": 36500,
            "cityName": "ULU BERNAM",
            "stateCode": "08",
            "postCode": "36500"
        },
        {
            "postCodeInt": 36600,
            "cityName": "CHENDERONG BALAI",
            "stateCode": "08",
            "postCode": "36600"
        },
        {
            "postCodeInt": 36700,
            "cityName": "LANGKAP",
            "stateCode": "08",
            "postCode": "36700"
        },
        {
            "postCodeInt": 36750,
            "cityName": "CHIKUS",
            "stateCode": "08",
            "postCode": "36750"
        },
        {
            "postCodeInt": 36800,
            "cityName": "KAMPONG GAJAH",
            "stateCode": "08",
            "postCode": "36800"
        },
        {
            "postCodeInt": 36810,
            "cityName": "KAMPUNG GAJAH",
            "stateCode": "08",
            "postCode": "36810"
        },
        {
            "postCodeInt": 30000,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30000"
        },
        {
            "postCodeInt": 30010,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30010"
        },
        {
            "postCodeInt": 30020,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30020"
        },
        {
            "postCodeInt": 30100,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30100"
        },
        {
            "postCodeInt": 30200,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30200"
        },
        {
            "postCodeInt": 30250,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30250"
        },
        {
            "postCodeInt": 30300,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30300"
        },
        {
            "postCodeInt": 30350,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30350"
        },
        {
            "postCodeInt": 30450,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30450"
        },
        {
            "postCodeInt": 30500,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30500"
        },
        {
            "postCodeInt": 30502,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30502"
        },
        {
            "postCodeInt": 30503,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30503"
        },
        {
            "postCodeInt": 30504,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30504"
        },
        {
            "postCodeInt": 30505,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30505"
        },
        {
            "postCodeInt": 30506,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30506"
        },
        {
            "postCodeInt": 30508,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30508"
        },
        {
            "postCodeInt": 30510,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30510"
        },
        {
            "postCodeInt": 30512,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30512"
        },
        {
            "postCodeInt": 30516,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30516"
        },
        {
            "postCodeInt": 30517,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30517"
        },
        {
            "postCodeInt": 30518,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30518"
        },
        {
            "postCodeInt": 30519,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30519"
        },
        {
            "postCodeInt": 30520,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30520"
        },
        {
            "postCodeInt": 30524,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30524"
        },
        {
            "postCodeInt": 30532,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30532"
        },
        {
            "postCodeInt": 30534,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30534"
        },
        {
            "postCodeInt": 30536,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30536"
        },
        {
            "postCodeInt": 30540,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30540"
        },
        {
            "postCodeInt": 30542,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30542"
        },
        {
            "postCodeInt": 30546,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30546"
        },
        {
            "postCodeInt": 30548,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30548"
        },
        {
            "postCodeInt": 30550,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30550"
        },
        {
            "postCodeInt": 30551,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30551"
        },
        {
            "postCodeInt": 30552,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30552"
        },
        {
            "postCodeInt": 30554,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30554"
        },
        {
            "postCodeInt": 30556,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30556"
        },
        {
            "postCodeInt": 30560,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30560"
        },
        {
            "postCodeInt": 30564,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30564"
        },
        {
            "postCodeInt": 30570,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30570"
        },
        {
            "postCodeInt": 30576,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30576"
        },
        {
            "postCodeInt": 30580,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30580"
        },
        {
            "postCodeInt": 30582,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30582"
        },
        {
            "postCodeInt": 30586,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30586"
        },
        {
            "postCodeInt": 30590,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30590"
        },
        {
            "postCodeInt": 30592,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30592"
        },
        {
            "postCodeInt": 30594,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30594"
        },
        {
            "postCodeInt": 30596,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30596"
        },
        {
            "postCodeInt": 30600,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30600"
        },
        {
            "postCodeInt": 30604,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30604"
        },
        {
            "postCodeInt": 30606,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30606"
        },
        {
            "postCodeInt": 30609,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30609"
        },
        {
            "postCodeInt": 30610,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30610"
        },
        {
            "postCodeInt": 30612,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30612"
        },
        {
            "postCodeInt": 30614,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30614"
        },
        {
            "postCodeInt": 30620,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30620"
        },
        {
            "postCodeInt": 30621,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30621"
        },
        {
            "postCodeInt": 30622,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30622"
        },
        {
            "postCodeInt": 30626,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30626"
        },
        {
            "postCodeInt": 30628,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30628"
        },
        {
            "postCodeInt": 30630,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30630"
        },
        {
            "postCodeInt": 30632,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30632"
        },
        {
            "postCodeInt": 30634,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30634"
        },
        {
            "postCodeInt": 30644,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30644"
        },
        {
            "postCodeInt": 30646,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30646"
        },
        {
            "postCodeInt": 30648,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30648"
        },
        {
            "postCodeInt": 30656,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30656"
        },
        {
            "postCodeInt": 30658,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30658"
        },
        {
            "postCodeInt": 30660,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30660"
        },
        {
            "postCodeInt": 30661,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30661"
        },
        {
            "postCodeInt": 30662,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30662"
        },
        {
            "postCodeInt": 30664,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30664"
        },
        {
            "postCodeInt": 30668,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30668"
        },
        {
            "postCodeInt": 30670,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30670"
        },
        {
            "postCodeInt": 30673,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30673"
        },
        {
            "postCodeInt": 30674,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30674"
        },
        {
            "postCodeInt": 30676,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30676"
        },
        {
            "postCodeInt": 30682,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30682"
        },
        {
            "postCodeInt": 30690,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30690"
        },
        {
            "postCodeInt": 30700,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30700"
        },
        {
            "postCodeInt": 30710,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30710"
        },
        {
            "postCodeInt": 30720,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30720"
        },
        {
            "postCodeInt": 30730,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30730"
        },
        {
            "postCodeInt": 30740,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30740"
        },
        {
            "postCodeInt": 30750,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30750"
        },
        {
            "postCodeInt": 30760,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30760"
        },
        {
            "postCodeInt": 30770,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30770"
        },
        {
            "postCodeInt": 30780,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30780"
        },
        {
            "postCodeInt": 30790,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30790"
        },
        {
            "postCodeInt": 30800,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30800"
        },
        {
            "postCodeInt": 30810,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30810"
        },
        {
            "postCodeInt": 30820,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30820"
        },
        {
            "postCodeInt": 30830,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30830"
        },
        {
            "postCodeInt": 30840,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30840"
        },
        {
            "postCodeInt": 30900,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30900"
        },
        {
            "postCodeInt": 30902,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30902"
        },
        {
            "postCodeInt": 30904,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30904"
        },
        {
            "postCodeInt": 30906,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30906"
        },
        {
            "postCodeInt": 30908,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30908"
        },
        {
            "postCodeInt": 30910,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30910"
        },
        {
            "postCodeInt": 30912,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30912"
        },
        {
            "postCodeInt": 30988,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30988"
        },
        {
            "postCodeInt": 30990,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "30990"
        },
        {
            "postCodeInt": 31000,
            "cityName": "BATU GAJAH",
            "stateCode": "08",
            "postCode": "31000"
        },
        {
            "postCodeInt": 31007,
            "cityName": "BATU GAJAH",
            "stateCode": "08",
            "postCode": "31007"
        },
        {
            "postCodeInt": 31009,
            "cityName": "BATU GAJAH",
            "stateCode": "08",
            "postCode": "31009"
        },
        {
            "postCodeInt": 31050,
            "cityName": "SUNGAI SIPUT",
            "stateCode": "08",
            "postCode": "31050"
        },
        {
            "postCodeInt": 31100,
            "cityName": "SUNGAI SIPUT",
            "stateCode": "08",
            "postCode": "31100"
        },
        {
            "postCodeInt": 31150,
            "cityName": "ULU KINTA",
            "stateCode": "08",
            "postCode": "31150"
        },
        {
            "postCodeInt": 31200,
            "cityName": "CHEMOR",
            "stateCode": "08",
            "postCode": "31200"
        },
        {
            "postCodeInt": 31250,
            "cityName": "TANJONG RAMBUTAN",
            "stateCode": "08",
            "postCode": "31250"
        },
        {
            "postCodeInt": 31300,
            "cityName": "KAMPONG KEPAYANG",
            "stateCode": "08",
            "postCode": "31300"
        },
        {
            "postCodeInt": 31350,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "31350"
        },
        {
            "postCodeInt": 31400,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "31400"
        },
        {
            "postCodeInt": 31407,
            "cityName": "TAMAN IPOH",
            "stateCode": "08",
            "postCode": "31407"
        },
        {
            "postCodeInt": 31409,
            "cityName": "TAMAN IPOH",
            "stateCode": "08",
            "postCode": "31409"
        },
        {
            "postCodeInt": 31450,
            "cityName": "MENGLEMBU",
            "stateCode": "08",
            "postCode": "31450"
        },
        {
            "postCodeInt": 31500,
            "cityName": "LAHAT",
            "stateCode": "08",
            "postCode": "31500"
        },
        {
            "postCodeInt": 31550,
            "cityName": "PUSING",
            "stateCode": "08",
            "postCode": "31550"
        },
        {
            "postCodeInt": 31560,
            "cityName": "PUSING",
            "stateCode": "08",
            "postCode": "31560"
        },
        {
            "postCodeInt": 31600,
            "cityName": "GOPENG",
            "stateCode": "08",
            "postCode": "31600"
        },
        {
            "postCodeInt": 31610,
            "cityName": "GOPENG",
            "stateCode": "08",
            "postCode": "31610"
        },
        {
            "postCodeInt": 31650,
            "cityName": "IPOH",
            "stateCode": "08",
            "postCode": "31650"
        },
        {
            "postCodeInt": 31700,
            "cityName": "MALIM NAWAR",
            "stateCode": "08",
            "postCode": "31700"
        },
        {
            "postCodeInt": 31750,
            "cityName": "TRONOH",
            "stateCode": "08",
            "postCode": "31750"
        },
        {
            "postCodeInt": 31800,
            "cityName": "TANJONG TUALANG",
            "stateCode": "08",
            "postCode": "31800"
        },
        {
            "postCodeInt": 31850,
            "cityName": "JERAM",
            "stateCode": "08",
            "postCode": "31850"
        },
        {
            "postCodeInt": 31900,
            "cityName": "KAMPAR",
            "stateCode": "08",
            "postCode": "31900"
        },
        {
            "postCodeInt": 31907,
            "cityName": "KAMPAR",
            "stateCode": "08",
            "postCode": "31907"
        },
        {
            "postCodeInt": 31909,
            "cityName": "KAMPAR",
            "stateCode": "08",
            "postCode": "31909"
        },
        {
            "postCodeInt": 31910,
            "cityName": "KAMPAR",
            "stateCode": "08",
            "postCode": "31910"
        },
        {
            "postCodeInt": 31920,
            "cityName": "KAMPAR",
            "stateCode": "08",
            "postCode": "31920"
        },
        {
            "postCodeInt": 31950,
            "cityName": "MAMBANG DI AWAN",
            "stateCode": "08",
            "postCode": "31950"
        },
        {
            "postCodeInt": 32000,
            "cityName": "SITIAWAN",
            "stateCode": "08",
            "postCode": "32000"
        },
        {
            "postCodeInt": 32040,
            "cityName": "SERI MANJONG",
            "stateCode": "08",
            "postCode": "32040"
        },
        {
            "postCodeInt": 32100,
            "cityName": "LUMUT",
            "stateCode": "08",
            "postCode": "32100"
        },
        {
            "postCodeInt": 32200,
            "cityName": "LUMUT",
            "stateCode": "08",
            "postCode": "32200"
        },
        {
            "postCodeInt": 32300,
            "cityName": "PANGKOR",
            "stateCode": "08",
            "postCode": "32300"
        },
        {
            "postCodeInt": 32400,
            "cityName": "AYER TAWAR",
            "stateCode": "08",
            "postCode": "32400"
        },
        {
            "postCodeInt": 32500,
            "cityName": "CHANGKAT KERUING",
            "stateCode": "08",
            "postCode": "32500"
        },
        {
            "postCodeInt": 32600,
            "cityName": "BOTA",
            "stateCode": "08",
            "postCode": "32600"
        },
        {
            "postCodeInt": 32610,
            "cityName": "BANDAR SERI ISKANDAR",
            "stateCode": "08",
            "postCode": "32610"
        },
        {
            "postCodeInt": 32700,
            "cityName": "BRUAS",
            "stateCode": "08",
            "postCode": "32700"
        },
        {
            "postCodeInt": 32800,
            "cityName": "PARIT",
            "stateCode": "08",
            "postCode": "32800"
        },
        {
            "postCodeInt": 32900,
            "cityName": "LAMBOR KANAN",
            "stateCode": "08",
            "postCode": "32900"
        },
        {
            "postCodeInt": 33000,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33000"
        },
        {
            "postCodeInt": 33007,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33007"
        },
        {
            "postCodeInt": 33009,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33009"
        },
        {
            "postCodeInt": 33010,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33010"
        },
        {
            "postCodeInt": 33020,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33020"
        },
        {
            "postCodeInt": 33030,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33030"
        },
        {
            "postCodeInt": 33040,
            "cityName": "KUALA KANGSAR",
            "stateCode": "08",
            "postCode": "33040"
        },
        {
            "postCodeInt": 33100,
            "cityName": "PENGKALAN HULU",
            "stateCode": "08",
            "postCode": "33100"
        },
        {
            "postCodeInt": 33200,
            "cityName": "INTAN",
            "stateCode": "08",
            "postCode": "33200"
        },
        {
            "postCodeInt": 33300,
            "cityName": "GERIK",
            "stateCode": "08",
            "postCode": "33300"
        },
        {
            "postCodeInt": 33310,
            "cityName": "GERIK",
            "stateCode": "08",
            "postCode": "33310"
        },
        {
            "postCodeInt": 33320,
            "cityName": "GERIK",
            "stateCode": "08",
            "postCode": "33320"
        },
        {
            "postCodeInt": 33400,
            "cityName": "LENGGONG",
            "stateCode": "08",
            "postCode": "33400"
        },
        {
            "postCodeInt": 33410,
            "cityName": "LENGGONG",
            "stateCode": "08",
            "postCode": "33410"
        },
        {
            "postCodeInt": 33420,
            "cityName": "LENGGONG",
            "stateCode": "08",
            "postCode": "33420"
        },
        {
            "postCodeInt": 33500,
            "cityName": "SAUK",
            "stateCode": "08",
            "postCode": "33500"
        },
        {
            "postCodeInt": 33600,
            "cityName": "ENGGOR",
            "stateCode": "08",
            "postCode": "33600"
        },
        {
            "postCodeInt": 33700,
            "cityName": "PADANG RENGAS",
            "stateCode": "08",
            "postCode": "33700"
        },
        {
            "postCodeInt": 33800,
            "cityName": "MANONG",
            "stateCode": "08",
            "postCode": "33800"
        },
        {
            "postCodeInt": 34000,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34000"
        },
        {
            "postCodeInt": 34007,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34007"
        },
        {
            "postCodeInt": 34008,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34008"
        },
        {
            "postCodeInt": 34009,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34009"
        },
        {
            "postCodeInt": 34010,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34010"
        },
        {
            "postCodeInt": 34020,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34020"
        },
        {
            "postCodeInt": 34030,
            "cityName": "TAIPING",
            "stateCode": "08",
            "postCode": "34030"
        },
        {
            "postCodeInt": 34100,
            "cityName": "SELAMA",
            "stateCode": "08",
            "postCode": "34100"
        },
        {
            "postCodeInt": 34120,
            "cityName": "FELDA IJOK",
            "stateCode": "08",
            "postCode": "34120"
        },
        {
            "postCodeInt": 34130,
            "cityName": "SELAMA",
            "stateCode": "08",
            "postCode": "34130"
        },
        {
            "postCodeInt": 34140,
            "cityName": "RANTAU PANJANG",
            "stateCode": "08",
            "postCode": "34140"
        },
        {
            "postCodeInt": 34200,
            "cityName": "PARIT BUNTAR",
            "stateCode": "08",
            "postCode": "34200"
        },
        {
            "postCodeInt": 34250,
            "cityName": "TANJONG PIANDANG",
            "stateCode": "08",
            "postCode": "34250"
        },
        {
            "postCodeInt": 34300,
            "cityName": "BAGAN SERAI",
            "stateCode": "08",
            "postCode": "34300"
        },
        {
            "postCodeInt": 34310,
            "cityName": "BAGAN SERAI",
            "stateCode": "08",
            "postCode": "34310"
        },
        {
            "postCodeInt": 34350,
            "cityName": "KUALA KURAU",
            "stateCode": "08",
            "postCode": "34350"
        },
        {
            "postCodeInt": 34400,
            "cityName": "SIMPANG AMPAT SEMANGGOL",
            "stateCode": "08",
            "postCode": "34400"
        },
        {
            "postCodeInt": 34500,
            "cityName": "BATU KURAU",
            "stateCode": "08",
            "postCode": "34500"
        },
        {
            "postCodeInt": 34510,
            "cityName": "BATU KURAU",
            "stateCode": "08",
            "postCode": "34510"
        },
        {
            "postCodeInt": 34520,
            "cityName": "BATU KURAU",
            "stateCode": "08",
            "postCode": "34520"
        },
        {
            "postCodeInt": 34600,
            "cityName": "KAMUNTING",
            "stateCode": "08",
            "postCode": "34600"
        },
        {
            "postCodeInt": 34650,
            "cityName": "KUALA SEPETANG",
            "stateCode": "08",
            "postCode": "34650"
        },
        {
            "postCodeInt": 34700,
            "cityName": "SIMPANG",
            "stateCode": "08",
            "postCode": "34700"
        },
        {
            "postCodeInt": 34750,
            "cityName": "MATANG",
            "stateCode": "08",
            "postCode": "34750"
        },
        {
            "postCodeInt": 34800,
            "cityName": "TRONG",
            "stateCode": "08",
            "postCode": "34800"
        },
        {
            "postCodeInt": 34850,
            "cityName": "CHANGKAT JERING",
            "stateCode": "08",
            "postCode": "34850"
        },
        {
            "postCodeInt": 34900,
            "cityName": "PANTAI REMIS",
            "stateCode": "08",
            "postCode": "34900"
        }
    ]
}

export default CityMaster